// // /* eslint-disable jsx-a11y/label-has-associated-control */
// // import React, { useState, useEffect, useCallback, useRef } from 'react';
// // import ReactDOM from 'react-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { useLocation } from 'react-router-dom';

// // import {
// //   MdShoppingCart,
// //   MdClose,
// //   MdChevronLeft,
// //   MdChevronRight,
// //   MdMoreHoriz,
// //   MdCheckCircle,
// //   MdOutlineError,
// // } from 'react-icons/md';
// // import { IoGitPullRequestSharp } from 'react-icons/io5';
// // import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
// // import * as Yup from 'yup';
// // import PropTypes from 'prop-types';

// // // import { Scope } from '@unform/core';
// // import { toast } from 'react-toastify';
// // // import history from '../../services/history';
// // import { AppError } from '../../errors/AppError';

// // import { Form, Row, Column } from '../Form';
// // import SelectInput from '../Form/Input/Select';
// // import Input from '../Form/Input';

// // import {
// //   adicionaCarrinhoArrayRequest,
// //   adicionaCarrinhoRequest,
// //   atualizaItemOSRequest,
// // } from '../../store/modules/cart/actions';

// // import { Info } from '../Info';

// // import {
// //   CartModal,
// //   Content,
// //   WrapperItemOS,
// //   SubtitleItemOS,
// //   WrapperUpdatePN,
// //   ButtonUpdatePN,
// // } from './styles';
// // // import InputViewer from '../Form/Input/Viewer';
// // // import { Table } from '../../pages/Home/Carrinho/styles';
// // import {
// //   bloqueiaPartnumberAnteriores,
// //   criaItemOSSisma,
// //   limitaQtdMax,
// //   limitaQtdMin,
// //   limiteItemQtdZero,
// //   permitePartnumberAnteriores,
// //   qtdItemInic0,
// //   removeERPHome,
// //   solicitaAtualizacaoPartnumber,
// //   usaAgenteCausa,
// //   usaMotivoFalha,
// //   usaSecaoTrab,
// //   utilizaConjunto,
// // } from '../../lib/paramUtils';
// // import api from '../../services/api';
// // import ImagePreviewModal from '../prototipoImagemPeca';
// // import ModalCriarConjunto from '../ModalCriarConjunto';
// // import {
// //   ADD_TO_CART,
// //   CLEAR_ALL,
// //   CREATE_SET_KIT,
// //   HEADER_TABLE_ITENS_QTD,
// //   MARK_ALL,
// //   NO_ERP_CODE_RELATED_TO_MATERIAL,
// //   NON_ORIGINAL_MATERIALS_WARNING,
// //   opIdiomaCatalogo,
// // } from '../../lib/idiomaAppOptions';
// // // import cdiNoPhotoAvailable from '../../assets/cdi-no-photo-available.png';
// // // import mep001 from '../../assets/mep/001.jpeg';
// // // import mep002 from '../../assets/mep/002.jpeg';
// // // import mep003 from '../../assets/mep/003.jpeg';
// // // import mep004 from '../../assets/mep/004.jpeg';
// // // import mep005 from '../../assets/mep/005.jpeg';
// // // import mep006 from '../../assets/mep/006.jpeg';

// // /** margem mínima entre o modal e as bordas da tela */
// // const MARGEM_TELA = 12;

// // // function ItemCart({ containerRef, item, onClose }) {
// // /**
// //  * containerRef permanece na assinatura por compatibilidade com as chamadas
// //  * existentes, mas não é mais usado para posicionar o modal: com o portal e
// //  * position: fixed a referência passou a ser a própria viewport.
// //  */
// // // eslint-disable-next-line no-unused-vars
// // function ItemCart({ containerRef, item, itensPagina, onClose }) {
// //   const modalRef = useRef();
// //   const formRef = useRef();

// //   const location = useLocation();
// //   const dispatch = useDispatch();

// //   /**
// //    * O modal é renderizado em um portal no document.body (mesmo padrão do
// //    * HoverImagePortal) e usa position: fixed. Assim fica disponível na tela
// //    * inteira e não é recortado pelo bloco da imagem (ZoomArea/Wrapper), que
// //    * possui overflow: hidden.
// //    */
// //   const [portalContainer, setPortalContainer] = useState(null);

// //   const [left, setLeft] = useState(0);
// //   const [top, setTop] = useState(0);

// //   /** evita o "salto" visual antes de medir e centralizar o modal */
// //   const [posicionado, setPosicionado] = useState(false);
// //   // const [move, setMove] = useState(false);

// //   const [motivoFalha, setMotivoFalha] = useState([]);
// //   const [agenteCausa, setAgenteCausa] = useState([]);
// //   const [secaoTrab, setSecaoTrab] = useState([]);
// //   const [sistema, setSistema] = useState([]);
// //   const [local, setLocal] = useState([]);

// //   const [sistemaSelecionado, setSistemaSelecionado] = useState(null);
// //   const [localSelecionado, setLocalSelecionado] = useState(null);

// //   const [partnumberSelecionado, setPartnumberSelecionado] = useState(null);

// //   const [itensConjuntoSelecionados, setItensConjuntoSelecionados] = useState(
// //     []
// //   );

// //   const [modalUpdatePN, setModalUpdatePN] = useState(false);
// //   const [novoPartnumber, setNovoPartnumber] = useState('');

// //   /** modal de criação de conjunto/kit (somente ADM = 4) */
// //   const [criarConjuntoAberto, setCriarConjuntoAberto] = useState(false);

// //   const [partnumbersMaterial, setPartnumbersMaterial] = useState([]);

// //   const [listImg, setListImg] = useState([]);

// //   //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
// //   const idiomaCatalogo = useSelector(
// //     (state) => state.param.idiomaCatalogo || null
// //   );

// //   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

// //   const itensOS = useSelector((state) => {
// //     const { cart } = state;
// //     const {
// //       order: { extItemOS },
// //     } = cart || {};

// //     return extItemOS;
// //   });

// //   const profile = useSelector((state) => {
// //     const { userId, adm, empresa } = state.user.profile || {};
// //     const { idEmpresa } = empresa || {};

// //     return { userId, adm, idEmpresa };
// //   });

// //   /** ADM = 4 pode criar conjunto/kit pela Home */
// //   const podeCriarConjunto = String(profile.adm) === '2' && utilizaConjunto();

// //   /**
// //    * Parâmetro global 35 (REMOVE_ERP_HOME): oculta o Código ERP do material na
// //    * Home. Com o parâmetro ativo, a seleção de "Código ERP" e as informações de
// //    * material ERP não são exibidas e o material é resolvido automaticamente
// //    * (primeiro material relacionado ao item, quando existir).
// //    */
// //   const ocultaERPHome = removeERPHome();

// //   const paramQuery = new URLSearchParams(location.search);

// //   const paramRoute = {
// //     ...Object.fromEntries(paramQuery),
// //   };

// //   const idCatalogoLocation = location.pathname.split('/').pop();
// //   const idPaginaLocation = paramRoute.IDP;

// //   useEffect(() => {
// //     const { quantidade, materialEmpresa } = item || { quantidade: 0 };

// //     const { ERP } = paramRoute;

// //     const materialEmpresaURL = ERP
// //       ? materialEmpresa.filter((e) => e.codimate === ERP)
// //       : [];

// //     /** com o parâmetro 35 ativo o campo de Código ERP não é renderizado */
// //     if (
// //       !ocultaERPHome &&
// //       (materialEmpresa.length === 1 || materialEmpresaURL.length === 1)
// //     ) {
// //       const selectedOption = {
// //         value: (materialEmpresaURL[0] || materialEmpresa[0]).codimate,
// //         label: `${(materialEmpresaURL[0] || materialEmpresa[0]).codimate} - ${
// //           (materialEmpresaURL[0] || materialEmpresa[0]).descricao
// //         }`,
// //         color:
// //           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
// //             ? '#2c405a'
// //             : '#de3b3b',
// //         fontStyle:
// //           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
// //             ? 'normal'
// //             : 'italic',
// //       };
// //       formRef.current.setFieldValue('materialEmpresa', selectedOption);
// //     }

// //     if (qtdItemInic0()) {
// //       formRef.current.setFieldValue('quantidade', 0);
// //     } else {
// //       formRef.current.setFieldValue('quantidade', quantidade);
// //     }
// //   }, [item, location.search]);

// //   useEffect(() => {
// //     const itensConjunto = item?.itensConjuntoModal || [];

// //     setItensConjuntoSelecionados(
// //       itensConjunto.map((conjuntoItem) => ({
// //         ...conjuntoItem,
// //         // checked: false,
// //         checked: true,
// //         quantidade:
// //           qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
// //             ? 0
// //             : Number(conjuntoItem.quantidade || 1),
// //       }))
// //     );
// //   }, [item]);

// //   useEffect(() => {
// //     async function fetchData() {
// //       const responseMotivoFalha = await api
// //         .get(`/empresa/${profile.idEmpresa}/itemos/motivofalha`)
// //         .then((res) => res.data);
// //       setMotivoFalha(responseMotivoFalha);

// //       const responseAgenteCausa = await api
// //         .get(`/empresa/${profile.idEmpresa}/itemos/agentecausa`)
// //         .then((res) => res.data);
// //       setAgenteCausa(responseAgenteCausa);

// //       const responseSecaoTrab = await api
// //         .get(`/empresa/${profile.idEmpresa}/itemos/secaotrab`)
// //         .then((res) => res.data);
// //       setSecaoTrab(responseSecaoTrab);

// //       const responseSistema = await api
// //         .get(
// //           `/empresa/${profile.idEmpresa}/itemos/sistema/${Number(
// //             idCatalogoLocation
// //           )}/pagina/${Number(idPaginaLocation)}`,
// //           {
// //             params: {
// //               local: localSelecionado ? Number(localSelecionado.value) : null,
// //             },
// //           }
// //         )
// //         .then((res) => res.data);
// //       setSistema(responseSistema);

// //       const responseLocal = await api
// //         .get(
// //           `/empresa/${profile.idEmpresa}/itemos/local/${Number(
// //             idCatalogoLocation
// //           )}`,
// //           {
// //             params: {
// //               sistema: sistemaSelecionado
// //                 ? Number(sistemaSelecionado.value)
// //                 : null,
// //             },
// //           }
// //         )
// //         .then((res) => res.data);
// //       setLocal(responseLocal);
// //     }

// //     if (criaItemOSSisma()) {
// //       fetchData();
// //     } else {
// //       setAgenteCausa([{ codiAgente: 0 }]);
// //       setMotivoFalha([{ codiMofa: 0 }]);
// //       setSecaoTrab([{ codiSetr: 0 }]);
// //       setSistema([{ codiSist: 0 }]);
// //       setLocal([{ codiLoca: 0 }]);
// //     }
// //   }, [
// //     sistemaSelecionado,
// //     localSelecionado,
// //     idCatalogoLocation,
// //     profile.idEmpresa,
// //     idPaginaLocation,
// //   ]);

// //   const handleRelacPagSistLoc = useCallback(async () => {
// //     const relac = await api
// //       .get(
// //         `/empresa/${profile.idEmpresa}/catalogo/${idCatalogoLocation}/relacionamento-sistema-local/${idPaginaLocation}`
// //       )
// //       .then((res) => {
// //         const { relacPaginaSistLoc } =
// //           res.data.relacPaginaSistLoc.length > 0 && res.data;

// //         const fmtRelacPaginaSistLoc =
// //           relacPaginaSistLoc && relacPaginaSistLoc.pop();

// //         const output = fmtRelacPaginaSistLoc
// //           ? {
// //               composicaoEnabled: true,
// //               label: `${fmtRelacPaginaSistLoc.sistema?.codiSist} - ${fmtRelacPaginaSistLoc.sistema?.descricao}`,
// //               value: fmtRelacPaginaSistLoc.sistema?.codiSist,
// //             }
// //           : null;

// //         return output;
// //       });

// //     return relac;
// //   }, [
// //     idCatalogoLocation,
// //     idPaginaLocation,
// //     profile.idEmpresa,
// //     location.search,
// //   ]);

// //   useEffect(() => {
// //     async function loadDefaultSistema() {
// //       const defaultValue = await handleRelacPagSistLoc();
// //       setSistemaSelecionado(defaultValue);
// //     }
// //     if (criaItemOSSisma()) loadDefaultSistema();
// //   }, [handleRelacPagSistLoc, location.search]);

// //   // useEffect(() => {
// //   //   const { ERP } = paramRoute;

// //   //   if (ERP) {
// //   //     paramQuery.delete('ERP');
// //   //     history.replace({
// //   //       pathname: location.pathname,
// //   //       search: `?${paramQuery.toString()}`,
// //   //     });
// //   //   }
// //   // }, [location.search, location.pathname]);

// //   /**
// //    * Não limpamos o ERP ao montar o modal.
// //    * O ERP precisa permanecer na URL até o ItemCart preencher o material correto.
// //    * A limpeza dos parâmetros temporários da busca (IDI/ERP) é feita no fechamento
// //    * do modal pelo componente da página.
// //    */

// //   // const montarItensCarrinho = useCallback(
// //   //   ({
// //   //     itemPrincipal,
// //   //     quantidadePrincipal,
// //   //     materialEmpresaPrincipal,
// //   //     imagemCatalogoPrincipal,
// //   //     itemOS,
// //   //     codiAgente,
// //   //     codiMofa,
// //   //     codiSetr,
// //   //     codiSist,
// //   //     codiLoca,
// //   //   }) => {
// //   //     const itensSelecionadosConjunto = itensConjuntoSelecionados
// //   //       .filter((conjuntoItem) => conjuntoItem.checked)
// //   //       .map((conjuntoItem) => ({
// //   //         idCatalogo: conjuntoItem.idCatalogo,
// //   //         idPagina: conjuntoItem.idPagina,
// //   //         idItem: conjuntoItem.idItem,
// //   //         idMaterial: conjuntoItem.idMaterial,
// //   //         quantidade: Number(conjuntoItem.quantidade || 1),
// //   //         materialEmpresa:
// //   //           conjuntoItem.materialEmpresa?.length === 1
// //   //             ? conjuntoItem.materialEmpresa[0].codimate
// //   //             : null,
// //   //         imagemCatalogo:
// //   //           conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
// //   //         itemOS,
// //   //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //   //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //   //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //   //         codiSist: criaItemOSSisma() ? codiSist : 0,
// //   //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //   //       }));

// //   //     const itemPrincipalFormatado = {
// //   //       idCatalogo: itemPrincipal.idCatalogo,
// //   //       idPagina: itemPrincipal.idPagina,
// //   //       idItem: itemPrincipal.idItem,
// //   //       idMaterial: itemPrincipal.idMaterial,
// //   //       quantidade: Number(quantidadePrincipal),
// //   //       materialEmpresa: materialEmpresaPrincipal,
// //   //       imagemCatalogo: imagemCatalogoPrincipal,
// //   //       itemOS,
// //   //       codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //   //       codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //   //       codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //   //       codiSist: criaItemOSSisma() ? codiSist : 0,
// //   //       codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //   //     };

// //   //     return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
// //   //   },
// //   //   [itensConjuntoSelecionados]
// //   // );

// //   const montarItensCarrinho = useCallback(
// //     ({
// //       itemPrincipal,
// //       partnumber,
// //       quantidadePrincipal,
// //       materialEmpresaPrincipal,
// //       imagemCatalogoPrincipal,
// //       itemOS,
// //       codiAgente,
// //       codiMofa,
// //       codiSetr,
// //       codiSist,
// //       codiLoca,
// //     }) => {
// //       const itensSelecionadosConjunto = itensConjuntoSelecionados
// //         .filter((conjuntoItem) => conjuntoItem.checked)
// //         .map((conjuntoItem) => ({
// //           idCatalogo: conjuntoItem.idCatalogo,
// //           idPagina: conjuntoItem.idPagina,
// //           idItem: conjuntoItem.idItem,
// //           idMaterial: conjuntoItem.idMaterial,
// //           partnumber: conjuntoItem.partnumber,
// //           quantidade: Number(conjuntoItem.quantidade || 1),
// //           codimate:
// //             conjuntoItem.materialEmpresa?.length === 1
// //               ? conjuntoItem.materialEmpresa[0].codimate
// //               : null,
// //           imagemCatalogo:
// //             conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
// //           itemOS,
// //           codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //           codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //           codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //           codiSist: criaItemOSSisma() ? codiSist : 0,
// //           codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //         }));

// //       const itemPrincipalFormatado = {
// //         idCatalogo: itemPrincipal.idCatalogo,
// //         idPagina: itemPrincipal.idPagina,
// //         idItem: itemPrincipal.idItem,
// //         idMaterial: itemPrincipal.idMaterial,
// //         partnumber: partnumber || itemPrincipal.partnumber,
// //         quantidade: Number(quantidadePrincipal),
// //         codimate: materialEmpresaPrincipal,
// //         imagemCatalogo: imagemCatalogoPrincipal,
// //         itemOS,
// //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //         codiSist: criaItemOSSisma() ? codiSist : 0,
// //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //       };

// //       return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
// //     },
// //     [itensConjuntoSelecionados]
// //   );

// //   const handleConfirmar = useCallback(
// //     async (data) => {
// //       try {
// //         /**
// //          * Com o parâmetro 35 (REMOVE_ERP_HOME) ativo o campo de Código ERP não
// //          * é exibido, portanto não há seleção de material a validar.
// //          */
// //         if (item.materialEmpresa.length > 0 && !ocultaERPHome) {
// //           const schema = Yup.object().shape({
// //             materialEmpresa: Yup.string().required('Selecione um material'),
// //           });

// //           await schema.validate(data, { abortEarly: false });
// //         }

// //         const {
// //           idCatalogo,
// //           idPagina,
// //           idItem,
// //           idMaterial,
// //           imagemCatalogo,
// //         } = item;

// //         const { quantidade, materialEmpresa, itemOS } = data;

// //         /**
// //          * Parâmetro 35: sem o campo de Código ERP na tela, usa o material
// //          * relacionado ao item (o primeiro, quando houver mais de um).
// //          */
// //         const materialEmpresaSelecionado = ocultaERPHome
// //           ? (item.materialEmpresa || [])[0]?.codimate || null
// //           : materialEmpresa;

// //         if (limiteItemQtdZero().active) {
// //           if (
// //             Number(item.quantidade) === 0 &&
// //             Number(quantidade) > Number(limiteItemQtdZero().value)
// //           ) {
// //             window.confirm(
// //               `A quantidade não pode ser maior que ${
// //                 limiteItemQtdZero().value
// //               } para itens que o catálogo indique a quantidade 0`
// //             );
// //             return;
// //           }
// //         }

// //         if (limitaQtdMax().active && !limitaQtdMin().active) {
// //           if (Number(limitaQtdMax().value) === 1) {
// //             if (Number(quantidade) > Number(item.quantidade)) {
// //               window.confirm(
// //                 'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
// //               );
// //               return;
// //             }
// //           }
// //           if (Number(limitaQtdMax().value) === 2) {
// //             if (Number(quantidade) > Number(item.quantidade)) {
// //               window.confirm(
// //                 'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
// //               );
// //             }
// //           }
// //         }

// //         if (limitaQtdMin().active && !limitaQtdMax().active) {
// //           if (Number(limitaQtdMin().value) === 1) {
// //             if (Number(quantidade) < Number(item.quantidade)) {
// //               window.confirm(
// //                 'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
// //               );
// //               return;
// //             }
// //           }
// //           if (Number(limitaQtdMin().value) === 2) {
// //             if (Number(quantidade) < Number(item.quantidade)) {
// //               window.confirm(
// //                 'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
// //               );
// //             }
// //           }
// //         }

// //         if (limitaQtdMin().active && limitaQtdMax().active) {
// //           if (
// //             Number(limitaQtdMax().value) === 1 &&
// //             Number(limitaQtdMin().value) === 1
// //           ) {
// //             if (Number(quantidade) !== Number(item.quantidade)) {
// //               window.confirm(
// //                 'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
// //               );
// //               return;
// //             }
// //           }
// //           if (
// //             Number(limitaQtdMax().value) === 2 &&
// //             Number(limitaQtdMin().value) === 2
// //           ) {
// //             if (Number(quantidade) !== Number(item.quantidade)) {
// //               window.confirm(
// //                 'A quantidade esta diferente da estabelecida no catálogo'
// //               );
// //             }
// //           }
// //         }

// //         const objAgenteCausa = agenteCausa[agenteCausa.length - 1] || {};
// //         const objMotivoFalha = motivoFalha[motivoFalha.length - 1] || {};
// //         const objSecaoTrab = secaoTrab[secaoTrab.length - 1] || {};

// //         const { codiAgente = 0 } = objAgenteCausa;
// //         const { codiMofa = 0 } = objMotivoFalha;
// //         const { codiSetr = 0 } = objSecaoTrab;

// //         const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
// //         const codiLoca = localSelecionado ? localSelecionado.value : 0;

// //         console.log(partnumberSelecionado);
// //         console.log(item);

// //         const partnumber =
// //           partnumberSelecionado !== null
// //             ? partnumberSelecionado.value
// //             : item.partnumber;

// //         //* ********************************************************* */

// //         // dispatch(
// //         //   adicionaCarrinhoRequest(
// //         //     idCatalogo,
// //         //     idPagina,
// //         //     idItem,
// //         //     idMaterial,
// //         //     Number(quantidade),
// //         //     materialEmpresa,
// //         //     imagemCatalogo,
// //         //     itemOS,
// //         //     criaItemOSSisma() ? codiAgente : 0,
// //         //     criaItemOSSisma() ? codiMofa : 0,
// //         //     criaItemOSSisma() ? codiSetr : 0,
// //         //     criaItemOSSisma() ? codiSist : 0,
// //         //     criaItemOSSisma() ? codiLoca : 0
// //         //   )
// //         // );

// //         // itensConjuntoSelecionados
// //         //   .filter((conjuntoItem) => conjuntoItem.checked)
// //         //   .forEach((conjuntoItem) => {
// //         //     dispatch(
// //         //       adicionaCarrinhoRequest(
// //         //         conjuntoItem.idCatalogo,
// //         //         conjuntoItem.idPagina,
// //         //         conjuntoItem.idItem,
// //         //         conjuntoItem.idMaterial,
// //         //         Number(conjuntoItem.quantidade || 1),
// //         //         conjuntoItem.materialEmpresa?.length === 1
// //         //           ? conjuntoItem.materialEmpresa[0].codimate
// //         //           : null,
// //         //         conjuntoItem.imagemCatalogo || imagemCatalogo,
// //         //         itemOS,
// //         //         criaItemOSSisma() ? codiAgente : 0,
// //         //         criaItemOSSisma() ? codiMofa : 0,
// //         //         criaItemOSSisma() ? codiSetr : 0,
// //         //         criaItemOSSisma() ? codiSist : 0,
// //         //         criaItemOSSisma() ? codiLoca : 0
// //         //       )
// //         //     );
// //         //   });

// //         //* ********************************************************* */

// //         // const itensParaAdicionar = montarItensCarrinho({
// //         //   itemPrincipal: item,
// //         //   quantidadePrincipal: quantidade,
// //         //   materialEmpresaPrincipal: materialEmpresa,
// //         //   imagemCatalogoPrincipal: imagemCatalogo,
// //         //   itemOS,
// //         //   codiAgente,
// //         //   codiMofa,
// //         //   codiSetr,
// //         //   codiSist,
// //         //   codiLoca,
// //         // });

// //         // dispatch(adicionaCarrinhoRequest(itensParaAdicionar));

// //         //* ********************************************************* */

// //         const itensParaAdicionar = montarItensCarrinho({
// //           itemPrincipal: item,
// //           partnumber,
// //           quantidadePrincipal: quantidade,
// //           materialEmpresaPrincipal: materialEmpresaSelecionado,
// //           imagemCatalogoPrincipal: imagemCatalogo,
// //           itemOS,
// //           codiAgente,
// //           codiMofa,
// //           codiSetr,
// //           codiSist,
// //           codiLoca,
// //         });

// //         if (itensParaAdicionar.length === 1) {
// //           const itemUnico = itensParaAdicionar[0];

// //           dispatch(
// //             adicionaCarrinhoRequest(
// //               itemUnico.idCatalogo,
// //               itemUnico.idPagina,
// //               itemUnico.idItem,
// //               itemUnico.idMaterial,
// //               itemUnico.partnumber,
// //               itemUnico.quantidade,
// //               itemUnico.codimate,
// //               itemUnico.imagemCatalogo,
// //               itemUnico.itemOS,
// //               itemUnico.codiAgente,
// //               itemUnico.codiMofa,
// //               itemUnico.codiSetr,
// //               itemUnico.codiSist,
// //               itemUnico.codiLoca
// //             )
// //           );
// //         } else {
// //           dispatch(
// //             adicionaCarrinhoArrayRequest(
// //               itensParaAdicionar[0].idCatalogo,
// //               itensParaAdicionar
// //             )
// //           );
// //         }

// //         onClose(data);
// //       } catch (err) {
// //         AppError(err, formRef);
// //       }
// //     },
// //     [
// //       item,
// //       dispatch,
// //       onClose,
// //       sistemaSelecionado,
// //       localSelecionado,
// //       partnumberSelecionado,
// //       agenteCausa,
// //       motivoFalha,
// //       secaoTrab,
// //       itensConjuntoSelecionados,
// //       ocultaERPHome,
// //     ]
// //   );

// //   const handleAdicionar = useCallback(() => {
// //     const quantidade = Number(formRef.current.getFieldValue('quantidade'));
// //     formRef.current.setFieldValue('quantidade', quantidade + 1);
// //   }, []);

// //   const handleRemover = useCallback(() => {
// //     const quantidade = Number(formRef.current.getFieldValue('quantidade'));

// //     if (quantidade > 1) {
// //       formRef.current.setFieldValue('quantidade', quantidade - 1);
// //     }
// //   }, []);

// //   /**
// //    * Arraste em coordenadas da viewport (clientX/clientY), coerente com o
// //    * position: fixed do modal, e limitado à área visível para que ele nunca
// //    * seja arrastado para fora do alcance do usuário.
// //    *
// //    * Usa Pointer Events para funcionar com mouse e com toque (tablet) —
// //    * antes eram apenas eventos de mouse, que não disparam durante o
// //    * arraste por toque.
// //    */
// //   const handleMouseMove = useCallback((e) => {
// //     if (!modalRef.current) return;

// //     const { width, height } = modalRef.current.getBoundingClientRect();

// //     const maxLeft = Math.max(
// //       MARGEM_TELA,
// //       window.innerWidth - width - MARGEM_TELA
// //     );
// //     const maxTop = Math.max(
// //       MARGEM_TELA,
// //       window.innerHeight - height - MARGEM_TELA
// //     );

// //     setLeft(Math.min(Math.max(MARGEM_TELA, e.clientX - width / 2), maxLeft));
// //     setTop(Math.min(Math.max(MARGEM_TELA, e.clientY - 5), maxTop));

// //     e.stopPropagation();
// //     e.preventDefault();
// //   }, []);

// //   const handleMouseUp = useCallback(
// //     (e) => {
// //       document.removeEventListener('pointermove', handleMouseMove);
// //       document.removeEventListener('pointerup', handleMouseUp);
// //       document.removeEventListener('pointercancel', handleMouseUp);

// //       e.stopPropagation();
// //       e.preventDefault();
// //     },
// //     [handleMouseMove]
// //   );

// //   const handleMouseDown = useCallback(
// //     (e) => {
// //       document.addEventListener('pointermove', handleMouseMove);
// //       document.addEventListener('pointerup', handleMouseUp);
// //       document.addEventListener('pointercancel', handleMouseUp);

// //       e.stopPropagation();
// //       e.preventDefault();
// //     },
// //     [handleMouseMove, handleMouseUp]
// //   );

// //   /** cria/remove o nó do portal */
// //   useEffect(() => {
// //     const container = document.createElement('div');
// //     document.body.appendChild(container);
// //     setPortalContainer(container);

// //     return () => {
// //       document.removeEventListener('pointermove', handleMouseMove);
// //       document.removeEventListener('pointerup', handleMouseUp);
// //       document.removeEventListener('pointercancel', handleMouseUp);

// //       document.body.removeChild(container);
// //     };
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   /**
// //    * Centraliza o modal na tela ao abrir. Depois disso a posição é do
// //    * usuário (arraste), por isso o efeito não observa o item selecionado.
// //    */
// //   useEffect(() => {
// //     if (!portalContainer || !modalRef.current) return;

// //     const { width, height } = modalRef.current.getBoundingClientRect();

// //     setLeft(Math.max(MARGEM_TELA, Math.round((window.innerWidth - width) / 2)));
// //     setTop(
// //       Math.max(MARGEM_TELA, Math.round((window.innerHeight - height) / 2))
// //     );
// //     setPosicionado(true);
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [portalContainer]);

// //   /** mantém o modal dentro da tela ao redimensionar / rotacionar o tablet */
// //   useEffect(() => {
// //     const handleResize = () => {
// //       if (!modalRef.current) return;

// //       const { width, height } = modalRef.current.getBoundingClientRect();

// //       setLeft((state) =>
// //         Math.min(
// //           Math.max(MARGEM_TELA, state),
// //           Math.max(MARGEM_TELA, window.innerWidth - width - MARGEM_TELA)
// //         )
// //       );
// //       setTop((state) =>
// //         Math.min(
// //           Math.max(MARGEM_TELA, state),
// //           Math.max(MARGEM_TELA, window.innerHeight - height - MARGEM_TELA)
// //         )
// //       );
// //     };

// //     window.addEventListener('resize', handleResize);

// //     return () => window.removeEventListener('resize', handleResize);
// //   }, []);

// //   // const handleSelecionado = useCallback(
// //   //   ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
// //   //     const codimate = materialEmpresa ? materialEmpresa.codimate : null;

// //   //     dispatch(
// //   //       atualizaItemOSRequest(
// //   //         idCatalogo,
// //   //         idPagina,
// //   //         idItem,
// //   //         idMaterial,
// //   //         value,
// //   //         codimate
// //   //       )
// //   //     );
// //   //   },
// //   //   [dispatch]
// //   // );

// //   const handleSelecionado = useCallback(
// //     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
// //       const codimate = Array.isArray(materialEmpresa)
// //         ? materialEmpresa[0]?.codimate || null
// //         : materialEmpresa?.codimate || null;

// //       dispatch(
// //         atualizaItemOSRequest(
// //           idCatalogo,
// //           idPagina,
// //           idItem,
// //           idMaterial,
// //           value,
// //           codimate
// //         )
// //       );
// //     },
// //     [dispatch]
// //   );

// //   useEffect(() => {
// //     if (local.length === 1 && !localSelecionado) {
// //       const selectedOption = {
// //         value: local[0].codiLoca,
// //         label: `${local[0].codiLoca} - ${local[0].descricao}`,
// //         color: '#2c405a',
// //       };
// //       setLocalSelecionado(selectedOption);
// //       formRef.current.setFieldValue('local', selectedOption);
// //     }
// //   }, [local, localSelecionado]);

// //   const handleToggleItemConjunto = useCallback((idItem, idMaterial) => {
// //     setItensConjuntoSelecionados((state) =>
// //       state.map((conjuntoItem) =>
// //         String(conjuntoItem.idItem) === String(idItem) &&
// //         Number(conjuntoItem.idMaterial) === Number(idMaterial)
// //           ? { ...conjuntoItem, checked: !conjuntoItem.checked }
// //           : conjuntoItem
// //       )
// //     );
// //   }, []);

// //   const handleQuantidadeItemConjunto = useCallback(
// //     (idItem, idMaterial, valor) => {
// //       setItensConjuntoSelecionados((state) =>
// //         state.map((conjuntoItem) => {
// //           if (
// //             String(conjuntoItem.idItem) !== String(idItem) ||
// //             Number(conjuntoItem.idMaterial) !== Number(idMaterial)
// //           ) {
// //             return conjuntoItem;
// //           }

// //           const quantidadeNormalizada = Number(valor);

// //           return {
// //             ...conjuntoItem,
// //             quantidade:
// //               Number.isNaN(quantidadeNormalizada) || quantidadeNormalizada < 0
// //                 ? 0
// //                 : quantidadeNormalizada,
// //           };
// //         })
// //       );
// //     },
// //     []
// //   );

// //   const handleToggleTodosItensConjunto = useCallback(() => {
// //     setItensConjuntoSelecionados((state) => {
// //       const todosMarcados =
// //         state.length > 0 && state.every((conjuntoItem) => conjuntoItem.checked);

// //       return state.map((conjuntoItem) => ({
// //         ...conjuntoItem,
// //         checked: !todosMarcados,
// //       }));
// //     });
// //   }, []);

// //   // useEffect(() => {
// //   //   if (!utilizaConjunto()) return;

// //   //   const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

// //   //   if (!idItemReferencia) return;

// //   //   if (String(item.idItem) === String(idItemReferencia)) return;

// //   //   const input = itensPagina.find(
// //   //     (i) => String(i.idItem) === String(idItemReferencia)
// //   //   );

// //   //   if (!input) return;

// //   //   setItensConjuntoSelecionados((prev) => {
// //   //     const listaSemItemClicado = prev.filter(
// //   //       (i) => String(i.idItem) !== String(item.idItem)
// //   //     );

// //   //     const jaExiste = listaSemItemClicado.some(
// //   //       (i) => String(i.idItem) === String(input.idItem)
// //   //     );

// //   //     if (jaExiste) return listaSemItemClicado;

// //   //     return [
// //   //       {
// //   //         ...input,
// //   //         checked: false,
// //   //         quantidade:
// //   //           qtdItemInic0() && Number(input.quantidade) !== 0
// //   //             ? 0
// //   //             : Number(input.quantidade || 1),
// //   //       },
// //   //       ...listaSemItemClicado,
// //   //     ];
// //   //   });
// //   // }, [item, itensPagina]);

// //   const normalizaQuantidadeConjunto = useCallback(
// //     (conjuntoItem) =>
// //       qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
// //         ? 0
// //         : Number(conjuntoItem.quantidade || 1),
// //     []
// //   );

// //   const normalizaLevaItemOri = useCallback(
// //     (valor) => valor === true || valor === 1 || valor === '1',
// //     []
// //   );

// //   // useEffect(() => {
// //   //   if (!item) {
// //   //     setItensConjuntoSelecionados([]);
// //   //     return;
// //   //   }

// //   //   const itemClicadoId = String(item.idItem);
// //   //   const itemClicadoMaterial = Number(item.idMaterial);

// //   //   let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
// //   //     ...conjuntoItem,
// //   //     checked: false,
// //   //     quantidade: normalizaQuantidadeConjunto(conjuntoItem),
// //   //   }));

// //   //   listaConjunto = listaConjunto.filter(
// //   //     (conjuntoItem) =>
// //   //       !(
// //   //         String(conjuntoItem.idItem) === itemClicadoId &&
// //   //         Number(conjuntoItem.idMaterial) === itemClicadoMaterial
// //   //       )
// //   //   );

// //   //   if (utilizaConjunto()) {
// //   //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

// //   //     // const deveLevarItemOrigem =
// //   //     //   item?.conjuntoReferencia?.levaItemOri === true ||
// //   //     //   item?.conjuntoReferencia?.levaItemOri === 1 ||
// //   //     //   item?.conjuntoReferencia?.levaItemOri === '1';

// //   //     const deveLevarItemOrigem = normalizaLevaItemOri(
// //   //       item?.conjuntoReferencia?.levaItemOri
// //   //     );

// //   //     const itemClicadoEhReferencia =
// //   //       idItemReferencia && String(idItemReferencia) === itemClicadoId;

// //   //     if (deveLevarItemOrigem && idItemReferencia && !itemClicadoEhReferencia) {
// //   //       const itemReferencia = itensPagina.find(
// //   //         (i) => String(i.idItem) === String(idItemReferencia)
// //   //       );

// //   //       if (itemReferencia) {
// //   //         const referenciaJaExiste = listaConjunto.some(
// //   //           (conjuntoItem) =>
// //   //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
// //   //             Number(conjuntoItem.idMaterial) ===
// //   //               Number(itemReferencia.idMaterial)
// //   //         );

// //   //         if (!referenciaJaExiste) {
// //   //           listaConjunto = [
// //   //             {
// //   //               ...itemReferencia,
// //   //               checked: false,
// //   //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
// //   //             },
// //   //             ...listaConjunto,
// //   //           ];
// //   //         }
// //   //       }
// //   //     }
// //   //   }

// //   //   setItensConjuntoSelecionados(listaConjunto);
// //   // }, [item, itensPagina, normalizaQuantidadeConjunto]);

// //   useEffect(() => {
// //     if (!item) {
// //       setItensConjuntoSelecionados([]);
// //       return;
// //     }

// //     const itemClicadoId = String(item.idItem);
// //     const itemClicadoMaterial = Number(item.idMaterial);

// //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;
// //     const idMaterialReferencia = item?.conjuntoReferencia?.idMaterialOri;

// //     const deveLevarItemOrigem = normalizaLevaItemOri(
// //       item?.conjuntoReferencia?.levaItemOri
// //     );

// //     const itemClicadoEhReferencia =
// //       idItemReferencia &&
// //       String(idItemReferencia) === itemClicadoId &&
// //       Number(idMaterialReferencia) === itemClicadoMaterial;

// //     /**
// //      * REGRA NOVA:
// //      * Se levaItemOri for false/0/'0' e o item clicado não for a origem,
// //      * o modal deve exibir somente o item clicado.
// //      */
// //     if (
// //       item.conjuntoReferencia &&
// //       !deveLevarItemOrigem &&
// //       !itemClicadoEhReferencia
// //     ) {
// //       setItensConjuntoSelecionados([]);
// //       return;
// //     }

// //     let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
// //       ...conjuntoItem,
// //       checked: false,
// //       quantidade: normalizaQuantidadeConjunto(conjuntoItem),
// //     }));

// //     listaConjunto = listaConjunto.filter(
// //       (conjuntoItem) =>
// //         !(
// //           String(conjuntoItem.idItem) === itemClicadoId &&
// //           Number(conjuntoItem.idMaterial) === itemClicadoMaterial
// //         )
// //     );

// //     if (
// //       utilizaConjunto() &&
// //       deveLevarItemOrigem &&
// //       idItemReferencia &&
// //       !itemClicadoEhReferencia
// //     ) {
// //       const itemReferencia = itensPagina.find(
// //         (i) =>
// //           String(i.idItem) === String(idItemReferencia) &&
// //           Number(i.idMaterial) === Number(idMaterialReferencia)
// //       );

// //       if (itemReferencia) {
// //         const referenciaJaExiste = listaConjunto.some(
// //           (conjuntoItem) =>
// //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
// //             Number(conjuntoItem.idMaterial) ===
// //               Number(itemReferencia.idMaterial)
// //         );

// //         if (!referenciaJaExiste) {
// //           listaConjunto = [
// //             {
// //               ...itemReferencia,
// //               checked: false,
// //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
// //             },
// //             ...listaConjunto,
// //           ];
// //         }
// //       }
// //     }

// //     setItensConjuntoSelecionados(listaConjunto);
// //   }, [item, itensPagina, normalizaQuantidadeConjunto, normalizaLevaItemOri]);

// //   const todosItensConjuntoMarcados =
// //     itensConjuntoSelecionados.length > 0 &&
// //     itensConjuntoSelecionados.every((conjuntoItem) => conjuntoItem.checked);

// //   const handleSolicitaAtualizacaoPN = useCallback(() => {
// //     setNovoPartnumber('');
// //     setModalUpdatePN(true);
// //   }, []);

// //   const handleConfirmUpdatePN = useCallback(async () => {
// //     const partnumber = String(novoPartnumber || '').trim();

// //     // console.log(profile);
// //     // console.log(item);

// //     const { idEmpresa } = profile;

// //     if (!partnumber) {
// //       toast.error('Informe o novo partnumber');
// //       return;
// //     }

// //     await api.post(`empresa/${idEmpresa}/update-pn`, {
// //       idMaterial: Number(item.idMaterial),
// //       novoPartnumber: partnumber,
// //     });

// //     toast.success('Solicitação de atualização enviada com sucesso');
// //     setModalUpdatePN(false);
// //     setNovoPartnumber('');
// //   }, [novoPartnumber]);

// //   useEffect(() => {
// //     const { idEmpresa } = profile;

// //     api
// //       .get(`empresa/${idEmpresa}/${item.idMaterial}/update-pn`)
// //       .then((response) => setPartnumbersMaterial(response.data.updatePN));
// //   }, [item]);

// //   const handleListImages = useCallback(() => {
// //     const { idEmpresa } = profile;
// //     const { idCatalogo, idPagina, idItem, idMaterial } = item;

// //     api
// //       .get(
// //         `/empresa/${idEmpresa}/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/material/${idMaterial}/imagens`
// //       )
// //       .then((response) => setListImg(response.data.imagens))
// //       .catch(() => {
// //         setListImg([]);
// //         toast.error('Não foi possível carregar a imagem');
// //       });
// //   }, [item]);

// //   useEffect(() => {
// //     handleListImages();
// //   }, [item]);

// //   if (!portalContainer) return null;

// //   return ReactDOM.createPortal(
// //     <>
// //       <CartModal
// //         ref={modalRef}
// //         top={top}
// //         left={left}
// //         posicionado={posicionado ? 1 : 0}
// //       >
// //         <Content>
// //           <Content.Move onPointerDown={handleMouseDown}>
// //             <MdMoreHoriz size={24} />
// //           </Content.Move>

// //           <Content.BtnClose type="button" onClick={() => onClose()}>
// //             <MdClose size={20} />
// //           </Content.BtnClose>

// //           <Content.Title>
// //             {/**
// //              *
// //             <strong>
// //               {item.descricao}
// //               {item.partnumber === '8C0143' && (
// //               {item.partnumber === 'AT458609' && ( // PRD 8C0143 QAS AT458609
// //                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
// //                 <ImagePreviewModal imagePaths={[mep001, mep002, mep003]} />
// //               )}
// //               {item.partnumber === '19M7865' && ( // PRD 5G0128 QAS 19M7865
// //                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
// //                 <ImagePreviewModal imagePaths={[mep004, mep005, mep006]} />
// //               )}
// //             </strong>
// //              */}
// //             <strong>
// //               {item.descricao}

// //               {listImg.length > 0 && (
// //                 <ImagePreviewModal
// //                   imagens={listImg}
// //                   idEmpresa={profile.idEmpresa}
// //                   idCatalogo={item.idCatalogo}
// //                   idPagina={item.idPagina}
// //                   idItem={item.idItem}
// //                   idMaterial={item.idMaterial}
// //                 />
// //               )}
// //             </strong>
// //             <div
// //               style={{
// //                 display: 'flex',
// //                 flexDirection: 'row',
// //                 justifyContent: 'flex-start',
// //                 alignItems: 'center',
// //                 width: '100%',
// //               }}
// //             >
// //               <span>{item.partnumber}</span>
// //               {solicitaAtualizacaoPartnumber() && (
// //                 <Row>
// //                   <ButtonUpdatePN
// //                     type="button"
// //                     onClick={handleSolicitaAtualizacaoPN}
// //                   >
// //                     <IoGitPullRequestSharp
// //                       size={20}
// //                       style={{ marginLeft: '5px' }}
// //                     />
// //                   </ButtonUpdatePN>
// //                 </Row>
// //               )}
// //             </div>

// //             {partnumbersMaterial && !permitePartnumberAnteriores() && (
// //               <Content.Title.Hist>
// //                 {partnumbersMaterial.map((pn, index) => {
// //                   if (partnumbersMaterial.length === index + 1)
// //                     return `${pn.partnumber}`;
// //                   return `${pn.partnumber}; `;
// //                 })}
// //               </Content.Title.Hist>
// //             )}

// //             {item.especTecnica && (
// //               <Content.Title.Espec>{item.especTecnica}</Content.Title.Espec>
// //             )}

// //             {(item.nota || item.especTecnica) && (
// //               <Info.Root rightIcon="0" topIcon="0">
// //                 {item.nota && (
// //                   <div>
// //                     <strong>Nota:</strong>
// //                     <span>{item.nota}</span>
// //                   </div>
// //                 )}
// //                 {item.especTecnica && (
// //                   <div>
// //                     <strong>Esp.Tec.:</strong>
// //                     <span>{item.especTecnica}</span>
// //                   </div>
// //                 )}
// //                 {!ocultaERPHome &&
// //                   item.materialEmpresa.map((material, index) => (
// //                     <div key={index}>
// //                       <strong>Material ERP:</strong>
// //                       <ul>
// //                         <li>{`${material.descricao || ' - '}`}</li>
// //                         <li>{`Cod.Mat: ${material.codimate || ' -'} | UN: ${
// //                           material.unidade || ' - '
// //                         } | Paralelo: ${
// //                           material.paralelo ? 'Sim' : 'Não'
// //                         }`}</li>
// //                       </ul>
// //                     </div>
// //                   ))}
// //               </Info.Root>
// //             )}
// //           </Content.Title>

// //           {/* {solicitaAtualizacaoPartnumber() && (
// //             <Row>
// //               <ButtonUpdatePN
// //                 type="button"
// //                 onClick={handleSolicitaAtualizacaoPN}
// //               >
// //                 <IoGitPullRequestSharp
// //                   size={20}
// //                   style={{ marginRight: '5px' }}
// //                 />
// //                 Solicitar Atualização de Partnumber
// //               </ButtonUpdatePN>
// //             </Row>
// //           )} */}

// //           <Row>
// //             {podeCriarConjunto && (
// //               <button
// //                 type="button"
// //                 onClick={() => setCriarConjuntoAberto(true)}
// //                 style={{
// //                   width: '100%',
// //                   padding: '10px 16px',
// //                   marginTop: '10px',
// //                   borderRadius: 12,
// //                   border: 'none',
// //                   background: '#1e3a8a',
// //                   color: '#fff',
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   cursor: 'pointer',
// //                 }}
// //               >
// //                 {CREATE_SET_KIT[idioma]}
// //               </button>
// //             )}
// //           </Row>

// //           <Content.Form>
// //             {item && (
// //               <Form id="formCart" ref={formRef} onSubmit={handleConfirmar}>
// //                 {!ocultaERPHome && (
// //                   <Column borderTop>
// //                     {item.materialEmpresa.length > 0 && (
// //                       <SelectInput
// //                         id="materialEmpresa"
// //                         name="materialEmpresa"
// //                         label="Código ERP"
// //                         isClearable
// //                         options={item.materialEmpresa.map((material) => ({
// //                           value: material.codimate,
// //                           label: `${material.codimate} - ${material.descricao}`,
// //                           color:
// //                             material.paralelo === '0' ? '#2c405a' : '#de3b3b',
// //                           fontStyle:
// //                             material.paralelo === '0' ? 'normal' : 'italic',
// //                         }))}
// //                         styles={{
// //                           option: (styles, { data }) => ({
// //                             ...styles,
// //                             color: data.color,
// //                             fontStyle: data.fontStyle,
// //                           }),
// //                         }}
// //                       />
// //                     )}
// //                     <Content.Form.Error>
// //                       {item.materialEmpresa.length > 0
// //                         ? NON_ORIGINAL_MATERIALS_WARNING[idioma]
// //                         : NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
// //                     </Content.Form.Error>
// //                   </Column>
// //                 )}

// //                 {partnumbersMaterial && permitePartnumberAnteriores() && (
// //                   <Column borderTop>
// //                     {item.materialEmpresa.length > 0 && (
// //                       <SelectInput
// //                         id="partnumbersMaterial"
// //                         name="partnumbersMaterial"
// //                         label="Partnumber"
// //                         isClearable
// //                         isSearchable
// //                         isDisabled={!partnumbersMaterial}
// //                         value={partnumberSelecionado}
// //                         placeholder="Selecione..."
// //                         options={partnumbersMaterial.map((pn) => ({
// //                           value: String(pn.partnumber),
// //                           label: `${pn.partnumber}`,
// //                         }))}
// //                         styles={{
// //                           option: (styles, { data }) => ({
// //                             ...styles,
// //                             color: data.color,
// //                             fontStyle: data.fontStyle,
// //                           }),
// //                         }}
// //                         onChange={(select) =>
// //                           setPartnumberSelecionado(
// //                             select
// //                               ? {
// //                                   label: String(select.label),
// //                                   value: String(select.value),
// //                                 }
// //                               : null
// //                           )
// //                         }
// //                       />
// //                     )}
// //                   </Column>
// //                 )}

// //                 {criaItemOSSisma() && (
// //                   <>
// //                     <WrapperItemOS>
// //                       {(usaMotivoFalha() ||
// //                         usaAgenteCausa() ||
// //                         usaSecaoTrab()) && (
// //                         <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
// //                           <SubtitleItemOS>Criação Item OS</SubtitleItemOS>
// //                         </Row>
// //                       )}

// //                       {(usaMotivoFalha() ||
// //                         usaAgenteCausa() ||
// //                         usaSecaoTrab()) && (
// //                         <Row>
// //                           {usaMotivoFalha() && (
// //                             <SelectInput
// //                               id="motivoFalha"
// //                               name="motivoFalha"
// //                               label="Motivo Falha"
// //                               width={200}
// //                               isSearchable
// //                               placeholder="Selecione..."
// //                               options={motivoFalha.map((m) => ({
// //                                 value: m.codiMofa,
// //                                 label: m.descricao,
// //                               }))}
// //                             />
// //                           )}

// //                           {usaAgenteCausa() && (
// //                             <SelectInput
// //                               id="agenteCausa"
// //                               name="agenteCausa"
// //                               label="Agente Causa"
// //                               width={200}
// //                               isSearchable
// //                               placeholder="Selecione..."
// //                               options={agenteCausa.map((a) => ({
// //                                 value: a.codiAgente,
// //                                 label: a.descricao,
// //                               }))}
// //                             />
// //                           )}

// //                           {usaSecaoTrab() && (
// //                             <SelectInput
// //                               id="secaoTrab"
// //                               name="secaoTrab"
// //                               label="Seção Trabalho"
// //                               width={200}
// //                               isSearchable
// //                               placeholder="Selecione..."
// //                               options={secaoTrab.map((s) => ({
// //                                 value: s.codiSetr,
// //                                 label: s.descrResum,
// //                               }))}
// //                             />
// //                           )}
// //                         </Row>
// //                       )}

// //                       <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
// //                         <SubtitleItemOS>Composição</SubtitleItemOS>
// //                       </Row>

// //                       <Row>
// //                         <SelectInput
// //                           id="sistema"
// //                           name="sistema"
// //                           label="Sistema"
// //                           width={300}
// //                           isSearchable
// //                           isDisabled={sistemaSelecionado}
// //                           placeholder="Selecione..."
// //                           value={sistemaSelecionado}
// //                           options={sistema.map((s) => ({
// //                             value: s.codiSist,
// //                             label: `${s.codiSist} - ${s.descricao}`,
// //                             composicaoEnabled: s.composicaoEnabled,
// //                             color:
// //                               s.composicaoEnabled === true
// //                                 ? '#334155'
// //                                 : '#64748b',
// //                             fontWeight:
// //                               s.composicaoEnabled === true
// //                                 ? 'bolder'
// //                                 : 'lighter',
// //                           }))}
// //                           styles={{
// //                             option: (styles, { data }) => ({
// //                               ...styles,
// //                               backgroundColor: data.backgroundColor,
// //                               color: data.color,
// //                               fontWeight: data.fontWeight,
// //                             }),
// //                           }}
// //                           onChange={(select) => {
// //                             setSistemaSelecionado({
// //                               composicaoEnabled: select.composicaoEnabled,
// //                               label: select.label,
// //                               value: select.value,
// //                             });
// //                           }}
// //                         />

// //                         <SelectInput
// //                           id="local"
// //                           name="local"
// //                           label="Local"
// //                           width={300}
// //                           isSearchable
// //                           isDisabled={!sistemaSelecionado}
// //                           value={localSelecionado}
// //                           placeholder="Selecione..."
// //                           options={local.map((l) => ({
// //                             value: l.codiLoca,
// //                             label: `${l.codiLoca} - ${l.descricao}`,
// //                             composicaoEnabled: l.composicaoEnabled,
// //                             color:
// //                               l.composicaoEnabled === true
// //                                 ? '#334155'
// //                                 : '#64748b',
// //                             fontWeight:
// //                               l.composicaoEnabled === true
// //                                 ? 'bolder'
// //                                 : 'lighter',
// //                           }))}
// //                           styles={{
// //                             option: (styles, { data }) => ({
// //                               ...styles,
// //                               backgroundColor: data.backgroundColor,
// //                               color: data.color,
// //                               fontWeight: data.fontWeight,
// //                             }),
// //                           }}
// //                           onChange={(select) =>
// //                             setLocalSelecionado({
// //                               composicaoEnabled: select.composicaoEnabled,
// //                               label: select.label,
// //                               value: select.value,
// //                             })
// //                           }
// //                         />
// //                       </Row>
// //                     </WrapperItemOS>
// //                   </>
// //                 )}

// //                 {itensOS.length > 0 && !criaItemOSSisma() && (
// //                   <Row>
// //                     <SelectInput
// //                       id="itemOS"
// //                       name="itemOS"
// //                       label="Item O.S."
// //                       width={335}
// //                       isSearchable
// //                       options={itensOS.map((i) => ({
// //                         value: i.value,
// //                         label: i.label,
// //                       }))}
// //                       defaultValue={{
// //                         value: itensOS[0].value,
// //                         label: itensOS[0].label,
// //                       }}
// //                       onChange={(select) =>
// //                         handleSelecionado(
// //                           select,
// //                           item.idCatalogo,
// //                           item.idPagina,
// //                           item.idItem,
// //                           item.idMaterial,
// //                           item.materialEmpresa
// //                         )
// //                       }
// //                     />
// //                   </Row>
// //                 )}

// //                 <Row>
// //                   <Content.Form.Quantity>
// //                     <label htmlFor="quantidade">
// //                       {HEADER_TABLE_ITENS_QTD[idioma]}
// //                     </label>
// //                     <div>
// //                       <button type="button" onClick={handleRemover}>
// //                         <MdChevronLeft size={25} />
// //                       </button>

// //                       <Input
// //                         id="quantidade"
// //                         name="quantidade"
// //                         flexDirection="row"
// //                         type="number"
// //                         min="1"
// //                         max="9999999.9999"
// //                         width={80}
// //                       />

// //                       <button type="button" onClick={handleAdicionar}>
// //                         <MdChevronRight size={25} />
// //                       </button>
// //                     </div>
// //                   </Content.Form.Quantity>
// //                 </Row>

// //                 {/* {solicitaAtualizacaoPartnumber() && (
// //                   <Row>
// //                     <button
// //                       type="button"
// //                       onClick={handleSolicitaAtualizacaoPN}
// //                       style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         width: '100%',
// //                         padding: '10px',
// //                         margin: '10px auto',
// //                         border: 'none',
// //                         background: '#64748b',
// //                         color: '#f8fafc',
// //                         borderRadius: '5px',
// //                       }}
// //                     >
// //                       <IoGitPullRequestSharp
// //                         size={20}
// //                         style={{ marginRight: '5px' }}
// //                       />
// //                       Solicitar Atualização de Partnumber
// //                     </button>
// //                   </Row>
// //                 )} */}

// //                 {utilizaConjunto() && !!itensConjuntoSelecionados.length && (
// //                   <Row style={{ marginTop: 16 }}>
// //                     <div style={{ width: '100%' }}>
// //                       <div
// //                         style={{
// //                           display: 'flex',
// //                           justifyContent: 'space-between',
// //                           alignItems: 'center',
// //                           marginBottom: 10,
// //                         }}
// //                       >
// //                         <label
// //                           style={{
// //                             display: 'block',
// //                             fontWeight: 600,
// //                             marginBottom: 0,
// //                           }}
// //                         >
// //                           Kit sugerido
// //                         </label>

// //                         <button
// //                           type="button"
// //                           onClick={handleToggleTodosItensConjunto}
// //                           style={{
// //                             background: 'transparent',
// //                             border: 'none',
// //                             color: '#2563eb',
// //                             cursor: 'pointer',
// //                             fontWeight: 600,
// //                             fontSize: 13,
// //                             padding: 0,
// //                           }}
// //                         >
// //                           {todosItensConjuntoMarcados
// //                             ? CLEAR_ALL[idioma]
// //                             : MARK_ALL[idioma]}
// //                         </button>
// //                       </div>

// //                       <div
// //                         style={{
// //                           maxHeight: 240,
// //                           overflowY: 'auto',
// //                           border: '1px solid #dbe1e9',
// //                           borderRadius: 8,
// //                           padding: 10,
// //                           background: '#fff',
// //                         }}
// //                       >
// //                         {itensConjuntoSelecionados.map((conjuntoItem) => (
// //                           <div
// //                             key={`${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
// //                             style={{
// //                               display: 'flex',
// //                               alignItems: 'center',
// //                               gap: 12,
// //                               padding: '10px 0',
// //                               borderBottom: '1px solid #eef2f7',
// //                               opacity: conjuntoItem.checked ? 1 : 0.45,
// //                               transition: 'opacity 0.2s ease',
// //                             }}
// //                           >
// //                             <input
// //                               type="checkbox"
// //                               checked={conjuntoItem.checked}
// //                               onChange={() =>
// //                                 handleToggleItemConjunto(
// //                                   conjuntoItem.idItem,
// //                                   conjuntoItem.idMaterial
// //                                 )
// //                               }
// //                             />

// //                             <div style={{ flex: 1, minWidth: 0 }}>
// //                               <div style={{ fontWeight: 600 }}>
// //                                 {conjuntoItem.itemResum || conjuntoItem.idItem}{' '}
// //                                 - {conjuntoItem.partnumber}
// //                               </div>
// //                               <div
// //                                 style={{
// //                                   fontSize: 13,
// //                                   color: '#64748b',
// //                                   marginTop: 2,
// //                                 }}
// //                               >
// //                                 {conjuntoItem.descricao}
// //                               </div>
// //                             </div>

// //                             <div
// //                               style={{
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: 8,
// //                               }}
// //                             >
// //                               <label
// //                                 htmlFor={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
// //                                 style={{ fontSize: 13 }}
// //                               >
// //                                 Qtd.
// //                               </label>

// //                               <input
// //                                 id={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
// //                                 type="number"
// //                                 min="0"
// //                                 value={conjuntoItem.quantidade}
// //                                 disabled={!conjuntoItem.checked}
// //                                 onChange={(e) =>
// //                                   handleQuantidadeItemConjunto(
// //                                     conjuntoItem.idItem,
// //                                     conjuntoItem.idMaterial,
// //                                     e.target.value
// //                                   )
// //                                 }
// //                                 style={{
// //                                   width: 50,
// //                                   height: 34,
// //                                   border: '1px solid #cbd5e1',
// //                                   borderRadius: 6,
// //                                   padding: '0 8px',
// //                                 }}
// //                               />
// //                             </div>
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   </Row>
// //                 )}
// //               </Form>
// //             )}

// //             <Content.BtnAddCart type="submit" form="formCart">
// //               <MdShoppingCart size={20} /> {ADD_TO_CART[idioma]}
// //             </Content.BtnAddCart>

// //             {/* {podeCriarConjunto && (
// //               <button
// //                 type="button"
// //                 onClick={() => setCriarConjuntoAberto(true)}
// //                 style={{
// //                   marginTop: 8,
// //                   width: '100%',
// //                   padding: '10px 16px',
// //                   borderRadius: 6,
// //                   border: 'none',
// //                   background: '#1789dd',
// //                   color: '#fff',
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   cursor: 'pointer',
// //                 }}
// //               >
// //                 {CREATE_SET_KIT[idioma]}
// //               </button>
// //             )} */}
// //           </Content.Form>
// //         </Content>

// //         {criarConjuntoAberto && (
// //           <ModalCriarConjunto
// //             item={item}
// //             itensPagina={itensPagina}
// //             onClose={() => setCriarConjuntoAberto(false)}
// //           />
// //         )}
// //       </CartModal>

// //       {/* {modalUpdatePN && (
// //         <CartModal>
// //           <Content>
// //             <Content.BtnClose
// //               type="button"
// //               onClick={() => setModalUpdatePN(false)}
// //             >
// //               <MdClose size={20} />
// //             </Content.BtnClose>
// //             <Content.Title>
// //               <strong>Atualização de Partnumber</strong>
// //             </Content.Title>
// //             <WrapperUpdatePN>
// //               <p>Partnumber Atual:</p>
// //               <h4>{item.partnumber}</h4>
// //               <p>Solicitar Atualização Para:</p>
// //               <input placeholder="Novo Partnumber" />
// //             </WrapperUpdatePN>
// //           </Content>
// //         </CartModal>
// //       )} */}

// //       {modalUpdatePN && (
// //         <CartModal centered={1}>
// //           <Content>
// //             <Content.BtnClose
// //               type="button"
// //               onClick={() => setModalUpdatePN(false)}
// //             >
// //               <MdClose size={20} />
// //             </Content.BtnClose>

// //             <Content.Title>
// //               <strong>Atualização de Partnumber</strong>
// //             </Content.Title>

// //             <WrapperUpdatePN>
// //               <div className="current-box">
// //                 <span>Partnumber atual</span>
// //                 <strong>{item.partnumber}</strong>
// //               </div>

// //               <div className="form-group">
// //                 <label htmlFor="new-partnumber">
// //                   Solicitar atualização para
// //                 </label>

// //                 {/* <input
// //                   id="new-partnumber"
// //                   type="text"
// //                   placeholder="Digite o novo partnumber"
// //                 /> */}
// //                 <input
// //                   id="new-partnumber"
// //                   type="text"
// //                   placeholder="Digite o novo partnumber"
// //                   value={novoPartnumber}
// //                   onChange={(e) => setNovoPartnumber(e.target.value)}
// //                 />
// //               </div>

// //               <div className="actions">
// //                 <button
// //                   type="button"
// //                   className="cancel"
// //                   onClick={() => setModalUpdatePN(false)}
// //                 >
// //                   Cancelar
// //                 </button>

// //                 <button
// //                   type="button"
// //                   onClick={() => handleConfirmUpdatePN(novoPartnumber)}
// //                 >
// //                   Solicitar atualização
// //                 </button>
// //               </div>
// //             </WrapperUpdatePN>
// //           </Content>
// //         </CartModal>
// //       )}
// //     </>,
// //     portalContainer
// //   );
// // }

// // export default ItemCart;

// // /* eslint-disable jsx-a11y/label-has-associated-control */
// // import React, { useState, useEffect, useCallback, useRef } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { useLocation } from 'react-router-dom';

// // import {
// //   MdShoppingCart,
// //   MdClose,
// //   MdChevronLeft,
// //   MdChevronRight,
// //   MdMoreHoriz,
// //   MdCheckCircle,
// //   MdOutlineError,
// // } from 'react-icons/md';
// // import { IoGitPullRequestSharp } from 'react-icons/io5';
// // import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
// // import * as Yup from 'yup';
// // import PropTypes from 'prop-types';

// // // import { Scope } from '@unform/core';
// // import { toast } from 'react-toastify';
// // // import history from '../../services/history';
// // import { AppError } from '../../errors/AppError';

// // import { Form, Row, Column } from '../Form';
// // import SelectInput from '../Form/Input/Select';
// // import Input from '../Form/Input';

// // import {
// //   adicionaCarrinhoArrayRequest,
// //   adicionaCarrinhoRequest,
// //   atualizaItemOSRequest,
// // } from '../../store/modules/cart/actions';

// // import { Info } from '../Info';

// // import {
// //   CartModal,
// //   Content,
// //   WrapperItemOS,
// //   SubtitleItemOS,
// //   WrapperUpdatePN,
// //   ButtonUpdatePN,
// // } from './styles';
// // // import InputViewer from '../Form/Input/Viewer';
// // // import { Table } from '../../pages/Home/Carrinho/styles';
// // import {
// //   bloqueiaPartnumberAnteriores,
// //   criaItemOSSisma,
// //   limitaQtdMax,
// //   limitaQtdMin,
// //   limiteItemQtdZero,
// //   permitePartnumberAnteriores,
// //   qtdItemInic0,
// //   solicitaAtualizacaoPartnumber,
// //   usaAgenteCausa,
// //   usaMotivoFalha,
// //   usaSecaoTrab,
// //   utilizaConjunto,
// // } from '../../lib/paramUtils';
// // import api from '../../services/api';
// // import ImagePreviewModal from '../prototipoImagemPeca';
// // import ModalCriarConjunto from '../ModalCriarConjunto';
// // import {
// //   ADD_TO_CART,
// //   CLEAR_ALL,
// //   CREATE_SET_KIT,
// //   HEADER_TABLE_ITENS_QTD,
// //   MARK_ALL,
// //   NO_ERP_CODE_RELATED_TO_MATERIAL,
// //   NON_ORIGINAL_MATERIALS_WARNING,
// //   opIdiomaCatalogo,
// // } from '../../lib/idiomaAppOptions';
// // // import cdiNoPhotoAvailable from '../../assets/cdi-no-photo-available.png';
// // // import mep001 from '../../assets/mep/001.jpeg';
// // // import mep002 from '../../assets/mep/002.jpeg';
// // // import mep003 from '../../assets/mep/003.jpeg';
// // // import mep004 from '../../assets/mep/004.jpeg';
// // // import mep005 from '../../assets/mep/005.jpeg';
// // // import mep006 from '../../assets/mep/006.jpeg';

// // // function ItemCart({ containerRef, item, onClose }) {
// // function ItemCart({ containerRef, item, itensPagina, onClose }) {
// //   const modalRef = useRef();
// //   const formRef = useRef();

// //   const location = useLocation();
// //   const dispatch = useDispatch();

// //   const [left, setLeft] = useState(0);
// //   const [top, setTop] = useState(0);
// //   // const [move, setMove] = useState(false);

// //   const [motivoFalha, setMotivoFalha] = useState([]);
// //   const [agenteCausa, setAgenteCausa] = useState([]);
// //   const [secaoTrab, setSecaoTrab] = useState([]);
// //   const [sistema, setSistema] = useState([]);
// //   const [local, setLocal] = useState([]);

// //   const [sistemaSelecionado, setSistemaSelecionado] = useState(null);
// //   const [localSelecionado, setLocalSelecionado] = useState(null);

// //   const [partnumberSelecionado, setPartnumberSelecionado] = useState(null);

// //   const [itensConjuntoSelecionados, setItensConjuntoSelecionados] = useState(
// //     []
// //   );

// //   const [modalUpdatePN, setModalUpdatePN] = useState(false);
// //   const [novoPartnumber, setNovoPartnumber] = useState('');

// //   /** modal de criação de conjunto/kit (somente ADM = 4) */
// //   const [criarConjuntoAberto, setCriarConjuntoAberto] = useState(false);

// //   const [partnumbersMaterial, setPartnumbersMaterial] = useState([]);

// //   const [listImg, setListImg] = useState([]);

// //   //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
// //   const idiomaCatalogo = useSelector(
// //     (state) => state.param.idiomaCatalogo || null
// //   );

// //   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

// //   const itensOS = useSelector((state) => {
// //     const { cart } = state;
// //     const {
// //       order: { extItemOS },
// //     } = cart || {};

// //     return extItemOS;
// //   });

// //   const profile = useSelector((state) => {
// //     const { userId, adm, empresa } = state.user.profile || {};
// //     const { idEmpresa } = empresa || {};

// //     return { userId, adm, idEmpresa };
// //   });

// //   /** ADM = 4 pode criar conjunto/kit pela Home */
// //   const podeCriarConjunto = String(profile.adm) === '2' && utilizaConjunto();

// //   const paramQuery = new URLSearchParams(location.search);

// //   const paramRoute = {
// //     ...Object.fromEntries(paramQuery),
// //   };

// //   const idCatalogoLocation = location.pathname.split('/').pop();
// //   const idPaginaLocation = paramRoute.IDP;

// //   useEffect(() => {
// //     const { quantidade, materialEmpresa } = item || { quantidade: 0 };

// //     const { ERP } = paramRoute;

// //     const materialEmpresaURL = ERP
// //       ? materialEmpresa.filter((e) => e.codimate === ERP)
// //       : [];

// //     if (materialEmpresa.length === 1 || materialEmpresaURL.length === 1) {
// //       const selectedOption = {
// //         value: (materialEmpresaURL[0] || materialEmpresa[0]).codimate,
// //         label: `${(materialEmpresaURL[0] || materialEmpresa[0]).codimate} - ${
// //           (materialEmpresaURL[0] || materialEmpresa[0]).descricao
// //         }`,
// //         color:
// //           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
// //             ? '#2c405a'
// //             : '#de3b3b',
// //         fontStyle:
// //           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
// //             ? 'normal'
// //             : 'italic',
// //       };
// //       formRef.current.setFieldValue('materialEmpresa', selectedOption);
// //     }

// //     if (qtdItemInic0()) {
// //       formRef.current.setFieldValue('quantidade', 0);
// //     } else {
// //       formRef.current.setFieldValue('quantidade', quantidade);
// //     }
// //   }, [item, location.search]);

// //   useEffect(() => {
// //     const itensConjunto = item?.itensConjuntoModal || [];

// //     setItensConjuntoSelecionados(
// //       itensConjunto.map((conjuntoItem) => ({
// //         ...conjuntoItem,
// //         // checked: false,
// //         checked: true,
// //         quantidade:
// //           qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
// //             ? 0
// //             : Number(conjuntoItem.quantidade || 1),
// //       }))
// //     );
// //   }, [item]);

// //   useEffect(() => {
// //     async function fetchData() {
// //       const responseMotivoFalha = await api
// //         .get(`/empresa/${profile.idEmpresa}/itemos/motivofalha`)
// //         .then((res) => res.data);
// //       setMotivoFalha(responseMotivoFalha);

// //       const responseAgenteCausa = await api
// //         .get(`/empresa/${profile.idEmpresa}/itemos/agentecausa`)
// //         .then((res) => res.data);
// //       setAgenteCausa(responseAgenteCausa);

// //       const responseSecaoTrab = await api
// //         .get(`/empresa/${profile.idEmpresa}/itemos/secaotrab`)
// //         .then((res) => res.data);
// //       setSecaoTrab(responseSecaoTrab);

// //       const responseSistema = await api
// //         .get(
// //           `/empresa/${profile.idEmpresa}/itemos/sistema/${Number(
// //             idCatalogoLocation
// //           )}/pagina/${Number(idPaginaLocation)}`,
// //           {
// //             params: {
// //               local: localSelecionado ? Number(localSelecionado.value) : null,
// //             },
// //           }
// //         )
// //         .then((res) => res.data);
// //       setSistema(responseSistema);

// //       const responseLocal = await api
// //         .get(
// //           `/empresa/${profile.idEmpresa}/itemos/local/${Number(
// //             idCatalogoLocation
// //           )}`,
// //           {
// //             params: {
// //               sistema: sistemaSelecionado
// //                 ? Number(sistemaSelecionado.value)
// //                 : null,
// //             },
// //           }
// //         )
// //         .then((res) => res.data);
// //       setLocal(responseLocal);
// //     }

// //     if (criaItemOSSisma()) {
// //       fetchData();
// //     } else {
// //       setAgenteCausa([{ codiAgente: 0 }]);
// //       setMotivoFalha([{ codiMofa: 0 }]);
// //       setSecaoTrab([{ codiSetr: 0 }]);
// //       setSistema([{ codiSist: 0 }]);
// //       setLocal([{ codiLoca: 0 }]);
// //     }
// //   }, [
// //     sistemaSelecionado,
// //     localSelecionado,
// //     idCatalogoLocation,
// //     profile.idEmpresa,
// //     idPaginaLocation,
// //   ]);

// //   const handleRelacPagSistLoc = useCallback(async () => {
// //     const relac = await api
// //       .get(
// //         `/empresa/${profile.idEmpresa}/catalogo/${idCatalogoLocation}/relacionamento-sistema-local/${idPaginaLocation}`
// //       )
// //       .then((res) => {
// //         const { relacPaginaSistLoc } =
// //           res.data.relacPaginaSistLoc.length > 0 && res.data;

// //         const fmtRelacPaginaSistLoc =
// //           relacPaginaSistLoc && relacPaginaSistLoc.pop();

// //         const output = fmtRelacPaginaSistLoc
// //           ? {
// //               composicaoEnabled: true,
// //               label: `${fmtRelacPaginaSistLoc.sistema?.codiSist} - ${fmtRelacPaginaSistLoc.sistema?.descricao}`,
// //               value: fmtRelacPaginaSistLoc.sistema?.codiSist,
// //             }
// //           : null;

// //         return output;
// //       });

// //     return relac;
// //   }, [
// //     idCatalogoLocation,
// //     idPaginaLocation,
// //     profile.idEmpresa,
// //     location.search,
// //   ]);

// //   useEffect(() => {
// //     async function loadDefaultSistema() {
// //       const defaultValue = await handleRelacPagSistLoc();
// //       setSistemaSelecionado(defaultValue);
// //     }
// //     if (criaItemOSSisma()) loadDefaultSistema();
// //   }, [handleRelacPagSistLoc, location.search]);

// //   // useEffect(() => {
// //   //   const { ERP } = paramRoute;

// //   //   if (ERP) {
// //   //     paramQuery.delete('ERP');
// //   //     history.replace({
// //   //       pathname: location.pathname,
// //   //       search: `?${paramQuery.toString()}`,
// //   //     });
// //   //   }
// //   // }, [location.search, location.pathname]);

// //   /**
// //    * Não limpamos o ERP ao montar o modal.
// //    * O ERP precisa permanecer na URL até o ItemCart preencher o material correto.
// //    * A limpeza dos parâmetros temporários da busca (IDI/ERP) é feita no fechamento
// //    * do modal pelo componente da página.
// //    */

// //   // const montarItensCarrinho = useCallback(
// //   //   ({
// //   //     itemPrincipal,
// //   //     quantidadePrincipal,
// //   //     materialEmpresaPrincipal,
// //   //     imagemCatalogoPrincipal,
// //   //     itemOS,
// //   //     codiAgente,
// //   //     codiMofa,
// //   //     codiSetr,
// //   //     codiSist,
// //   //     codiLoca,
// //   //   }) => {
// //   //     const itensSelecionadosConjunto = itensConjuntoSelecionados
// //   //       .filter((conjuntoItem) => conjuntoItem.checked)
// //   //       .map((conjuntoItem) => ({
// //   //         idCatalogo: conjuntoItem.idCatalogo,
// //   //         idPagina: conjuntoItem.idPagina,
// //   //         idItem: conjuntoItem.idItem,
// //   //         idMaterial: conjuntoItem.idMaterial,
// //   //         quantidade: Number(conjuntoItem.quantidade || 1),
// //   //         materialEmpresa:
// //   //           conjuntoItem.materialEmpresa?.length === 1
// //   //             ? conjuntoItem.materialEmpresa[0].codimate
// //   //             : null,
// //   //         imagemCatalogo:
// //   //           conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
// //   //         itemOS,
// //   //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //   //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //   //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //   //         codiSist: criaItemOSSisma() ? codiSist : 0,
// //   //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //   //       }));

// //   //     const itemPrincipalFormatado = {
// //   //       idCatalogo: itemPrincipal.idCatalogo,
// //   //       idPagina: itemPrincipal.idPagina,
// //   //       idItem: itemPrincipal.idItem,
// //   //       idMaterial: itemPrincipal.idMaterial,
// //   //       quantidade: Number(quantidadePrincipal),
// //   //       materialEmpresa: materialEmpresaPrincipal,
// //   //       imagemCatalogo: imagemCatalogoPrincipal,
// //   //       itemOS,
// //   //       codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //   //       codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //   //       codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //   //       codiSist: criaItemOSSisma() ? codiSist : 0,
// //   //       codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //   //     };

// //   //     return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
// //   //   },
// //   //   [itensConjuntoSelecionados]
// //   // );

// //   const montarItensCarrinho = useCallback(
// //     ({
// //       itemPrincipal,
// //       partnumber,
// //       quantidadePrincipal,
// //       materialEmpresaPrincipal,
// //       imagemCatalogoPrincipal,
// //       itemOS,
// //       codiAgente,
// //       codiMofa,
// //       codiSetr,
// //       codiSist,
// //       codiLoca,
// //     }) => {
// //       const itensSelecionadosConjunto = itensConjuntoSelecionados
// //         .filter((conjuntoItem) => conjuntoItem.checked)
// //         .map((conjuntoItem) => ({
// //           idCatalogo: conjuntoItem.idCatalogo,
// //           idPagina: conjuntoItem.idPagina,
// //           idItem: conjuntoItem.idItem,
// //           idMaterial: conjuntoItem.idMaterial,
// //           partnumber: conjuntoItem.partnumber,
// //           quantidade: Number(conjuntoItem.quantidade || 1),
// //           codimate:
// //             conjuntoItem.materialEmpresa?.length === 1
// //               ? conjuntoItem.materialEmpresa[0].codimate
// //               : null,
// //           imagemCatalogo:
// //             conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
// //           itemOS,
// //           codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //           codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //           codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //           codiSist: criaItemOSSisma() ? codiSist : 0,
// //           codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //         }));

// //       const itemPrincipalFormatado = {
// //         idCatalogo: itemPrincipal.idCatalogo,
// //         idPagina: itemPrincipal.idPagina,
// //         idItem: itemPrincipal.idItem,
// //         idMaterial: itemPrincipal.idMaterial,
// //         partnumber: partnumber || itemPrincipal.partnumber,
// //         quantidade: Number(quantidadePrincipal),
// //         codimate: materialEmpresaPrincipal,
// //         imagemCatalogo: imagemCatalogoPrincipal,
// //         itemOS,
// //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
// //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
// //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
// //         codiSist: criaItemOSSisma() ? codiSist : 0,
// //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
// //       };

// //       return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
// //     },
// //     [itensConjuntoSelecionados]
// //   );

// //   const handleConfirmar = useCallback(
// //     async (data) => {
// //       try {
// //         if (item.materialEmpresa.length > 0) {
// //           const schema = Yup.object().shape({
// //             materialEmpresa: Yup.string().required('Selecione um material'),
// //           });

// //           await schema.validate(data, { abortEarly: false });
// //         }

// //         const {
// //           idCatalogo,
// //           idPagina,
// //           idItem,
// //           idMaterial,
// //           imagemCatalogo,
// //         } = item;

// //         const { quantidade, materialEmpresa, itemOS } = data;

// //         if (limiteItemQtdZero().active) {
// //           if (
// //             Number(item.quantidade) === 0 &&
// //             Number(quantidade) > Number(limiteItemQtdZero().value)
// //           ) {
// //             window.confirm(
// //               `A quantidade não pode ser maior que ${
// //                 limiteItemQtdZero().value
// //               } para itens que o catálogo indique a quantidade 0`
// //             );
// //             return;
// //           }
// //         }

// //         if (limitaQtdMax().active && !limitaQtdMin().active) {
// //           if (Number(limitaQtdMax().value) === 1) {
// //             if (Number(quantidade) > Number(item.quantidade)) {
// //               window.confirm(
// //                 'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
// //               );
// //               return;
// //             }
// //           }
// //           if (Number(limitaQtdMax().value) === 2) {
// //             if (Number(quantidade) > Number(item.quantidade)) {
// //               window.confirm(
// //                 'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
// //               );
// //             }
// //           }
// //         }

// //         if (limitaQtdMin().active && !limitaQtdMax().active) {
// //           if (Number(limitaQtdMin().value) === 1) {
// //             if (Number(quantidade) < Number(item.quantidade)) {
// //               window.confirm(
// //                 'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
// //               );
// //               return;
// //             }
// //           }
// //           if (Number(limitaQtdMin().value) === 2) {
// //             if (Number(quantidade) < Number(item.quantidade)) {
// //               window.confirm(
// //                 'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
// //               );
// //             }
// //           }
// //         }

// //         if (limitaQtdMin().active && limitaQtdMax().active) {
// //           if (
// //             Number(limitaQtdMax().value) === 1 &&
// //             Number(limitaQtdMin().value) === 1
// //           ) {
// //             if (Number(quantidade) !== Number(item.quantidade)) {
// //               window.confirm(
// //                 'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
// //               );
// //               return;
// //             }
// //           }
// //           if (
// //             Number(limitaQtdMax().value) === 2 &&
// //             Number(limitaQtdMin().value) === 2
// //           ) {
// //             if (Number(quantidade) !== Number(item.quantidade)) {
// //               window.confirm(
// //                 'A quantidade esta diferente da estabelecida no catálogo'
// //               );
// //             }
// //           }
// //         }

// //         const objAgenteCausa = agenteCausa[agenteCausa.length - 1] || {};
// //         const objMotivoFalha = motivoFalha[motivoFalha.length - 1] || {};
// //         const objSecaoTrab = secaoTrab[secaoTrab.length - 1] || {};

// //         const { codiAgente = 0 } = objAgenteCausa;
// //         const { codiMofa = 0 } = objMotivoFalha;
// //         const { codiSetr = 0 } = objSecaoTrab;

// //         const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
// //         const codiLoca = localSelecionado ? localSelecionado.value : 0;

// //         console.log(partnumberSelecionado);
// //         console.log(item);

// //         const partnumber =
// //           partnumberSelecionado !== null
// //             ? partnumberSelecionado.value
// //             : item.partnumber;

// //         //* ********************************************************* */

// //         // dispatch(
// //         //   adicionaCarrinhoRequest(
// //         //     idCatalogo,
// //         //     idPagina,
// //         //     idItem,
// //         //     idMaterial,
// //         //     Number(quantidade),
// //         //     materialEmpresa,
// //         //     imagemCatalogo,
// //         //     itemOS,
// //         //     criaItemOSSisma() ? codiAgente : 0,
// //         //     criaItemOSSisma() ? codiMofa : 0,
// //         //     criaItemOSSisma() ? codiSetr : 0,
// //         //     criaItemOSSisma() ? codiSist : 0,
// //         //     criaItemOSSisma() ? codiLoca : 0
// //         //   )
// //         // );

// //         // itensConjuntoSelecionados
// //         //   .filter((conjuntoItem) => conjuntoItem.checked)
// //         //   .forEach((conjuntoItem) => {
// //         //     dispatch(
// //         //       adicionaCarrinhoRequest(
// //         //         conjuntoItem.idCatalogo,
// //         //         conjuntoItem.idPagina,
// //         //         conjuntoItem.idItem,
// //         //         conjuntoItem.idMaterial,
// //         //         Number(conjuntoItem.quantidade || 1),
// //         //         conjuntoItem.materialEmpresa?.length === 1
// //         //           ? conjuntoItem.materialEmpresa[0].codimate
// //         //           : null,
// //         //         conjuntoItem.imagemCatalogo || imagemCatalogo,
// //         //         itemOS,
// //         //         criaItemOSSisma() ? codiAgente : 0,
// //         //         criaItemOSSisma() ? codiMofa : 0,
// //         //         criaItemOSSisma() ? codiSetr : 0,
// //         //         criaItemOSSisma() ? codiSist : 0,
// //         //         criaItemOSSisma() ? codiLoca : 0
// //         //       )
// //         //     );
// //         //   });

// //         //* ********************************************************* */

// //         // const itensParaAdicionar = montarItensCarrinho({
// //         //   itemPrincipal: item,
// //         //   quantidadePrincipal: quantidade,
// //         //   materialEmpresaPrincipal: materialEmpresa,
// //         //   imagemCatalogoPrincipal: imagemCatalogo,
// //         //   itemOS,
// //         //   codiAgente,
// //         //   codiMofa,
// //         //   codiSetr,
// //         //   codiSist,
// //         //   codiLoca,
// //         // });

// //         // dispatch(adicionaCarrinhoRequest(itensParaAdicionar));

// //         //* ********************************************************* */

// //         const itensParaAdicionar = montarItensCarrinho({
// //           itemPrincipal: item,
// //           partnumber,
// //           quantidadePrincipal: quantidade,
// //           materialEmpresaPrincipal: materialEmpresa,
// //           imagemCatalogoPrincipal: imagemCatalogo,
// //           itemOS,
// //           codiAgente,
// //           codiMofa,
// //           codiSetr,
// //           codiSist,
// //           codiLoca,
// //         });

// //         if (itensParaAdicionar.length === 1) {
// //           const itemUnico = itensParaAdicionar[0];

// //           dispatch(
// //             adicionaCarrinhoRequest(
// //               itemUnico.idCatalogo,
// //               itemUnico.idPagina,
// //               itemUnico.idItem,
// //               itemUnico.idMaterial,
// //               itemUnico.partnumber,
// //               itemUnico.quantidade,
// //               itemUnico.codimate,
// //               itemUnico.imagemCatalogo,
// //               itemUnico.itemOS,
// //               itemUnico.codiAgente,
// //               itemUnico.codiMofa,
// //               itemUnico.codiSetr,
// //               itemUnico.codiSist,
// //               itemUnico.codiLoca
// //             )
// //           );
// //         } else {
// //           dispatch(
// //             adicionaCarrinhoArrayRequest(
// //               itensParaAdicionar[0].idCatalogo,
// //               itensParaAdicionar
// //             )
// //           );
// //         }

// //         onClose(data);
// //       } catch (err) {
// //         AppError(err, formRef);
// //       }
// //     },
// //     [
// //       item,
// //       dispatch,
// //       onClose,
// //       sistemaSelecionado,
// //       localSelecionado,
// //       partnumberSelecionado,
// //       agenteCausa,
// //       motivoFalha,
// //       secaoTrab,
// //       itensConjuntoSelecionados,
// //     ]
// //   );

// //   const handleAdicionar = useCallback(() => {
// //     const quantidade = Number(formRef.current.getFieldValue('quantidade'));
// //     formRef.current.setFieldValue('quantidade', quantidade + 1);
// //   }, []);

// //   const handleRemover = useCallback(() => {
// //     const quantidade = Number(formRef.current.getFieldValue('quantidade'));

// //     if (quantidade > 1) {
// //       formRef.current.setFieldValue('quantidade', quantidade - 1);
// //     }
// //   }, []);

// //   const handleMouseMove = useCallback(
// //     (e) => {
// //       const {
// //         left: leftContainer,
// //         top: topContainer,
// //       } = containerRef.current.getBoundingClientRect();
// //       const { width } = modalRef.current.getBoundingClientRect();

// //       setLeft(e.pageX - leftContainer - width / 2);
// //       setTop(e.pageY - topContainer - 5);

// //       e.stopPropagation();
// //       e.preventDefault();
// //     },
// //     [containerRef]
// //   );

// //   const handleMouseUp = useCallback(
// //     (e) => {
// //       document.removeEventListener('mousemove', handleMouseMove);
// //       document.removeEventListener('mouseup', handleMouseUp);

// //       e.stopPropagation();
// //       e.preventDefault();
// //     },
// //     [handleMouseMove]
// //   );

// //   const handleMouseDown = useCallback(
// //     (e) => {
// //       document.addEventListener('mousemove', handleMouseMove);
// //       document.addEventListener('mouseup', handleMouseUp);

// //       e.stopPropagation();
// //       e.preventDefault();
// //     },
// //     [handleMouseMove, handleMouseUp]
// //   );

// //   // const handleSelecionado = useCallback(
// //   //   ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
// //   //     const codimate = materialEmpresa ? materialEmpresa.codimate : null;

// //   //     dispatch(
// //   //       atualizaItemOSRequest(
// //   //         idCatalogo,
// //   //         idPagina,
// //   //         idItem,
// //   //         idMaterial,
// //   //         value,
// //   //         codimate
// //   //       )
// //   //     );
// //   //   },
// //   //   [dispatch]
// //   // );

// //   const handleSelecionado = useCallback(
// //     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
// //       const codimate = Array.isArray(materialEmpresa)
// //         ? materialEmpresa[0]?.codimate || null
// //         : materialEmpresa?.codimate || null;

// //       dispatch(
// //         atualizaItemOSRequest(
// //           idCatalogo,
// //           idPagina,
// //           idItem,
// //           idMaterial,
// //           value,
// //           codimate
// //         )
// //       );
// //     },
// //     [dispatch]
// //   );

// //   useEffect(() => {
// //     if (local.length === 1 && !localSelecionado) {
// //       const selectedOption = {
// //         value: local[0].codiLoca,
// //         label: `${local[0].codiLoca} - ${local[0].descricao}`,
// //         color: '#2c405a',
// //       };
// //       setLocalSelecionado(selectedOption);
// //       formRef.current.setFieldValue('local', selectedOption);
// //     }
// //   }, [local, localSelecionado]);

// //   const handleToggleItemConjunto = useCallback((idItem, idMaterial) => {
// //     setItensConjuntoSelecionados((state) =>
// //       state.map((conjuntoItem) =>
// //         String(conjuntoItem.idItem) === String(idItem) &&
// //         Number(conjuntoItem.idMaterial) === Number(idMaterial)
// //           ? { ...conjuntoItem, checked: !conjuntoItem.checked }
// //           : conjuntoItem
// //       )
// //     );
// //   }, []);

// //   const handleQuantidadeItemConjunto = useCallback(
// //     (idItem, idMaterial, valor) => {
// //       setItensConjuntoSelecionados((state) =>
// //         state.map((conjuntoItem) => {
// //           if (
// //             String(conjuntoItem.idItem) !== String(idItem) ||
// //             Number(conjuntoItem.idMaterial) !== Number(idMaterial)
// //           ) {
// //             return conjuntoItem;
// //           }

// //           const quantidadeNormalizada = Number(valor);

// //           return {
// //             ...conjuntoItem,
// //             quantidade:
// //               Number.isNaN(quantidadeNormalizada) || quantidadeNormalizada < 0
// //                 ? 0
// //                 : quantidadeNormalizada,
// //           };
// //         })
// //       );
// //     },
// //     []
// //   );

// //   const handleToggleTodosItensConjunto = useCallback(() => {
// //     setItensConjuntoSelecionados((state) => {
// //       const todosMarcados =
// //         state.length > 0 && state.every((conjuntoItem) => conjuntoItem.checked);

// //       return state.map((conjuntoItem) => ({
// //         ...conjuntoItem,
// //         checked: !todosMarcados,
// //       }));
// //     });
// //   }, []);

// //   // useEffect(() => {
// //   //   if (!utilizaConjunto()) return;

// //   //   const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

// //   //   if (!idItemReferencia) return;

// //   //   if (String(item.idItem) === String(idItemReferencia)) return;

// //   //   const input = itensPagina.find(
// //   //     (i) => String(i.idItem) === String(idItemReferencia)
// //   //   );

// //   //   if (!input) return;

// //   //   setItensConjuntoSelecionados((prev) => {
// //   //     const listaSemItemClicado = prev.filter(
// //   //       (i) => String(i.idItem) !== String(item.idItem)
// //   //     );

// //   //     const jaExiste = listaSemItemClicado.some(
// //   //       (i) => String(i.idItem) === String(input.idItem)
// //   //     );

// //   //     if (jaExiste) return listaSemItemClicado;

// //   //     return [
// //   //       {
// //   //         ...input,
// //   //         checked: false,
// //   //         quantidade:
// //   //           qtdItemInic0() && Number(input.quantidade) !== 0
// //   //             ? 0
// //   //             : Number(input.quantidade || 1),
// //   //       },
// //   //       ...listaSemItemClicado,
// //   //     ];
// //   //   });
// //   // }, [item, itensPagina]);

// //   const normalizaQuantidadeConjunto = useCallback(
// //     (conjuntoItem) =>
// //       qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
// //         ? 0
// //         : Number(conjuntoItem.quantidade || 1),
// //     []
// //   );

// //   const normalizaLevaItemOri = useCallback(
// //     (valor) => valor === true || valor === 1 || valor === '1',
// //     []
// //   );

// //   // useEffect(() => {
// //   //   if (!item) {
// //   //     setItensConjuntoSelecionados([]);
// //   //     return;
// //   //   }

// //   //   const itemClicadoId = String(item.idItem);
// //   //   const itemClicadoMaterial = Number(item.idMaterial);

// //   //   let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
// //   //     ...conjuntoItem,
// //   //     checked: false,
// //   //     quantidade: normalizaQuantidadeConjunto(conjuntoItem),
// //   //   }));

// //   //   listaConjunto = listaConjunto.filter(
// //   //     (conjuntoItem) =>
// //   //       !(
// //   //         String(conjuntoItem.idItem) === itemClicadoId &&
// //   //         Number(conjuntoItem.idMaterial) === itemClicadoMaterial
// //   //       )
// //   //   );

// //   //   if (utilizaConjunto()) {
// //   //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

// //   //     // const deveLevarItemOrigem =
// //   //     //   item?.conjuntoReferencia?.levaItemOri === true ||
// //   //     //   item?.conjuntoReferencia?.levaItemOri === 1 ||
// //   //     //   item?.conjuntoReferencia?.levaItemOri === '1';

// //   //     const deveLevarItemOrigem = normalizaLevaItemOri(
// //   //       item?.conjuntoReferencia?.levaItemOri
// //   //     );

// //   //     const itemClicadoEhReferencia =
// //   //       idItemReferencia && String(idItemReferencia) === itemClicadoId;

// //   //     if (deveLevarItemOrigem && idItemReferencia && !itemClicadoEhReferencia) {
// //   //       const itemReferencia = itensPagina.find(
// //   //         (i) => String(i.idItem) === String(idItemReferencia)
// //   //       );

// //   //       if (itemReferencia) {
// //   //         const referenciaJaExiste = listaConjunto.some(
// //   //           (conjuntoItem) =>
// //   //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
// //   //             Number(conjuntoItem.idMaterial) ===
// //   //               Number(itemReferencia.idMaterial)
// //   //         );

// //   //         if (!referenciaJaExiste) {
// //   //           listaConjunto = [
// //   //             {
// //   //               ...itemReferencia,
// //   //               checked: false,
// //   //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
// //   //             },
// //   //             ...listaConjunto,
// //   //           ];
// //   //         }
// //   //       }
// //   //     }
// //   //   }

// //   //   setItensConjuntoSelecionados(listaConjunto);
// //   // }, [item, itensPagina, normalizaQuantidadeConjunto]);

// //   useEffect(() => {
// //     if (!item) {
// //       setItensConjuntoSelecionados([]);
// //       return;
// //     }

// //     const itemClicadoId = String(item.idItem);
// //     const itemClicadoMaterial = Number(item.idMaterial);

// //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;
// //     const idMaterialReferencia = item?.conjuntoReferencia?.idMaterialOri;

// //     const deveLevarItemOrigem = normalizaLevaItemOri(
// //       item?.conjuntoReferencia?.levaItemOri
// //     );

// //     const itemClicadoEhReferencia =
// //       idItemReferencia &&
// //       String(idItemReferencia) === itemClicadoId &&
// //       Number(idMaterialReferencia) === itemClicadoMaterial;

// //     /**
// //      * REGRA NOVA:
// //      * Se levaItemOri for false/0/'0' e o item clicado não for a origem,
// //      * o modal deve exibir somente o item clicado.
// //      */
// //     if (
// //       item.conjuntoReferencia &&
// //       !deveLevarItemOrigem &&
// //       !itemClicadoEhReferencia
// //     ) {
// //       setItensConjuntoSelecionados([]);
// //       return;
// //     }

// //     let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
// //       ...conjuntoItem,
// //       checked: false,
// //       quantidade: normalizaQuantidadeConjunto(conjuntoItem),
// //     }));

// //     listaConjunto = listaConjunto.filter(
// //       (conjuntoItem) =>
// //         !(
// //           String(conjuntoItem.idItem) === itemClicadoId &&
// //           Number(conjuntoItem.idMaterial) === itemClicadoMaterial
// //         )
// //     );

// //     if (
// //       utilizaConjunto() &&
// //       deveLevarItemOrigem &&
// //       idItemReferencia &&
// //       !itemClicadoEhReferencia
// //     ) {
// //       const itemReferencia = itensPagina.find(
// //         (i) =>
// //           String(i.idItem) === String(idItemReferencia) &&
// //           Number(i.idMaterial) === Number(idMaterialReferencia)
// //       );

// //       if (itemReferencia) {
// //         const referenciaJaExiste = listaConjunto.some(
// //           (conjuntoItem) =>
// //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
// //             Number(conjuntoItem.idMaterial) ===
// //               Number(itemReferencia.idMaterial)
// //         );

// //         if (!referenciaJaExiste) {
// //           listaConjunto = [
// //             {
// //               ...itemReferencia,
// //               checked: false,
// //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
// //             },
// //             ...listaConjunto,
// //           ];
// //         }
// //       }
// //     }

// //     setItensConjuntoSelecionados(listaConjunto);
// //   }, [item, itensPagina, normalizaQuantidadeConjunto, normalizaLevaItemOri]);

// //   const todosItensConjuntoMarcados =
// //     itensConjuntoSelecionados.length > 0 &&
// //     itensConjuntoSelecionados.every((conjuntoItem) => conjuntoItem.checked);

// //   const handleSolicitaAtualizacaoPN = useCallback(() => {
// //     setNovoPartnumber('');
// //     setModalUpdatePN(true);
// //   }, []);

// //   const handleConfirmUpdatePN = useCallback(async () => {
// //     const partnumber = String(novoPartnumber || '').trim();

// //     // console.log(profile);
// //     // console.log(item);

// //     const { idEmpresa } = profile;

// //     if (!partnumber) {
// //       toast.error('Informe o novo partnumber');
// //       return;
// //     }

// //     await api.post(`empresa/${idEmpresa}/update-pn`, {
// //       idMaterial: Number(item.idMaterial),
// //       novoPartnumber: partnumber,
// //     });

// //     toast.success('Solicitação de atualização enviada com sucesso');
// //     setModalUpdatePN(false);
// //     setNovoPartnumber('');
// //   }, [novoPartnumber]);

// //   useEffect(() => {
// //     const { idEmpresa } = profile;

// //     api
// //       .get(`empresa/${idEmpresa}/${item.idMaterial}/update-pn`)
// //       .then((response) => setPartnumbersMaterial(response.data.updatePN));
// //   }, [item]);

// //   const handleListImages = useCallback(() => {
// //     const { idEmpresa } = profile;
// //     const { idCatalogo, idPagina, idItem, idMaterial } = item;

// //     api
// //       .get(
// //         `/empresa/${idEmpresa}/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/material/${idMaterial}/imagens`
// //       )
// //       .then((response) => setListImg(response.data.imagens))
// //       .catch(() => {
// //         setListImg([]);
// //         toast.error('Não foi possível carregar a imagem');
// //       });
// //   }, [item]);

// //   useEffect(() => {
// //     handleListImages();
// //   }, [item]);

// //   return (
// //     <>
// //       <CartModal ref={modalRef} top={top} left={left}>
// //         <Content>
// //           <Content.Move onMouseDown={handleMouseDown}>
// //             <MdMoreHoriz size={24} />
// //           </Content.Move>

// //           <Content.BtnClose type="button" onClick={() => onClose()}>
// //             <MdClose size={20} />
// //           </Content.BtnClose>

// //           <Content.Title>
// //             {/**
// //              *
// //             <strong>
// //               {item.descricao}
// //               {item.partnumber === '8C0143' && (
// //               {item.partnumber === 'AT458609' && ( // PRD 8C0143 QAS AT458609
// //                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
// //                 <ImagePreviewModal imagePaths={[mep001, mep002, mep003]} />
// //               )}
// //               {item.partnumber === '19M7865' && ( // PRD 5G0128 QAS 19M7865
// //                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
// //                 <ImagePreviewModal imagePaths={[mep004, mep005, mep006]} />
// //               )}
// //             </strong>
// //              */}
// //             <strong>
// //               {item.descricao}

// //               {listImg.length > 0 && (
// //                 <ImagePreviewModal
// //                   imagens={listImg}
// //                   idEmpresa={profile.idEmpresa}
// //                   idCatalogo={item.idCatalogo}
// //                   idPagina={item.idPagina}
// //                   idItem={item.idItem}
// //                   idMaterial={item.idMaterial}
// //                 />
// //               )}
// //             </strong>
// //             <div
// //               style={{
// //                 display: 'flex',
// //                 flexDirection: 'row',
// //                 justifyContent: 'flex-start',
// //                 alignItems: 'center',
// //                 width: '100%',
// //               }}
// //             >
// //               <span>{item.partnumber}</span>
// //               {solicitaAtualizacaoPartnumber() && (
// //                 <Row>
// //                   <ButtonUpdatePN
// //                     type="button"
// //                     onClick={handleSolicitaAtualizacaoPN}
// //                   >
// //                     <IoGitPullRequestSharp
// //                       size={20}
// //                       style={{ marginLeft: '5px' }}
// //                     />
// //                   </ButtonUpdatePN>
// //                 </Row>
// //               )}
// //             </div>

// //             {partnumbersMaterial && !permitePartnumberAnteriores() && (
// //               <Content.Title.Hist>
// //                 {partnumbersMaterial.map((pn, index) => {
// //                   if (partnumbersMaterial.length === index + 1)
// //                     return `${pn.partnumber}`;
// //                   return `${pn.partnumber}; `;
// //                 })}
// //               </Content.Title.Hist>
// //             )}

// //             {item.especTecnica && (
// //               <Content.Title.Espec>{item.especTecnica}</Content.Title.Espec>
// //             )}

// //             {(item.nota || item.especTecnica) && (
// //               <Info.Root rightIcon="0" topIcon="0">
// //                 {item.nota && (
// //                   <div>
// //                     <strong>Nota:</strong>
// //                     <span>{item.nota}</span>
// //                   </div>
// //                 )}
// //                 {item.especTecnica && (
// //                   <div>
// //                     <strong>Esp.Tec.:</strong>
// //                     <span>{item.especTecnica}</span>
// //                   </div>
// //                 )}
// //                 {item.materialEmpresa.map((material, index) => (
// //                   <div key={index}>
// //                     <strong>Material ERP:</strong>
// //                     <ul>
// //                       <li>{`${material.descricao || ' - '}`}</li>
// //                       <li>{`Cod.Mat: ${material.codimate || ' -'} | UN: ${
// //                         material.unidade || ' - '
// //                       } | Paralelo: ${material.paralelo ? 'Sim' : 'Não'}`}</li>
// //                     </ul>
// //                   </div>
// //                 ))}
// //               </Info.Root>
// //             )}
// //           </Content.Title>

// //           {/* {solicitaAtualizacaoPartnumber() && (
// //             <Row>
// //               <ButtonUpdatePN
// //                 type="button"
// //                 onClick={handleSolicitaAtualizacaoPN}
// //               >
// //                 <IoGitPullRequestSharp
// //                   size={20}
// //                   style={{ marginRight: '5px' }}
// //                 />
// //                 Solicitar Atualização de Partnumber
// //               </ButtonUpdatePN>
// //             </Row>
// //           )} */}

// //           <Row>
// //             {podeCriarConjunto && (
// //               <button
// //                 type="button"
// //                 onClick={() => setCriarConjuntoAberto(true)}
// //                 style={{
// //                   width: '100%',
// //                   padding: '10px 16px',
// //                   marginTop: '10px',
// //                   borderRadius: 12,
// //                   border: 'none',
// //                   background: '#1e3a8a',
// //                   color: '#fff',
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   cursor: 'pointer',
// //                 }}
// //               >
// //                 {CREATE_SET_KIT[idioma]}
// //               </button>
// //             )}
// //           </Row>

// //           <Content.Form>
// //             {item && (
// //               <Form id="formCart" ref={formRef} onSubmit={handleConfirmar}>
// //                 <Column borderTop>
// //                   {item.materialEmpresa.length > 0 && (
// //                     <SelectInput
// //                       id="materialEmpresa"
// //                       name="materialEmpresa"
// //                       label="Código ERP"
// //                       isClearable
// //                       options={item.materialEmpresa.map((material) => ({
// //                         value: material.codimate,
// //                         label: `${material.codimate} - ${material.descricao}`,
// //                         color:
// //                           material.paralelo === '0' ? '#2c405a' : '#de3b3b',
// //                         fontStyle:
// //                           material.paralelo === '0' ? 'normal' : 'italic',
// //                       }))}
// //                       styles={{
// //                         option: (styles, { data }) => ({
// //                           ...styles,
// //                           color: data.color,
// //                           fontStyle: data.fontStyle,
// //                         }),
// //                       }}
// //                     />
// //                   )}
// //                   <Content.Form.Error>
// //                     {item.materialEmpresa.length > 0
// //                       ? NON_ORIGINAL_MATERIALS_WARNING[idioma]
// //                       : NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
// //                   </Content.Form.Error>
// //                 </Column>

// //                 {partnumbersMaterial && permitePartnumberAnteriores() && (
// //                   <Column borderTop>
// //                     {item.materialEmpresa.length > 0 && (
// //                       <SelectInput
// //                         id="partnumbersMaterial"
// //                         name="partnumbersMaterial"
// //                         label="Partnumber"
// //                         isClearable
// //                         isSearchable
// //                         isDisabled={!partnumbersMaterial}
// //                         value={partnumberSelecionado}
// //                         placeholder="Selecione..."
// //                         options={partnumbersMaterial.map((pn) => ({
// //                           value: String(pn.partnumber),
// //                           label: `${pn.partnumber}`,
// //                         }))}
// //                         styles={{
// //                           option: (styles, { data }) => ({
// //                             ...styles,
// //                             color: data.color,
// //                             fontStyle: data.fontStyle,
// //                           }),
// //                         }}
// //                         onChange={(select) =>
// //                           setPartnumberSelecionado(
// //                             select
// //                               ? {
// //                                   label: String(select.label),
// //                                   value: String(select.value),
// //                                 }
// //                               : null
// //                           )
// //                         }
// //                       />
// //                     )}
// //                   </Column>
// //                 )}

// //                 {criaItemOSSisma() && (
// //                   <>
// //                     <WrapperItemOS>
// //                       {(usaMotivoFalha() ||
// //                         usaAgenteCausa() ||
// //                         usaSecaoTrab()) && (
// //                         <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
// //                           <SubtitleItemOS>Criação Item OS</SubtitleItemOS>
// //                         </Row>
// //                       )}

// //                       {(usaMotivoFalha() ||
// //                         usaAgenteCausa() ||
// //                         usaSecaoTrab()) && (
// //                         <Row>
// //                           {usaMotivoFalha() && (
// //                             <SelectInput
// //                               id="motivoFalha"
// //                               name="motivoFalha"
// //                               label="Motivo Falha"
// //                               width={200}
// //                               isSearchable
// //                               placeholder="Selecione..."
// //                               options={motivoFalha.map((m) => ({
// //                                 value: m.codiMofa,
// //                                 label: m.descricao,
// //                               }))}
// //                             />
// //                           )}

// //                           {usaAgenteCausa() && (
// //                             <SelectInput
// //                               id="agenteCausa"
// //                               name="agenteCausa"
// //                               label="Agente Causa"
// //                               width={200}
// //                               isSearchable
// //                               placeholder="Selecione..."
// //                               options={agenteCausa.map((a) => ({
// //                                 value: a.codiAgente,
// //                                 label: a.descricao,
// //                               }))}
// //                             />
// //                           )}

// //                           {usaSecaoTrab() && (
// //                             <SelectInput
// //                               id="secaoTrab"
// //                               name="secaoTrab"
// //                               label="Seção Trabalho"
// //                               width={200}
// //                               isSearchable
// //                               placeholder="Selecione..."
// //                               options={secaoTrab.map((s) => ({
// //                                 value: s.codiSetr,
// //                                 label: s.descrResum,
// //                               }))}
// //                             />
// //                           )}
// //                         </Row>
// //                       )}

// //                       <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
// //                         <SubtitleItemOS>Composição</SubtitleItemOS>
// //                       </Row>

// //                       <Row>
// //                         <SelectInput
// //                           id="sistema"
// //                           name="sistema"
// //                           label="Sistema"
// //                           width={300}
// //                           isSearchable
// //                           isDisabled={sistemaSelecionado}
// //                           placeholder="Selecione..."
// //                           value={sistemaSelecionado}
// //                           options={sistema.map((s) => ({
// //                             value: s.codiSist,
// //                             label: `${s.codiSist} - ${s.descricao}`,
// //                             composicaoEnabled: s.composicaoEnabled,
// //                             color:
// //                               s.composicaoEnabled === true
// //                                 ? '#334155'
// //                                 : '#64748b',
// //                             fontWeight:
// //                               s.composicaoEnabled === true
// //                                 ? 'bolder'
// //                                 : 'lighter',
// //                           }))}
// //                           styles={{
// //                             option: (styles, { data }) => ({
// //                               ...styles,
// //                               backgroundColor: data.backgroundColor,
// //                               color: data.color,
// //                               fontWeight: data.fontWeight,
// //                             }),
// //                           }}
// //                           onChange={(select) => {
// //                             setSistemaSelecionado({
// //                               composicaoEnabled: select.composicaoEnabled,
// //                               label: select.label,
// //                               value: select.value,
// //                             });
// //                           }}
// //                         />

// //                         <SelectInput
// //                           id="local"
// //                           name="local"
// //                           label="Local"
// //                           width={300}
// //                           isSearchable
// //                           isDisabled={!sistemaSelecionado}
// //                           value={localSelecionado}
// //                           placeholder="Selecione..."
// //                           options={local.map((l) => ({
// //                             value: l.codiLoca,
// //                             label: `${l.codiLoca} - ${l.descricao}`,
// //                             composicaoEnabled: l.composicaoEnabled,
// //                             color:
// //                               l.composicaoEnabled === true
// //                                 ? '#334155'
// //                                 : '#64748b',
// //                             fontWeight:
// //                               l.composicaoEnabled === true
// //                                 ? 'bolder'
// //                                 : 'lighter',
// //                           }))}
// //                           styles={{
// //                             option: (styles, { data }) => ({
// //                               ...styles,
// //                               backgroundColor: data.backgroundColor,
// //                               color: data.color,
// //                               fontWeight: data.fontWeight,
// //                             }),
// //                           }}
// //                           onChange={(select) =>
// //                             setLocalSelecionado({
// //                               composicaoEnabled: select.composicaoEnabled,
// //                               label: select.label,
// //                               value: select.value,
// //                             })
// //                           }
// //                         />
// //                       </Row>
// //                     </WrapperItemOS>
// //                   </>
// //                 )}

// //                 {itensOS.length > 0 && !criaItemOSSisma() && (
// //                   <Row>
// //                     <SelectInput
// //                       id="itemOS"
// //                       name="itemOS"
// //                       label="Item O.S."
// //                       width={335}
// //                       isSearchable
// //                       options={itensOS.map((i) => ({
// //                         value: i.value,
// //                         label: i.label,
// //                       }))}
// //                       defaultValue={{
// //                         value: itensOS[0].value,
// //                         label: itensOS[0].label,
// //                       }}
// //                       onChange={(select) =>
// //                         handleSelecionado(
// //                           select,
// //                           item.idCatalogo,
// //                           item.idPagina,
// //                           item.idItem,
// //                           item.idMaterial,
// //                           item.materialEmpresa
// //                         )
// //                       }
// //                     />
// //                   </Row>
// //                 )}

// //                 <Row>
// //                   <Content.Form.Quantity>
// //                     <label htmlFor="quantidade">
// //                       {HEADER_TABLE_ITENS_QTD[idioma]}
// //                     </label>
// //                     <div>
// //                       <button type="button" onClick={handleRemover}>
// //                         <MdChevronLeft size={25} />
// //                       </button>

// //                       <Input
// //                         id="quantidade"
// //                         name="quantidade"
// //                         flexDirection="row"
// //                         type="number"
// //                         min="1"
// //                         max="9999999.9999"
// //                         width={80}
// //                       />

// //                       <button type="button" onClick={handleAdicionar}>
// //                         <MdChevronRight size={25} />
// //                       </button>
// //                     </div>
// //                   </Content.Form.Quantity>
// //                 </Row>

// //                 {/* {solicitaAtualizacaoPartnumber() && (
// //                   <Row>
// //                     <button
// //                       type="button"
// //                       onClick={handleSolicitaAtualizacaoPN}
// //                       style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         width: '100%',
// //                         padding: '10px',
// //                         margin: '10px auto',
// //                         border: 'none',
// //                         background: '#64748b',
// //                         color: '#f8fafc',
// //                         borderRadius: '5px',
// //                       }}
// //                     >
// //                       <IoGitPullRequestSharp
// //                         size={20}
// //                         style={{ marginRight: '5px' }}
// //                       />
// //                       Solicitar Atualização de Partnumber
// //                     </button>
// //                   </Row>
// //                 )} */}

// //                 {utilizaConjunto() && !!itensConjuntoSelecionados.length && (
// //                   <Row style={{ marginTop: 16 }}>
// //                     <div style={{ width: '100%' }}>
// //                       <div
// //                         style={{
// //                           display: 'flex',
// //                           justifyContent: 'space-between',
// //                           alignItems: 'center',
// //                           marginBottom: 10,
// //                         }}
// //                       >
// //                         <label
// //                           style={{
// //                             display: 'block',
// //                             fontWeight: 600,
// //                             marginBottom: 0,
// //                           }}
// //                         >
// //                           Kit sugerido
// //                         </label>

// //                         <button
// //                           type="button"
// //                           onClick={handleToggleTodosItensConjunto}
// //                           style={{
// //                             background: 'transparent',
// //                             border: 'none',
// //                             color: '#2563eb',
// //                             cursor: 'pointer',
// //                             fontWeight: 600,
// //                             fontSize: 13,
// //                             padding: 0,
// //                           }}
// //                         >
// //                           {todosItensConjuntoMarcados
// //                             ? CLEAR_ALL[idioma]
// //                             : MARK_ALL[idioma]}
// //                         </button>
// //                       </div>

// //                       <div
// //                         style={{
// //                           maxHeight: 240,
// //                           overflowY: 'auto',
// //                           border: '1px solid #dbe1e9',
// //                           borderRadius: 8,
// //                           padding: 10,
// //                           background: '#fff',
// //                         }}
// //                       >
// //                         {itensConjuntoSelecionados.map((conjuntoItem) => (
// //                           <div
// //                             key={`${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
// //                             style={{
// //                               display: 'flex',
// //                               alignItems: 'center',
// //                               gap: 12,
// //                               padding: '10px 0',
// //                               borderBottom: '1px solid #eef2f7',
// //                               opacity: conjuntoItem.checked ? 1 : 0.45,
// //                               transition: 'opacity 0.2s ease',
// //                             }}
// //                           >
// //                             <input
// //                               type="checkbox"
// //                               checked={conjuntoItem.checked}
// //                               onChange={() =>
// //                                 handleToggleItemConjunto(
// //                                   conjuntoItem.idItem,
// //                                   conjuntoItem.idMaterial
// //                                 )
// //                               }
// //                             />

// //                             <div style={{ flex: 1, minWidth: 0 }}>
// //                               <div style={{ fontWeight: 600 }}>
// //                                 {conjuntoItem.itemResum || conjuntoItem.idItem}{' '}
// //                                 - {conjuntoItem.partnumber}
// //                               </div>
// //                               <div
// //                                 style={{
// //                                   fontSize: 13,
// //                                   color: '#64748b',
// //                                   marginTop: 2,
// //                                 }}
// //                               >
// //                                 {conjuntoItem.descricao}
// //                               </div>
// //                             </div>

// //                             <div
// //                               style={{
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: 8,
// //                               }}
// //                             >
// //                               <label
// //                                 htmlFor={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
// //                                 style={{ fontSize: 13 }}
// //                               >
// //                                 Qtd.
// //                               </label>

// //                               <input
// //                                 id={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
// //                                 type="number"
// //                                 min="0"
// //                                 value={conjuntoItem.quantidade}
// //                                 disabled={!conjuntoItem.checked}
// //                                 onChange={(e) =>
// //                                   handleQuantidadeItemConjunto(
// //                                     conjuntoItem.idItem,
// //                                     conjuntoItem.idMaterial,
// //                                     e.target.value
// //                                   )
// //                                 }
// //                                 style={{
// //                                   width: 50,
// //                                   height: 34,
// //                                   border: '1px solid #cbd5e1',
// //                                   borderRadius: 6,
// //                                   padding: '0 8px',
// //                                 }}
// //                               />
// //                             </div>
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   </Row>
// //                 )}
// //               </Form>
// //             )}

// //             <Content.BtnAddCart type="submit" form="formCart">
// //               <MdShoppingCart size={20} /> {ADD_TO_CART[idioma]}
// //             </Content.BtnAddCart>

// //             {/* {podeCriarConjunto && (
// //               <button
// //                 type="button"
// //                 onClick={() => setCriarConjuntoAberto(true)}
// //                 style={{
// //                   marginTop: 8,
// //                   width: '100%',
// //                   padding: '10px 16px',
// //                   borderRadius: 6,
// //                   border: 'none',
// //                   background: '#1789dd',
// //                   color: '#fff',
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   cursor: 'pointer',
// //                 }}
// //               >
// //                 {CREATE_SET_KIT[idioma]}
// //               </button>
// //             )} */}
// //           </Content.Form>
// //         </Content>

// //         {criarConjuntoAberto && (
// //           <ModalCriarConjunto
// //             item={item}
// //             itensPagina={itensPagina}
// //             onClose={() => setCriarConjuntoAberto(false)}
// //           />
// //         )}
// //       </CartModal>

// //       {/* {modalUpdatePN && (
// //         <CartModal>
// //           <Content>
// //             <Content.BtnClose
// //               type="button"
// //               onClick={() => setModalUpdatePN(false)}
// //             >
// //               <MdClose size={20} />
// //             </Content.BtnClose>
// //             <Content.Title>
// //               <strong>Atualização de Partnumber</strong>
// //             </Content.Title>
// //             <WrapperUpdatePN>
// //               <p>Partnumber Atual:</p>
// //               <h4>{item.partnumber}</h4>
// //               <p>Solicitar Atualização Para:</p>
// //               <input placeholder="Novo Partnumber" />
// //             </WrapperUpdatePN>
// //           </Content>
// //         </CartModal>
// //       )} */}

// //       {modalUpdatePN && (
// //         <CartModal>
// //           <Content>
// //             <Content.BtnClose
// //               type="button"
// //               onClick={() => setModalUpdatePN(false)}
// //             >
// //               <MdClose size={20} />
// //             </Content.BtnClose>

// //             <Content.Title>
// //               <strong>Atualização de Partnumber</strong>
// //             </Content.Title>

// //             <WrapperUpdatePN>
// //               <div className="current-box">
// //                 <span>Partnumber atual</span>
// //                 <strong>{item.partnumber}</strong>
// //               </div>

// //               <div className="form-group">
// //                 <label htmlFor="new-partnumber">
// //                   Solicitar atualização para
// //                 </label>

// //                 {/* <input
// //                   id="new-partnumber"
// //                   type="text"
// //                   placeholder="Digite o novo partnumber"
// //                 /> */}
// //                 <input
// //                   id="new-partnumber"
// //                   type="text"
// //                   placeholder="Digite o novo partnumber"
// //                   value={novoPartnumber}
// //                   onChange={(e) => setNovoPartnumber(e.target.value)}
// //                 />
// //               </div>

// //               <div className="actions">
// //                 <button
// //                   type="button"
// //                   className="cancel"
// //                   onClick={() => setModalUpdatePN(false)}
// //                 >
// //                   Cancelar
// //                 </button>

// //                 <button
// //                   type="button"
// //                   onClick={() => handleConfirmUpdatePN(novoPartnumber)}
// //                 >
// //                   Solicitar atualização
// //                 </button>
// //               </div>
// //             </WrapperUpdatePN>
// //           </Content>
// //         </CartModal>
// //       )}
// //     </>
// //   );
// // }

// // export default ItemCart;

// /* eslint-disable jsx-a11y/label-has-associated-control */
// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import ReactDOM from 'react-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';

// import {
//   MdShoppingCart,
//   MdClose,
//   MdChevronLeft,
//   MdChevronRight,
//   MdMoreHoriz,
//   MdCheckCircle,
//   MdOutlineError,
// } from 'react-icons/md';
// import { IoGitPullRequestSharp } from 'react-icons/io5';
// import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
// import * as Yup from 'yup';
// import PropTypes from 'prop-types';

// // import { Scope } from '@unform/core';
// import { toast } from 'react-toastify';
// // import history from '../../services/history';
// import { AppError } from '../../errors/AppError';

// import { Form, Row, Column } from '../Form';
// import SelectInput from '../Form/Input/Select';
// import Input from '../Form/Input';

// import {
//   adicionaCarrinhoArrayRequest,
//   adicionaCarrinhoRequest,
//   atualizaItemOSRequest,
// } from '../../store/modules/cart/actions';

// import { Info } from '../Info';

// import {
//   CartModal,
//   Content,
//   WrapperItemOS,
//   SubtitleItemOS,
//   WrapperUpdatePN,
//   ButtonUpdatePN,
// } from './styles';
// // import InputViewer from '../Form/Input/Viewer';
// // import { Table } from '../../pages/Home/Carrinho/styles';
// import {
//   bloqueiaPartnumberAnteriores,
//   criaItemOSSisma,
//   limitaQtdMax,
//   limitaQtdMin,
//   limiteItemQtdZero,
//   permitePartnumberAnteriores,
//   qtdItemInic0,
//   removeERPHome,
//   solicitaAtualizacaoPartnumber,
//   usaAgenteCausa,
//   usaMotivoFalha,
//   usaSecaoTrab,
//   utilizaConjunto,
// } from '../../lib/paramUtils';
// import api from '../../services/api';
// import ImagePreviewModal from '../prototipoImagemPeca';
// import ModalCriarConjunto from '../ModalCriarConjunto';
// import {
//   ADD_TO_CART,
//   CLEAR_ALL,
//   CREATE_SET_KIT,
//   HEADER_TABLE_ITENS_QTD,
//   MARK_ALL,
//   NO_ERP_CODE_RELATED_TO_MATERIAL,
//   NON_ORIGINAL_MATERIALS_WARNING,
//   opIdiomaCatalogo,
// } from '../../lib/idiomaAppOptions';
// // import cdiNoPhotoAvailable from '../../assets/cdi-no-photo-available.png';
// // import mep001 from '../../assets/mep/001.jpeg';
// // import mep002 from '../../assets/mep/002.jpeg';
// // import mep003 from '../../assets/mep/003.jpeg';
// // import mep004 from '../../assets/mep/004.jpeg';
// // import mep005 from '../../assets/mep/005.jpeg';
// // import mep006 from '../../assets/mep/006.jpeg';

// /** margem mínima entre o modal e as bordas da tela */
// const MARGEM_TELA = 12;

// // function ItemCart({ containerRef, item, onClose }) {
// /**
//  * containerRef permanece na assinatura por compatibilidade com as chamadas
//  * existentes, mas não é mais usado para posicionar o modal: com o portal e
//  * position: fixed a referência passou a ser a própria viewport.
//  */
// // eslint-disable-next-line no-unused-vars
// function ItemCart({ containerRef, item, itensPagina, onClose }) {
//   const modalRef = useRef();
//   const formRef = useRef();

//   const location = useLocation();
//   const dispatch = useDispatch();

//   /**
//    * O modal é renderizado em um portal no document.body e usa
//    * position: fixed. Assim fica disponível na tela inteira e não é
//    * recortado pelo bloco da imagem (ZoomArea/Wrapper), que tem
//    * overflow: hidden.
//    *
//    * ATENÇÃO: o nó do portal é criado de forma SÍNCRONA (inicializador do
//    * useState) e não dentro de um useEffect. Criá-lo em efeito faria o
//    * primeiro render retornar null, o formulário não seria montado e os
//    * efeitos que usam formRef.current (quantidade, código ERP, local)
//    * quebrariam com "Cannot read properties of undefined".
//    */
//   const [portalContainer] = useState(() => document.createElement('div'));

//   const [left, setLeft] = useState(0);
//   const [top, setTop] = useState(0);

//   /** evita o "salto" visual antes de medir e centralizar o modal */
//   const [posicionado, setPosicionado] = useState(false);
//   // const [move, setMove] = useState(false);

//   const [motivoFalha, setMotivoFalha] = useState([]);
//   const [agenteCausa, setAgenteCausa] = useState([]);
//   const [secaoTrab, setSecaoTrab] = useState([]);
//   const [sistema, setSistema] = useState([]);
//   const [local, setLocal] = useState([]);

//   const [sistemaSelecionado, setSistemaSelecionado] = useState(null);
//   const [localSelecionado, setLocalSelecionado] = useState(null);

//   const [partnumberSelecionado, setPartnumberSelecionado] = useState(null);

//   const [itensConjuntoSelecionados, setItensConjuntoSelecionados] = useState(
//     []
//   );

//   const [modalUpdatePN, setModalUpdatePN] = useState(false);
//   const [novoPartnumber, setNovoPartnumber] = useState('');

//   /** modal de criação de conjunto/kit (somente ADM = 4) */
//   const [criarConjuntoAberto, setCriarConjuntoAberto] = useState(false);

//   const [partnumbersMaterial, setPartnumbersMaterial] = useState([]);

//   const [listImg, setListImg] = useState([]);

//   //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const itensOS = useSelector((state) => {
//     const { cart } = state;
//     const {
//       order: { extItemOS },
//     } = cart || {};

//     return extItemOS;
//   });

//   const profile = useSelector((state) => {
//     const { userId, adm, empresa } = state.user.profile || {};
//     const { idEmpresa } = empresa || {};

//     return { userId, adm, idEmpresa };
//   });

//   /** ADM = 4 pode criar conjunto/kit pela Home */
//   const podeCriarConjunto = String(profile.adm) === '2' && utilizaConjunto();

//   /**
//    * Parâmetro global 35 (REMOVE_ERP_HOME): oculta o Código ERP do material na
//    * Home. Com o parâmetro ativo, a seleção de "Código ERP" e as informações de
//    * material ERP não são exibidas e o material é resolvido automaticamente
//    * (primeiro material relacionado ao item, quando existir).
//    */
//   const ocultaERPHome = removeERPHome();

//   const paramQuery = new URLSearchParams(location.search);

//   const paramRoute = {
//     ...Object.fromEntries(paramQuery),
//   };

//   const idCatalogoLocation = location.pathname.split('/').pop();
//   const idPaginaLocation = paramRoute.IDP;

//   useEffect(() => {
//     const { quantidade, materialEmpresa } = item || { quantidade: 0 };

//     const { ERP } = paramRoute;

//     const materialEmpresaURL = ERP
//       ? materialEmpresa.filter((e) => e.codimate === ERP)
//       : [];

//     /** com o parâmetro 35 ativo o campo de Código ERP não é renderizado */
//     if (
//       !ocultaERPHome &&
//       (materialEmpresa.length === 1 || materialEmpresaURL.length === 1)
//     ) {
//       const selectedOption = {
//         value: (materialEmpresaURL[0] || materialEmpresa[0]).codimate,
//         label: `${(materialEmpresaURL[0] || materialEmpresa[0]).codimate} - ${
//           (materialEmpresaURL[0] || materialEmpresa[0]).descricao
//         }`,
//         color:
//           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
//             ? '#2c405a'
//             : '#de3b3b',
//         fontStyle:
//           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
//             ? 'normal'
//             : 'italic',
//       };
//       formRef.current.setFieldValue('materialEmpresa', selectedOption);
//     }

//     if (qtdItemInic0()) {
//       formRef.current.setFieldValue('quantidade', 0);
//     } else {
//       formRef.current.setFieldValue('quantidade', quantidade);
//     }
//   }, [item, location.search]);

//   useEffect(() => {
//     const itensConjunto = item?.itensConjuntoModal || [];

//     setItensConjuntoSelecionados(
//       itensConjunto.map((conjuntoItem) => ({
//         ...conjuntoItem,
//         // checked: false,
//         checked: true,
//         quantidade:
//           qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
//             ? 0
//             : Number(conjuntoItem.quantidade || 1),
//       }))
//     );
//   }, [item]);

//   useEffect(() => {
//     async function fetchData() {
//       const responseMotivoFalha = await api
//         .get(`/empresa/${profile.idEmpresa}/itemos/motivofalha`)
//         .then((res) => res.data);
//       setMotivoFalha(responseMotivoFalha);

//       const responseAgenteCausa = await api
//         .get(`/empresa/${profile.idEmpresa}/itemos/agentecausa`)
//         .then((res) => res.data);
//       setAgenteCausa(responseAgenteCausa);

//       const responseSecaoTrab = await api
//         .get(`/empresa/${profile.idEmpresa}/itemos/secaotrab`)
//         .then((res) => res.data);
//       setSecaoTrab(responseSecaoTrab);

//       const responseSistema = await api
//         .get(
//           `/empresa/${profile.idEmpresa}/itemos/sistema/${Number(
//             idCatalogoLocation
//           )}/pagina/${Number(idPaginaLocation)}`,
//           {
//             params: {
//               local: localSelecionado ? Number(localSelecionado.value) : null,
//             },
//           }
//         )
//         .then((res) => res.data);
//       setSistema(responseSistema);

//       const responseLocal = await api
//         .get(
//           `/empresa/${profile.idEmpresa}/itemos/local/${Number(
//             idCatalogoLocation
//           )}`,
//           {
//             params: {
//               sistema: sistemaSelecionado
//                 ? Number(sistemaSelecionado.value)
//                 : null,
//             },
//           }
//         )
//         .then((res) => res.data);
//       setLocal(responseLocal);
//     }

//     if (criaItemOSSisma()) {
//       fetchData();
//     } else {
//       setAgenteCausa([{ codiAgente: 0 }]);
//       setMotivoFalha([{ codiMofa: 0 }]);
//       setSecaoTrab([{ codiSetr: 0 }]);
//       setSistema([{ codiSist: 0 }]);
//       setLocal([{ codiLoca: 0 }]);
//     }
//   }, [
//     sistemaSelecionado,
//     localSelecionado,
//     idCatalogoLocation,
//     profile.idEmpresa,
//     idPaginaLocation,
//   ]);

//   const handleRelacPagSistLoc = useCallback(async () => {
//     const relac = await api
//       .get(
//         `/empresa/${profile.idEmpresa}/catalogo/${idCatalogoLocation}/relacionamento-sistema-local/${idPaginaLocation}`
//       )
//       .then((res) => {
//         const { relacPaginaSistLoc } =
//           res.data.relacPaginaSistLoc.length > 0 && res.data;

//         const fmtRelacPaginaSistLoc =
//           relacPaginaSistLoc && relacPaginaSistLoc.pop();

//         const output = fmtRelacPaginaSistLoc
//           ? {
//               composicaoEnabled: true,
//               label: `${fmtRelacPaginaSistLoc.sistema?.codiSist} - ${fmtRelacPaginaSistLoc.sistema?.descricao}`,
//               value: fmtRelacPaginaSistLoc.sistema?.codiSist,
//             }
//           : null;

//         return output;
//       });

//     return relac;
//   }, [
//     idCatalogoLocation,
//     idPaginaLocation,
//     profile.idEmpresa,
//     location.search,
//   ]);

//   useEffect(() => {
//     async function loadDefaultSistema() {
//       const defaultValue = await handleRelacPagSistLoc();
//       setSistemaSelecionado(defaultValue);
//     }
//     if (criaItemOSSisma()) loadDefaultSistema();
//   }, [handleRelacPagSistLoc, location.search]);

//   // useEffect(() => {
//   //   const { ERP } = paramRoute;

//   //   if (ERP) {
//   //     paramQuery.delete('ERP');
//   //     history.replace({
//   //       pathname: location.pathname,
//   //       search: `?${paramQuery.toString()}`,
//   //     });
//   //   }
//   // }, [location.search, location.pathname]);

//   /**
//    * Não limpamos o ERP ao montar o modal.
//    * O ERP precisa permanecer na URL até o ItemCart preencher o material correto.
//    * A limpeza dos parâmetros temporários da busca (IDI/ERP) é feita no fechamento
//    * do modal pelo componente da página.
//    */

//   // const montarItensCarrinho = useCallback(
//   //   ({
//   //     itemPrincipal,
//   //     quantidadePrincipal,
//   //     materialEmpresaPrincipal,
//   //     imagemCatalogoPrincipal,
//   //     itemOS,
//   //     codiAgente,
//   //     codiMofa,
//   //     codiSetr,
//   //     codiSist,
//   //     codiLoca,
//   //   }) => {
//   //     const itensSelecionadosConjunto = itensConjuntoSelecionados
//   //       .filter((conjuntoItem) => conjuntoItem.checked)
//   //       .map((conjuntoItem) => ({
//   //         idCatalogo: conjuntoItem.idCatalogo,
//   //         idPagina: conjuntoItem.idPagina,
//   //         idItem: conjuntoItem.idItem,
//   //         idMaterial: conjuntoItem.idMaterial,
//   //         quantidade: Number(conjuntoItem.quantidade || 1),
//   //         materialEmpresa:
//   //           conjuntoItem.materialEmpresa?.length === 1
//   //             ? conjuntoItem.materialEmpresa[0].codimate
//   //             : null,
//   //         imagemCatalogo:
//   //           conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
//   //         itemOS,
//   //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
//   //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
//   //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
//   //         codiSist: criaItemOSSisma() ? codiSist : 0,
//   //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
//   //       }));

//   //     const itemPrincipalFormatado = {
//   //       idCatalogo: itemPrincipal.idCatalogo,
//   //       idPagina: itemPrincipal.idPagina,
//   //       idItem: itemPrincipal.idItem,
//   //       idMaterial: itemPrincipal.idMaterial,
//   //       quantidade: Number(quantidadePrincipal),
//   //       materialEmpresa: materialEmpresaPrincipal,
//   //       imagemCatalogo: imagemCatalogoPrincipal,
//   //       itemOS,
//   //       codiAgente: criaItemOSSisma() ? codiAgente : 0,
//   //       codiMofa: criaItemOSSisma() ? codiMofa : 0,
//   //       codiSetr: criaItemOSSisma() ? codiSetr : 0,
//   //       codiSist: criaItemOSSisma() ? codiSist : 0,
//   //       codiLoca: criaItemOSSisma() ? codiLoca : 0,
//   //     };

//   //     return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
//   //   },
//   //   [itensConjuntoSelecionados]
//   // );

//   const montarItensCarrinho = useCallback(
//     ({
//       itemPrincipal,
//       partnumber,
//       quantidadePrincipal,
//       materialEmpresaPrincipal,
//       imagemCatalogoPrincipal,
//       itemOS,
//       codiAgente,
//       codiMofa,
//       codiSetr,
//       codiSist,
//       codiLoca,
//     }) => {
//       const itensSelecionadosConjunto = itensConjuntoSelecionados
//         .filter((conjuntoItem) => conjuntoItem.checked)
//         .map((conjuntoItem) => ({
//           idCatalogo: conjuntoItem.idCatalogo,
//           idPagina: conjuntoItem.idPagina,
//           idItem: conjuntoItem.idItem,
//           idMaterial: conjuntoItem.idMaterial,
//           partnumber: conjuntoItem.partnumber,
//           quantidade: Number(conjuntoItem.quantidade || 1),
//           codimate:
//             conjuntoItem.materialEmpresa?.length === 1
//               ? conjuntoItem.materialEmpresa[0].codimate
//               : null,
//           imagemCatalogo:
//             conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
//           itemOS,
//           codiAgente: criaItemOSSisma() ? codiAgente : 0,
//           codiMofa: criaItemOSSisma() ? codiMofa : 0,
//           codiSetr: criaItemOSSisma() ? codiSetr : 0,
//           codiSist: criaItemOSSisma() ? codiSist : 0,
//           codiLoca: criaItemOSSisma() ? codiLoca : 0,
//         }));

//       const itemPrincipalFormatado = {
//         idCatalogo: itemPrincipal.idCatalogo,
//         idPagina: itemPrincipal.idPagina,
//         idItem: itemPrincipal.idItem,
//         idMaterial: itemPrincipal.idMaterial,
//         partnumber: partnumber || itemPrincipal.partnumber,
//         quantidade: Number(quantidadePrincipal),
//         codimate: materialEmpresaPrincipal,
//         imagemCatalogo: imagemCatalogoPrincipal,
//         itemOS,
//         codiAgente: criaItemOSSisma() ? codiAgente : 0,
//         codiMofa: criaItemOSSisma() ? codiMofa : 0,
//         codiSetr: criaItemOSSisma() ? codiSetr : 0,
//         codiSist: criaItemOSSisma() ? codiSist : 0,
//         codiLoca: criaItemOSSisma() ? codiLoca : 0,
//       };

//       return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
//     },
//     [itensConjuntoSelecionados]
//   );

//   const handleConfirmar = useCallback(
//     async (data) => {
//       try {
//         /**
//          * Com o parâmetro 35 (REMOVE_ERP_HOME) ativo o campo de Código ERP não
//          * é exibido, portanto não há seleção de material a validar.
//          */
//         if (item.materialEmpresa.length > 0 && !ocultaERPHome) {
//           const schema = Yup.object().shape({
//             materialEmpresa: Yup.string().required('Selecione um material'),
//           });

//           await schema.validate(data, { abortEarly: false });
//         }

//         const {
//           idCatalogo,
//           idPagina,
//           idItem,
//           idMaterial,
//           imagemCatalogo,
//         } = item;

//         const { quantidade, materialEmpresa, itemOS } = data;

//         /**
//          * Parâmetro 35: sem o campo de Código ERP na tela, usa o material
//          * relacionado ao item (o primeiro, quando houver mais de um).
//          */
//         const materialEmpresaSelecionado = ocultaERPHome
//           ? (item.materialEmpresa || [])[0]?.codimate || null
//           : materialEmpresa;

//         if (limiteItemQtdZero().active) {
//           if (
//             Number(item.quantidade) === 0 &&
//             Number(quantidade) > Number(limiteItemQtdZero().value)
//           ) {
//             window.confirm(
//               `A quantidade não pode ser maior que ${
//                 limiteItemQtdZero().value
//               } para itens que o catálogo indique a quantidade 0`
//             );
//             return;
//           }
//         }

//         if (limitaQtdMax().active && !limitaQtdMin().active) {
//           if (Number(limitaQtdMax().value) === 1) {
//             if (Number(quantidade) > Number(item.quantidade)) {
//               window.confirm(
//                 'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
//               );
//               return;
//             }
//           }
//           if (Number(limitaQtdMax().value) === 2) {
//             if (Number(quantidade) > Number(item.quantidade)) {
//               window.confirm(
//                 'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
//               );
//             }
//           }
//         }

//         if (limitaQtdMin().active && !limitaQtdMax().active) {
//           if (Number(limitaQtdMin().value) === 1) {
//             if (Number(quantidade) < Number(item.quantidade)) {
//               window.confirm(
//                 'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
//               );
//               return;
//             }
//           }
//           if (Number(limitaQtdMin().value) === 2) {
//             if (Number(quantidade) < Number(item.quantidade)) {
//               window.confirm(
//                 'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
//               );
//             }
//           }
//         }

//         if (limitaQtdMin().active && limitaQtdMax().active) {
//           if (
//             Number(limitaQtdMax().value) === 1 &&
//             Number(limitaQtdMin().value) === 1
//           ) {
//             if (Number(quantidade) !== Number(item.quantidade)) {
//               window.confirm(
//                 'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
//               );
//               return;
//             }
//           }
//           if (
//             Number(limitaQtdMax().value) === 2 &&
//             Number(limitaQtdMin().value) === 2
//           ) {
//             if (Number(quantidade) !== Number(item.quantidade)) {
//               window.confirm(
//                 'A quantidade esta diferente da estabelecida no catálogo'
//               );
//             }
//           }
//         }

//         const objAgenteCausa = agenteCausa[agenteCausa.length - 1] || {};
//         const objMotivoFalha = motivoFalha[motivoFalha.length - 1] || {};
//         const objSecaoTrab = secaoTrab[secaoTrab.length - 1] || {};

//         const { codiAgente = 0 } = objAgenteCausa;
//         const { codiMofa = 0 } = objMotivoFalha;
//         const { codiSetr = 0 } = objSecaoTrab;

//         const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
//         const codiLoca = localSelecionado ? localSelecionado.value : 0;

//         console.log(partnumberSelecionado);
//         console.log(item);

//         const partnumber =
//           partnumberSelecionado !== null
//             ? partnumberSelecionado.value
//             : item.partnumber;

//         //* ********************************************************* */

//         // dispatch(
//         //   adicionaCarrinhoRequest(
//         //     idCatalogo,
//         //     idPagina,
//         //     idItem,
//         //     idMaterial,
//         //     Number(quantidade),
//         //     materialEmpresa,
//         //     imagemCatalogo,
//         //     itemOS,
//         //     criaItemOSSisma() ? codiAgente : 0,
//         //     criaItemOSSisma() ? codiMofa : 0,
//         //     criaItemOSSisma() ? codiSetr : 0,
//         //     criaItemOSSisma() ? codiSist : 0,
//         //     criaItemOSSisma() ? codiLoca : 0
//         //   )
//         // );

//         // itensConjuntoSelecionados
//         //   .filter((conjuntoItem) => conjuntoItem.checked)
//         //   .forEach((conjuntoItem) => {
//         //     dispatch(
//         //       adicionaCarrinhoRequest(
//         //         conjuntoItem.idCatalogo,
//         //         conjuntoItem.idPagina,
//         //         conjuntoItem.idItem,
//         //         conjuntoItem.idMaterial,
//         //         Number(conjuntoItem.quantidade || 1),
//         //         conjuntoItem.materialEmpresa?.length === 1
//         //           ? conjuntoItem.materialEmpresa[0].codimate
//         //           : null,
//         //         conjuntoItem.imagemCatalogo || imagemCatalogo,
//         //         itemOS,
//         //         criaItemOSSisma() ? codiAgente : 0,
//         //         criaItemOSSisma() ? codiMofa : 0,
//         //         criaItemOSSisma() ? codiSetr : 0,
//         //         criaItemOSSisma() ? codiSist : 0,
//         //         criaItemOSSisma() ? codiLoca : 0
//         //       )
//         //     );
//         //   });

//         //* ********************************************************* */

//         // const itensParaAdicionar = montarItensCarrinho({
//         //   itemPrincipal: item,
//         //   quantidadePrincipal: quantidade,
//         //   materialEmpresaPrincipal: materialEmpresa,
//         //   imagemCatalogoPrincipal: imagemCatalogo,
//         //   itemOS,
//         //   codiAgente,
//         //   codiMofa,
//         //   codiSetr,
//         //   codiSist,
//         //   codiLoca,
//         // });

//         // dispatch(adicionaCarrinhoRequest(itensParaAdicionar));

//         //* ********************************************************* */

//         const itensParaAdicionar = montarItensCarrinho({
//           itemPrincipal: item,
//           partnumber,
//           quantidadePrincipal: quantidade,
//           materialEmpresaPrincipal: materialEmpresaSelecionado,
//           imagemCatalogoPrincipal: imagemCatalogo,
//           itemOS,
//           codiAgente,
//           codiMofa,
//           codiSetr,
//           codiSist,
//           codiLoca,
//         });

//         if (itensParaAdicionar.length === 1) {
//           const itemUnico = itensParaAdicionar[0];

//           dispatch(
//             adicionaCarrinhoRequest(
//               itemUnico.idCatalogo,
//               itemUnico.idPagina,
//               itemUnico.idItem,
//               itemUnico.idMaterial,
//               itemUnico.partnumber,
//               itemUnico.quantidade,
//               itemUnico.codimate,
//               itemUnico.imagemCatalogo,
//               itemUnico.itemOS,
//               itemUnico.codiAgente,
//               itemUnico.codiMofa,
//               itemUnico.codiSetr,
//               itemUnico.codiSist,
//               itemUnico.codiLoca
//             )
//           );
//         } else {
//           dispatch(
//             adicionaCarrinhoArrayRequest(
//               itensParaAdicionar[0].idCatalogo,
//               itensParaAdicionar
//             )
//           );
//         }

//         onClose(data);
//       } catch (err) {
//         AppError(err, formRef);
//       }
//     },
//     [
//       item,
//       dispatch,
//       onClose,
//       sistemaSelecionado,
//       localSelecionado,
//       partnumberSelecionado,
//       agenteCausa,
//       motivoFalha,
//       secaoTrab,
//       itensConjuntoSelecionados,
//       ocultaERPHome,
//     ]
//   );

//   const handleAdicionar = useCallback(() => {
//     const quantidade = Number(formRef.current.getFieldValue('quantidade'));
//     formRef.current.setFieldValue('quantidade', quantidade + 1);
//   }, []);

//   const handleRemover = useCallback(() => {
//     const quantidade = Number(formRef.current.getFieldValue('quantidade'));

//     if (quantidade > 1) {
//       formRef.current.setFieldValue('quantidade', quantidade - 1);
//     }
//   }, []);

//   /**
//    * Arraste em coordenadas da viewport (clientX/clientY), coerente com o
//    * position: fixed do modal, e limitado à área visível para que ele nunca
//    * seja arrastado para fora do alcance do usuário.
//    *
//    * Usa Pointer Events para funcionar com mouse e com toque (tablet) —
//    * antes eram apenas eventos de mouse, que não disparam durante o
//    * arraste por toque.
//    */
//   const handleMouseMove = useCallback((e) => {
//     if (!modalRef.current) return;

//     const { width, height } = modalRef.current.getBoundingClientRect();

//     const maxLeft = Math.max(
//       MARGEM_TELA,
//       window.innerWidth - width - MARGEM_TELA
//     );
//     const maxTop = Math.max(
//       MARGEM_TELA,
//       window.innerHeight - height - MARGEM_TELA
//     );

//     setLeft(Math.min(Math.max(MARGEM_TELA, e.clientX - width / 2), maxLeft));
//     setTop(Math.min(Math.max(MARGEM_TELA, e.clientY - 5), maxTop));

//     e.stopPropagation();
//     e.preventDefault();
//   }, []);

//   const handleMouseUp = useCallback(
//     (e) => {
//       document.removeEventListener('pointermove', handleMouseMove);
//       document.removeEventListener('pointerup', handleMouseUp);
//       document.removeEventListener('pointercancel', handleMouseUp);

//       e.stopPropagation();
//       e.preventDefault();
//     },
//     [handleMouseMove]
//   );

//   const handleMouseDown = useCallback(
//     (e) => {
//       document.addEventListener('pointermove', handleMouseMove);
//       document.addEventListener('pointerup', handleMouseUp);
//       document.addEventListener('pointercancel', handleMouseUp);

//       e.stopPropagation();
//       e.preventDefault();
//     },
//     [handleMouseMove, handleMouseUp]
//   );

//   /**
//    * Anexa o nó do portal ao document.body e faz a limpeza ao desmontar.
//    * Declarado ANTES do efeito de centralização para que o nó já esteja no
//    * documento quando o modal for medido.
//    */
//   useEffect(() => {
//     document.body.appendChild(portalContainer);

//     return () => {
//       document.removeEventListener('pointermove', handleMouseMove);
//       document.removeEventListener('pointerup', handleMouseUp);
//       document.removeEventListener('pointercancel', handleMouseUp);

//       document.body.removeChild(portalContainer);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   /**
//    * Centraliza o modal na tela ao abrir. Depois disso a posição é do
//    * usuário (arraste), por isso o efeito não observa o item selecionado.
//    */
//   useEffect(() => {
//     if (!modalRef.current) return;

//     const { width, height } = modalRef.current.getBoundingClientRect();

//     setLeft(Math.max(MARGEM_TELA, Math.round((window.innerWidth - width) / 2)));
//     setTop(
//       Math.max(MARGEM_TELA, Math.round((window.innerHeight - height) / 2))
//     );
//     setPosicionado(true);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   /** mantém o modal dentro da tela ao redimensionar / rotacionar o tablet */
//   useEffect(() => {
//     const handleResize = () => {
//       if (!modalRef.current) return;

//       const { width, height } = modalRef.current.getBoundingClientRect();

//       setLeft((state) =>
//         Math.min(
//           Math.max(MARGEM_TELA, state),
//           Math.max(MARGEM_TELA, window.innerWidth - width - MARGEM_TELA)
//         )
//       );
//       setTop((state) =>
//         Math.min(
//           Math.max(MARGEM_TELA, state),
//           Math.max(MARGEM_TELA, window.innerHeight - height - MARGEM_TELA)
//         )
//       );
//     };

//     window.addEventListener('resize', handleResize);

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // const handleSelecionado = useCallback(
//   //   ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//   //     const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//   //     dispatch(
//   //       atualizaItemOSRequest(
//   //         idCatalogo,
//   //         idPagina,
//   //         idItem,
//   //         idMaterial,
//   //         value,
//   //         codimate
//   //       )
//   //     );
//   //   },
//   //   [dispatch]
//   // );

//   const handleSelecionado = useCallback(
//     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//       const codimate = Array.isArray(materialEmpresa)
//         ? materialEmpresa[0]?.codimate || null
//         : materialEmpresa?.codimate || null;

//       dispatch(
//         atualizaItemOSRequest(
//           idCatalogo,
//           idPagina,
//           idItem,
//           idMaterial,
//           value,
//           codimate
//         )
//       );
//     },
//     [dispatch]
//   );

//   useEffect(() => {
//     if (local.length === 1 && !localSelecionado) {
//       const selectedOption = {
//         value: local[0].codiLoca,
//         label: `${local[0].codiLoca} - ${local[0].descricao}`,
//         color: '#2c405a',
//       };
//       setLocalSelecionado(selectedOption);
//       formRef.current.setFieldValue('local', selectedOption);
//     }
//   }, [local, localSelecionado]);

//   const handleToggleItemConjunto = useCallback((idItem, idMaterial) => {
//     setItensConjuntoSelecionados((state) =>
//       state.map((conjuntoItem) =>
//         String(conjuntoItem.idItem) === String(idItem) &&
//         Number(conjuntoItem.idMaterial) === Number(idMaterial)
//           ? { ...conjuntoItem, checked: !conjuntoItem.checked }
//           : conjuntoItem
//       )
//     );
//   }, []);

//   const handleQuantidadeItemConjunto = useCallback(
//     (idItem, idMaterial, valor) => {
//       setItensConjuntoSelecionados((state) =>
//         state.map((conjuntoItem) => {
//           if (
//             String(conjuntoItem.idItem) !== String(idItem) ||
//             Number(conjuntoItem.idMaterial) !== Number(idMaterial)
//           ) {
//             return conjuntoItem;
//           }

//           const quantidadeNormalizada = Number(valor);

//           return {
//             ...conjuntoItem,
//             quantidade:
//               Number.isNaN(quantidadeNormalizada) || quantidadeNormalizada < 0
//                 ? 0
//                 : quantidadeNormalizada,
//           };
//         })
//       );
//     },
//     []
//   );

//   const handleToggleTodosItensConjunto = useCallback(() => {
//     setItensConjuntoSelecionados((state) => {
//       const todosMarcados =
//         state.length > 0 && state.every((conjuntoItem) => conjuntoItem.checked);

//       return state.map((conjuntoItem) => ({
//         ...conjuntoItem,
//         checked: !todosMarcados,
//       }));
//     });
//   }, []);

//   // useEffect(() => {
//   //   if (!utilizaConjunto()) return;

//   //   const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

//   //   if (!idItemReferencia) return;

//   //   if (String(item.idItem) === String(idItemReferencia)) return;

//   //   const input = itensPagina.find(
//   //     (i) => String(i.idItem) === String(idItemReferencia)
//   //   );

//   //   if (!input) return;

//   //   setItensConjuntoSelecionados((prev) => {
//   //     const listaSemItemClicado = prev.filter(
//   //       (i) => String(i.idItem) !== String(item.idItem)
//   //     );

//   //     const jaExiste = listaSemItemClicado.some(
//   //       (i) => String(i.idItem) === String(input.idItem)
//   //     );

//   //     if (jaExiste) return listaSemItemClicado;

//   //     return [
//   //       {
//   //         ...input,
//   //         checked: false,
//   //         quantidade:
//   //           qtdItemInic0() && Number(input.quantidade) !== 0
//   //             ? 0
//   //             : Number(input.quantidade || 1),
//   //       },
//   //       ...listaSemItemClicado,
//   //     ];
//   //   });
//   // }, [item, itensPagina]);

//   const normalizaQuantidadeConjunto = useCallback(
//     (conjuntoItem) =>
//       qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
//         ? 0
//         : Number(conjuntoItem.quantidade || 1),
//     []
//   );

//   const normalizaLevaItemOri = useCallback(
//     (valor) => valor === true || valor === 1 || valor === '1',
//     []
//   );

//   // useEffect(() => {
//   //   if (!item) {
//   //     setItensConjuntoSelecionados([]);
//   //     return;
//   //   }

//   //   const itemClicadoId = String(item.idItem);
//   //   const itemClicadoMaterial = Number(item.idMaterial);

//   //   let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
//   //     ...conjuntoItem,
//   //     checked: false,
//   //     quantidade: normalizaQuantidadeConjunto(conjuntoItem),
//   //   }));

//   //   listaConjunto = listaConjunto.filter(
//   //     (conjuntoItem) =>
//   //       !(
//   //         String(conjuntoItem.idItem) === itemClicadoId &&
//   //         Number(conjuntoItem.idMaterial) === itemClicadoMaterial
//   //       )
//   //   );

//   //   if (utilizaConjunto()) {
//   //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

//   //     // const deveLevarItemOrigem =
//   //     //   item?.conjuntoReferencia?.levaItemOri === true ||
//   //     //   item?.conjuntoReferencia?.levaItemOri === 1 ||
//   //     //   item?.conjuntoReferencia?.levaItemOri === '1';

//   //     const deveLevarItemOrigem = normalizaLevaItemOri(
//   //       item?.conjuntoReferencia?.levaItemOri
//   //     );

//   //     const itemClicadoEhReferencia =
//   //       idItemReferencia && String(idItemReferencia) === itemClicadoId;

//   //     if (deveLevarItemOrigem && idItemReferencia && !itemClicadoEhReferencia) {
//   //       const itemReferencia = itensPagina.find(
//   //         (i) => String(i.idItem) === String(idItemReferencia)
//   //       );

//   //       if (itemReferencia) {
//   //         const referenciaJaExiste = listaConjunto.some(
//   //           (conjuntoItem) =>
//   //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
//   //             Number(conjuntoItem.idMaterial) ===
//   //               Number(itemReferencia.idMaterial)
//   //         );

//   //         if (!referenciaJaExiste) {
//   //           listaConjunto = [
//   //             {
//   //               ...itemReferencia,
//   //               checked: false,
//   //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
//   //             },
//   //             ...listaConjunto,
//   //           ];
//   //         }
//   //       }
//   //     }
//   //   }

//   //   setItensConjuntoSelecionados(listaConjunto);
//   // }, [item, itensPagina, normalizaQuantidadeConjunto]);

//   useEffect(() => {
//     if (!item) {
//       setItensConjuntoSelecionados([]);
//       return;
//     }

//     const itemClicadoId = String(item.idItem);
//     const itemClicadoMaterial = Number(item.idMaterial);

//     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;
//     const idMaterialReferencia = item?.conjuntoReferencia?.idMaterialOri;

//     const deveLevarItemOrigem = normalizaLevaItemOri(
//       item?.conjuntoReferencia?.levaItemOri
//     );

//     const itemClicadoEhReferencia =
//       idItemReferencia &&
//       String(idItemReferencia) === itemClicadoId &&
//       Number(idMaterialReferencia) === itemClicadoMaterial;

//     /**
//      * REGRA NOVA:
//      * Se levaItemOri for false/0/'0' e o item clicado não for a origem,
//      * o modal deve exibir somente o item clicado.
//      */
//     if (
//       item.conjuntoReferencia &&
//       !deveLevarItemOrigem &&
//       !itemClicadoEhReferencia
//     ) {
//       setItensConjuntoSelecionados([]);
//       return;
//     }

//     let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
//       ...conjuntoItem,
//       checked: false,
//       quantidade: normalizaQuantidadeConjunto(conjuntoItem),
//     }));

//     listaConjunto = listaConjunto.filter(
//       (conjuntoItem) =>
//         !(
//           String(conjuntoItem.idItem) === itemClicadoId &&
//           Number(conjuntoItem.idMaterial) === itemClicadoMaterial
//         )
//     );

//     if (
//       utilizaConjunto() &&
//       deveLevarItemOrigem &&
//       idItemReferencia &&
//       !itemClicadoEhReferencia
//     ) {
//       const itemReferencia = itensPagina.find(
//         (i) =>
//           String(i.idItem) === String(idItemReferencia) &&
//           Number(i.idMaterial) === Number(idMaterialReferencia)
//       );

//       if (itemReferencia) {
//         const referenciaJaExiste = listaConjunto.some(
//           (conjuntoItem) =>
//             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
//             Number(conjuntoItem.idMaterial) ===
//               Number(itemReferencia.idMaterial)
//         );

//         if (!referenciaJaExiste) {
//           listaConjunto = [
//             {
//               ...itemReferencia,
//               checked: false,
//               quantidade: normalizaQuantidadeConjunto(itemReferencia),
//             },
//             ...listaConjunto,
//           ];
//         }
//       }
//     }

//     setItensConjuntoSelecionados(listaConjunto);
//   }, [item, itensPagina, normalizaQuantidadeConjunto, normalizaLevaItemOri]);

//   const todosItensConjuntoMarcados =
//     itensConjuntoSelecionados.length > 0 &&
//     itensConjuntoSelecionados.every((conjuntoItem) => conjuntoItem.checked);

//   const handleSolicitaAtualizacaoPN = useCallback(() => {
//     setNovoPartnumber('');
//     setModalUpdatePN(true);
//   }, []);

//   const handleConfirmUpdatePN = useCallback(async () => {
//     const partnumber = String(novoPartnumber || '').trim();

//     // console.log(profile);
//     // console.log(item);

//     const { idEmpresa } = profile;

//     if (!partnumber) {
//       toast.error('Informe o novo partnumber');
//       return;
//     }

//     await api.post(`empresa/${idEmpresa}/update-pn`, {
//       idMaterial: Number(item.idMaterial),
//       novoPartnumber: partnumber,
//     });

//     toast.success('Solicitação de atualização enviada com sucesso');
//     setModalUpdatePN(false);
//     setNovoPartnumber('');
//   }, [novoPartnumber]);

//   useEffect(() => {
//     const { idEmpresa } = profile;

//     api
//       .get(`empresa/${idEmpresa}/${item.idMaterial}/update-pn`)
//       .then((response) => setPartnumbersMaterial(response.data.updatePN));
//   }, [item]);

//   const handleListImages = useCallback(() => {
//     const { idEmpresa } = profile;
//     const { idCatalogo, idPagina, idItem, idMaterial } = item;

//     api
//       .get(
//         `/empresa/${idEmpresa}/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/material/${idMaterial}/imagens`
//       )
//       .then((response) => setListImg(response.data.imagens))
//       .catch(() => {
//         setListImg([]);
//         toast.error('Não foi possível carregar a imagem');
//       });
//   }, [item]);

//   useEffect(() => {
//     handleListImages();
//   }, [item]);

//   return ReactDOM.createPortal(
//     <>
//       <CartModal
//         ref={modalRef}
//         top={top}
//         left={left}
//         posicionado={posicionado ? 1 : 0}
//       >
//         <Content>
//           <Content.Move onPointerDown={handleMouseDown}>
//             <MdMoreHoriz size={24} />
//           </Content.Move>

//           <Content.BtnClose type="button" onClick={() => onClose()}>
//             <MdClose size={20} />
//           </Content.BtnClose>

//           <Content.Title>
//             {/**
//              *
//             <strong>
//               {item.descricao}
//               {item.partnumber === '8C0143' && (
//               {item.partnumber === 'AT458609' && ( // PRD 8C0143 QAS AT458609
//                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
//                 <ImagePreviewModal imagePaths={[mep001, mep002, mep003]} />
//               )}
//               {item.partnumber === '19M7865' && ( // PRD 5G0128 QAS 19M7865
//                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
//                 <ImagePreviewModal imagePaths={[mep004, mep005, mep006]} />
//               )}
//             </strong>
//              */}
//             <strong>
//               {item.descricao}

//               {listImg.length > 0 && (
//                 <ImagePreviewModal
//                   imagens={listImg}
//                   idEmpresa={profile.idEmpresa}
//                   idCatalogo={item.idCatalogo}
//                   idPagina={item.idPagina}
//                   idItem={item.idItem}
//                   idMaterial={item.idMaterial}
//                 />
//               )}
//             </strong>
//             <div
//               style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'flex-start',
//                 alignItems: 'center',
//                 width: '100%',
//               }}
//             >
//               <span>{item.partnumber}</span>
//               {solicitaAtualizacaoPartnumber() && (
//                 <Row>
//                   <ButtonUpdatePN
//                     type="button"
//                     onClick={handleSolicitaAtualizacaoPN}
//                   >
//                     <IoGitPullRequestSharp
//                       size={20}
//                       style={{ marginLeft: '5px' }}
//                     />
//                   </ButtonUpdatePN>
//                 </Row>
//               )}
//             </div>

//             {partnumbersMaterial && !permitePartnumberAnteriores() && (
//               <Content.Title.Hist>
//                 {partnumbersMaterial.map((pn, index) => {
//                   if (partnumbersMaterial.length === index + 1)
//                     return `${pn.partnumber}`;
//                   return `${pn.partnumber}; `;
//                 })}
//               </Content.Title.Hist>
//             )}

//             {item.especTecnica && (
//               <Content.Title.Espec>{item.especTecnica}</Content.Title.Espec>
//             )}

//             {(item.nota || item.especTecnica) && (
//               <Info.Root rightIcon="0" topIcon="0">
//                 {item.nota && (
//                   <div>
//                     <strong>Nota:</strong>
//                     <span>{item.nota}</span>
//                   </div>
//                 )}
//                 {item.especTecnica && (
//                   <div>
//                     <strong>Esp.Tec.:</strong>
//                     <span>{item.especTecnica}</span>
//                   </div>
//                 )}
//                 {!ocultaERPHome &&
//                   item.materialEmpresa.map((material, index) => (
//                     <div key={index}>
//                       <strong>Material ERP:</strong>
//                       <ul>
//                         <li>{`${material.descricao || ' - '}`}</li>
//                         <li>{`Cod.Mat: ${material.codimate || ' -'} | UN: ${
//                           material.unidade || ' - '
//                         } | Paralelo: ${
//                           material.paralelo ? 'Sim' : 'Não'
//                         }`}</li>
//                       </ul>
//                     </div>
//                   ))}
//               </Info.Root>
//             )}
//           </Content.Title>

//           {/* {solicitaAtualizacaoPartnumber() && (
//             <Row>
//               <ButtonUpdatePN
//                 type="button"
//                 onClick={handleSolicitaAtualizacaoPN}
//               >
//                 <IoGitPullRequestSharp
//                   size={20}
//                   style={{ marginRight: '5px' }}
//                 />
//                 Solicitar Atualização de Partnumber
//               </ButtonUpdatePN>
//             </Row>
//           )} */}

//           <Row>
//             {podeCriarConjunto && (
//               <button
//                 type="button"
//                 onClick={() => setCriarConjuntoAberto(true)}
//                 style={{
//                   width: '100%',
//                   padding: '10px 16px',
//                   marginTop: '10px',
//                   borderRadius: 12,
//                   border: 'none',
//                   background: '#1e3a8a',
//                   color: '#fff',
//                   fontSize: 13,
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                 }}
//               >
//                 {CREATE_SET_KIT[idioma]}
//               </button>
//             )}
//           </Row>

//           <Content.Form>
//             {item && (
//               <Form id="formCart" ref={formRef} onSubmit={handleConfirmar}>
//                 {!ocultaERPHome && (
//                   <Column borderTop>
//                     {item.materialEmpresa.length > 0 && (
//                       <SelectInput
//                         id="materialEmpresa"
//                         name="materialEmpresa"
//                         label="Código ERP"
//                         isClearable
//                         options={item.materialEmpresa.map((material) => ({
//                           value: material.codimate,
//                           label: `${material.codimate} - ${material.descricao}`,
//                           color:
//                             material.paralelo === '0' ? '#2c405a' : '#de3b3b',
//                           fontStyle:
//                             material.paralelo === '0' ? 'normal' : 'italic',
//                         }))}
//                         styles={{
//                           option: (styles, { data }) => ({
//                             ...styles,
//                             color: data.color,
//                             fontStyle: data.fontStyle,
//                           }),
//                         }}
//                       />
//                     )}
//                     <Content.Form.Error>
//                       {item.materialEmpresa.length > 0
//                         ? NON_ORIGINAL_MATERIALS_WARNING[idioma]
//                         : NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
//                     </Content.Form.Error>
//                   </Column>
//                 )}

//                 {partnumbersMaterial && permitePartnumberAnteriores() && (
//                   <Column borderTop>
//                     {item.materialEmpresa.length > 0 && (
//                       <SelectInput
//                         id="partnumbersMaterial"
//                         name="partnumbersMaterial"
//                         label="Partnumber"
//                         isClearable
//                         isSearchable
//                         isDisabled={!partnumbersMaterial}
//                         value={partnumberSelecionado}
//                         placeholder="Selecione..."
//                         options={partnumbersMaterial.map((pn) => ({
//                           value: String(pn.partnumber),
//                           label: `${pn.partnumber}`,
//                         }))}
//                         styles={{
//                           option: (styles, { data }) => ({
//                             ...styles,
//                             color: data.color,
//                             fontStyle: data.fontStyle,
//                           }),
//                         }}
//                         onChange={(select) =>
//                           setPartnumberSelecionado(
//                             select
//                               ? {
//                                   label: String(select.label),
//                                   value: String(select.value),
//                                 }
//                               : null
//                           )
//                         }
//                       />
//                     )}
//                   </Column>
//                 )}

//                 {criaItemOSSisma() && (
//                   <>
//                     <WrapperItemOS>
//                       {(usaMotivoFalha() ||
//                         usaAgenteCausa() ||
//                         usaSecaoTrab()) && (
//                         <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
//                           <SubtitleItemOS>Criação Item OS</SubtitleItemOS>
//                         </Row>
//                       )}

//                       {(usaMotivoFalha() ||
//                         usaAgenteCausa() ||
//                         usaSecaoTrab()) && (
//                         <Row>
//                           {usaMotivoFalha() && (
//                             <SelectInput
//                               id="motivoFalha"
//                               name="motivoFalha"
//                               label="Motivo Falha"
//                               width={200}
//                               isSearchable
//                               placeholder="Selecione..."
//                               options={motivoFalha.map((m) => ({
//                                 value: m.codiMofa,
//                                 label: m.descricao,
//                               }))}
//                             />
//                           )}

//                           {usaAgenteCausa() && (
//                             <SelectInput
//                               id="agenteCausa"
//                               name="agenteCausa"
//                               label="Agente Causa"
//                               width={200}
//                               isSearchable
//                               placeholder="Selecione..."
//                               options={agenteCausa.map((a) => ({
//                                 value: a.codiAgente,
//                                 label: a.descricao,
//                               }))}
//                             />
//                           )}

//                           {usaSecaoTrab() && (
//                             <SelectInput
//                               id="secaoTrab"
//                               name="secaoTrab"
//                               label="Seção Trabalho"
//                               width={200}
//                               isSearchable
//                               placeholder="Selecione..."
//                               options={secaoTrab.map((s) => ({
//                                 value: s.codiSetr,
//                                 label: s.descrResum,
//                               }))}
//                             />
//                           )}
//                         </Row>
//                       )}

//                       <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
//                         <SubtitleItemOS>Composição</SubtitleItemOS>
//                       </Row>

//                       <Row>
//                         <SelectInput
//                           id="sistema"
//                           name="sistema"
//                           label="Sistema"
//                           width={300}
//                           isSearchable
//                           isDisabled={sistemaSelecionado}
//                           placeholder="Selecione..."
//                           value={sistemaSelecionado}
//                           options={sistema.map((s) => ({
//                             value: s.codiSist,
//                             label: `${s.codiSist} - ${s.descricao}`,
//                             composicaoEnabled: s.composicaoEnabled,
//                             color:
//                               s.composicaoEnabled === true
//                                 ? '#334155'
//                                 : '#64748b',
//                             fontWeight:
//                               s.composicaoEnabled === true
//                                 ? 'bolder'
//                                 : 'lighter',
//                           }))}
//                           styles={{
//                             option: (styles, { data }) => ({
//                               ...styles,
//                               backgroundColor: data.backgroundColor,
//                               color: data.color,
//                               fontWeight: data.fontWeight,
//                             }),
//                           }}
//                           onChange={(select) => {
//                             setSistemaSelecionado({
//                               composicaoEnabled: select.composicaoEnabled,
//                               label: select.label,
//                               value: select.value,
//                             });
//                           }}
//                         />

//                         <SelectInput
//                           id="local"
//                           name="local"
//                           label="Local"
//                           width={300}
//                           isSearchable
//                           isDisabled={!sistemaSelecionado}
//                           value={localSelecionado}
//                           placeholder="Selecione..."
//                           options={local.map((l) => ({
//                             value: l.codiLoca,
//                             label: `${l.codiLoca} - ${l.descricao}`,
//                             composicaoEnabled: l.composicaoEnabled,
//                             color:
//                               l.composicaoEnabled === true
//                                 ? '#334155'
//                                 : '#64748b',
//                             fontWeight:
//                               l.composicaoEnabled === true
//                                 ? 'bolder'
//                                 : 'lighter',
//                           }))}
//                           styles={{
//                             option: (styles, { data }) => ({
//                               ...styles,
//                               backgroundColor: data.backgroundColor,
//                               color: data.color,
//                               fontWeight: data.fontWeight,
//                             }),
//                           }}
//                           onChange={(select) =>
//                             setLocalSelecionado({
//                               composicaoEnabled: select.composicaoEnabled,
//                               label: select.label,
//                               value: select.value,
//                             })
//                           }
//                         />
//                       </Row>
//                     </WrapperItemOS>
//                   </>
//                 )}

//                 {itensOS.length > 0 && !criaItemOSSisma() && (
//                   <Row>
//                     <SelectInput
//                       id="itemOS"
//                       name="itemOS"
//                       label="Item O.S."
//                       width={335}
//                       isSearchable
//                       options={itensOS.map((i) => ({
//                         value: i.value,
//                         label: i.label,
//                       }))}
//                       defaultValue={{
//                         value: itensOS[0].value,
//                         label: itensOS[0].label,
//                       }}
//                       onChange={(select) =>
//                         handleSelecionado(
//                           select,
//                           item.idCatalogo,
//                           item.idPagina,
//                           item.idItem,
//                           item.idMaterial,
//                           item.materialEmpresa
//                         )
//                       }
//                     />
//                   </Row>
//                 )}

//                 <Row>
//                   <Content.Form.Quantity>
//                     <label htmlFor="quantidade">
//                       {HEADER_TABLE_ITENS_QTD[idioma]}
//                     </label>
//                     <div>
//                       <button type="button" onClick={handleRemover}>
//                         <MdChevronLeft size={25} />
//                       </button>

//                       <Input
//                         id="quantidade"
//                         name="quantidade"
//                         flexDirection="row"
//                         type="number"
//                         min="1"
//                         max="9999999.9999"
//                         width={80}
//                       />

//                       <button type="button" onClick={handleAdicionar}>
//                         <MdChevronRight size={25} />
//                       </button>
//                     </div>
//                   </Content.Form.Quantity>
//                 </Row>

//                 {/* {solicitaAtualizacaoPartnumber() && (
//                   <Row>
//                     <button
//                       type="button"
//                       onClick={handleSolicitaAtualizacaoPN}
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: '100%',
//                         padding: '10px',
//                         margin: '10px auto',
//                         border: 'none',
//                         background: '#64748b',
//                         color: '#f8fafc',
//                         borderRadius: '5px',
//                       }}
//                     >
//                       <IoGitPullRequestSharp
//                         size={20}
//                         style={{ marginRight: '5px' }}
//                       />
//                       Solicitar Atualização de Partnumber
//                     </button>
//                   </Row>
//                 )} */}

//                 {utilizaConjunto() && !!itensConjuntoSelecionados.length && (
//                   <Row style={{ marginTop: 16 }}>
//                     <div style={{ width: '100%' }}>
//                       <div
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           marginBottom: 10,
//                         }}
//                       >
//                         <label
//                           style={{
//                             display: 'block',
//                             fontWeight: 600,
//                             marginBottom: 0,
//                           }}
//                         >
//                           Kit sugerido
//                         </label>

//                         <button
//                           type="button"
//                           onClick={handleToggleTodosItensConjunto}
//                           style={{
//                             background: 'transparent',
//                             border: 'none',
//                             color: '#2563eb',
//                             cursor: 'pointer',
//                             fontWeight: 600,
//                             fontSize: 13,
//                             padding: 0,
//                           }}
//                         >
//                           {todosItensConjuntoMarcados
//                             ? CLEAR_ALL[idioma]
//                             : MARK_ALL[idioma]}
//                         </button>
//                       </div>

//                       <div
//                         style={{
//                           maxHeight: 240,
//                           overflowY: 'auto',
//                           border: '1px solid #dbe1e9',
//                           borderRadius: 8,
//                           padding: 10,
//                           background: '#fff',
//                         }}
//                       >
//                         {itensConjuntoSelecionados.map((conjuntoItem) => (
//                           <div
//                             key={`${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
//                             style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: 12,
//                               padding: '10px 0',
//                               borderBottom: '1px solid #eef2f7',
//                               opacity: conjuntoItem.checked ? 1 : 0.45,
//                               transition: 'opacity 0.2s ease',
//                             }}
//                           >
//                             <input
//                               type="checkbox"
//                               checked={conjuntoItem.checked}
//                               onChange={() =>
//                                 handleToggleItemConjunto(
//                                   conjuntoItem.idItem,
//                                   conjuntoItem.idMaterial
//                                 )
//                               }
//                             />

//                             <div style={{ flex: 1, minWidth: 0 }}>
//                               <div style={{ fontWeight: 600 }}>
//                                 {conjuntoItem.itemResum || conjuntoItem.idItem}{' '}
//                                 - {conjuntoItem.partnumber}
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: 13,
//                                   color: '#64748b',
//                                   marginTop: 2,
//                                 }}
//                               >
//                                 {conjuntoItem.descricao}
//                               </div>
//                             </div>

//                             <div
//                               style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: 8,
//                               }}
//                             >
//                               <label
//                                 htmlFor={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
//                                 style={{ fontSize: 13 }}
//                               >
//                                 Qtd.
//                               </label>

//                               <input
//                                 id={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
//                                 type="number"
//                                 min="0"
//                                 value={conjuntoItem.quantidade}
//                                 disabled={!conjuntoItem.checked}
//                                 onChange={(e) =>
//                                   handleQuantidadeItemConjunto(
//                                     conjuntoItem.idItem,
//                                     conjuntoItem.idMaterial,
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{
//                                   width: 50,
//                                   height: 34,
//                                   border: '1px solid #cbd5e1',
//                                   borderRadius: 6,
//                                   padding: '0 8px',
//                                 }}
//                               />
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </Row>
//                 )}
//               </Form>
//             )}

//             <Content.BtnAddCart type="submit" form="formCart">
//               <MdShoppingCart size={20} /> {ADD_TO_CART[idioma]}
//             </Content.BtnAddCart>

//             {/* {podeCriarConjunto && (
//               <button
//                 type="button"
//                 onClick={() => setCriarConjuntoAberto(true)}
//                 style={{
//                   marginTop: 8,
//                   width: '100%',
//                   padding: '10px 16px',
//                   borderRadius: 6,
//                   border: 'none',
//                   background: '#1789dd',
//                   color: '#fff',
//                   fontSize: 13,
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                 }}
//               >
//                 {CREATE_SET_KIT[idioma]}
//               </button>
//             )} */}
//           </Content.Form>
//         </Content>

//         {criarConjuntoAberto && (
//           <ModalCriarConjunto
//             item={item}
//             itensPagina={itensPagina}
//             onClose={() => setCriarConjuntoAberto(false)}
//           />
//         )}
//       </CartModal>

//       {/* {modalUpdatePN && (
//         <CartModal>
//           <Content>
//             <Content.BtnClose
//               type="button"
//               onClick={() => setModalUpdatePN(false)}
//             >
//               <MdClose size={20} />
//             </Content.BtnClose>
//             <Content.Title>
//               <strong>Atualização de Partnumber</strong>
//             </Content.Title>
//             <WrapperUpdatePN>
//               <p>Partnumber Atual:</p>
//               <h4>{item.partnumber}</h4>
//               <p>Solicitar Atualização Para:</p>
//               <input placeholder="Novo Partnumber" />
//             </WrapperUpdatePN>
//           </Content>
//         </CartModal>
//       )} */}

//       {modalUpdatePN && (
//         <CartModal centered={1}>
//           <Content>
//             <Content.BtnClose
//               type="button"
//               onClick={() => setModalUpdatePN(false)}
//             >
//               <MdClose size={20} />
//             </Content.BtnClose>

//             <Content.Title>
//               <strong>Atualização de Partnumber</strong>
//             </Content.Title>

//             <WrapperUpdatePN>
//               <div className="current-box">
//                 <span>Partnumber atual</span>
//                 <strong>{item.partnumber}</strong>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="new-partnumber">
//                   Solicitar atualização para
//                 </label>

//                 {/* <input
//                   id="new-partnumber"
//                   type="text"
//                   placeholder="Digite o novo partnumber"
//                 /> */}
//                 <input
//                   id="new-partnumber"
//                   type="text"
//                   placeholder="Digite o novo partnumber"
//                   value={novoPartnumber}
//                   onChange={(e) => setNovoPartnumber(e.target.value)}
//                 />
//               </div>

//               <div className="actions">
//                 <button
//                   type="button"
//                   className="cancel"
//                   onClick={() => setModalUpdatePN(false)}
//                 >
//                   Cancelar
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleConfirmUpdatePN(novoPartnumber)}
//                 >
//                   Solicitar atualização
//                 </button>
//               </div>
//             </WrapperUpdatePN>
//           </Content>
//         </CartModal>
//       )}
//     </>,
//     portalContainer
//   );
// }

// export default ItemCart;

// /* eslint-disable jsx-a11y/label-has-associated-control */
// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';

// import {
//   MdShoppingCart,
//   MdClose,
//   MdChevronLeft,
//   MdChevronRight,
//   MdMoreHoriz,
//   MdCheckCircle,
//   MdOutlineError,
// } from 'react-icons/md';
// import { IoGitPullRequestSharp } from 'react-icons/io5';
// import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
// import * as Yup from 'yup';
// import PropTypes from 'prop-types';

// // import { Scope } from '@unform/core';
// import { toast } from 'react-toastify';
// // import history from '../../services/history';
// import { AppError } from '../../errors/AppError';

// import { Form, Row, Column } from '../Form';
// import SelectInput from '../Form/Input/Select';
// import Input from '../Form/Input';

// import {
//   adicionaCarrinhoArrayRequest,
//   adicionaCarrinhoRequest,
//   atualizaItemOSRequest,
// } from '../../store/modules/cart/actions';

// import { Info } from '../Info';

// import {
//   CartModal,
//   Content,
//   WrapperItemOS,
//   SubtitleItemOS,
//   WrapperUpdatePN,
//   ButtonUpdatePN,
// } from './styles';
// // import InputViewer from '../Form/Input/Viewer';
// // import { Table } from '../../pages/Home/Carrinho/styles';
// import {
//   bloqueiaPartnumberAnteriores,
//   criaItemOSSisma,
//   limitaQtdMax,
//   limitaQtdMin,
//   limiteItemQtdZero,
//   permitePartnumberAnteriores,
//   qtdItemInic0,
//   solicitaAtualizacaoPartnumber,
//   usaAgenteCausa,
//   usaMotivoFalha,
//   usaSecaoTrab,
//   utilizaConjunto,
// } from '../../lib/paramUtils';
// import api from '../../services/api';
// import ImagePreviewModal from '../prototipoImagemPeca';
// import ModalCriarConjunto from '../ModalCriarConjunto';
// import {
//   ADD_TO_CART,
//   CLEAR_ALL,
//   CREATE_SET_KIT,
//   HEADER_TABLE_ITENS_QTD,
//   MARK_ALL,
//   NO_ERP_CODE_RELATED_TO_MATERIAL,
//   NON_ORIGINAL_MATERIALS_WARNING,
//   opIdiomaCatalogo,
// } from '../../lib/idiomaAppOptions';
// // import cdiNoPhotoAvailable from '../../assets/cdi-no-photo-available.png';
// // import mep001 from '../../assets/mep/001.jpeg';
// // import mep002 from '../../assets/mep/002.jpeg';
// // import mep003 from '../../assets/mep/003.jpeg';
// // import mep004 from '../../assets/mep/004.jpeg';
// // import mep005 from '../../assets/mep/005.jpeg';
// // import mep006 from '../../assets/mep/006.jpeg';

// // function ItemCart({ containerRef, item, onClose }) {
// function ItemCart({ containerRef, item, itensPagina, onClose }) {
//   const modalRef = useRef();
//   const formRef = useRef();

//   const location = useLocation();
//   const dispatch = useDispatch();

//   const [left, setLeft] = useState(0);
//   const [top, setTop] = useState(0);
//   // const [move, setMove] = useState(false);

//   const [motivoFalha, setMotivoFalha] = useState([]);
//   const [agenteCausa, setAgenteCausa] = useState([]);
//   const [secaoTrab, setSecaoTrab] = useState([]);
//   const [sistema, setSistema] = useState([]);
//   const [local, setLocal] = useState([]);

//   const [sistemaSelecionado, setSistemaSelecionado] = useState(null);
//   const [localSelecionado, setLocalSelecionado] = useState(null);

//   const [partnumberSelecionado, setPartnumberSelecionado] = useState(null);

//   const [itensConjuntoSelecionados, setItensConjuntoSelecionados] = useState(
//     []
//   );

//   const [modalUpdatePN, setModalUpdatePN] = useState(false);
//   const [novoPartnumber, setNovoPartnumber] = useState('');

//   /** modal de criação de conjunto/kit (somente ADM = 4) */
//   const [criarConjuntoAberto, setCriarConjuntoAberto] = useState(false);

//   const [partnumbersMaterial, setPartnumbersMaterial] = useState([]);

//   const [listImg, setListImg] = useState([]);

//   //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const itensOS = useSelector((state) => {
//     const { cart } = state;
//     const {
//       order: { extItemOS },
//     } = cart || {};

//     return extItemOS;
//   });

//   const profile = useSelector((state) => {
//     const { userId, adm, empresa } = state.user.profile || {};
//     const { idEmpresa } = empresa || {};

//     return { userId, adm, idEmpresa };
//   });

//   /** ADM = 4 pode criar conjunto/kit pela Home */
//   const podeCriarConjunto = String(profile.adm) === '2' && utilizaConjunto();

//   const paramQuery = new URLSearchParams(location.search);

//   const paramRoute = {
//     ...Object.fromEntries(paramQuery),
//   };

//   const idCatalogoLocation = location.pathname.split('/').pop();
//   const idPaginaLocation = paramRoute.IDP;

//   useEffect(() => {
//     const { quantidade, materialEmpresa } = item || { quantidade: 0 };

//     const { ERP } = paramRoute;

//     const materialEmpresaURL = ERP
//       ? materialEmpresa.filter((e) => e.codimate === ERP)
//       : [];

//     if (materialEmpresa.length === 1 || materialEmpresaURL.length === 1) {
//       const selectedOption = {
//         value: (materialEmpresaURL[0] || materialEmpresa[0]).codimate,
//         label: `${(materialEmpresaURL[0] || materialEmpresa[0]).codimate} - ${
//           (materialEmpresaURL[0] || materialEmpresa[0]).descricao
//         }`,
//         color:
//           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
//             ? '#2c405a'
//             : '#de3b3b',
//         fontStyle:
//           (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
//             ? 'normal'
//             : 'italic',
//       };
//       formRef.current.setFieldValue('materialEmpresa', selectedOption);
//     }

//     if (qtdItemInic0()) {
//       formRef.current.setFieldValue('quantidade', 0);
//     } else {
//       formRef.current.setFieldValue('quantidade', quantidade);
//     }
//   }, [item, location.search]);

//   useEffect(() => {
//     const itensConjunto = item?.itensConjuntoModal || [];

//     setItensConjuntoSelecionados(
//       itensConjunto.map((conjuntoItem) => ({
//         ...conjuntoItem,
//         // checked: false,
//         checked: true,
//         quantidade:
//           qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
//             ? 0
//             : Number(conjuntoItem.quantidade || 1),
//       }))
//     );
//   }, [item]);

//   useEffect(() => {
//     async function fetchData() {
//       const responseMotivoFalha = await api
//         .get(`/empresa/${profile.idEmpresa}/itemos/motivofalha`)
//         .then((res) => res.data);
//       setMotivoFalha(responseMotivoFalha);

//       const responseAgenteCausa = await api
//         .get(`/empresa/${profile.idEmpresa}/itemos/agentecausa`)
//         .then((res) => res.data);
//       setAgenteCausa(responseAgenteCausa);

//       const responseSecaoTrab = await api
//         .get(`/empresa/${profile.idEmpresa}/itemos/secaotrab`)
//         .then((res) => res.data);
//       setSecaoTrab(responseSecaoTrab);

//       const responseSistema = await api
//         .get(
//           `/empresa/${profile.idEmpresa}/itemos/sistema/${Number(
//             idCatalogoLocation
//           )}/pagina/${Number(idPaginaLocation)}`,
//           {
//             params: {
//               local: localSelecionado ? Number(localSelecionado.value) : null,
//             },
//           }
//         )
//         .then((res) => res.data);
//       setSistema(responseSistema);

//       const responseLocal = await api
//         .get(
//           `/empresa/${profile.idEmpresa}/itemos/local/${Number(
//             idCatalogoLocation
//           )}`,
//           {
//             params: {
//               sistema: sistemaSelecionado
//                 ? Number(sistemaSelecionado.value)
//                 : null,
//             },
//           }
//         )
//         .then((res) => res.data);
//       setLocal(responseLocal);
//     }

//     if (criaItemOSSisma()) {
//       fetchData();
//     } else {
//       setAgenteCausa([{ codiAgente: 0 }]);
//       setMotivoFalha([{ codiMofa: 0 }]);
//       setSecaoTrab([{ codiSetr: 0 }]);
//       setSistema([{ codiSist: 0 }]);
//       setLocal([{ codiLoca: 0 }]);
//     }
//   }, [
//     sistemaSelecionado,
//     localSelecionado,
//     idCatalogoLocation,
//     profile.idEmpresa,
//     idPaginaLocation,
//   ]);

//   const handleRelacPagSistLoc = useCallback(async () => {
//     const relac = await api
//       .get(
//         `/empresa/${profile.idEmpresa}/catalogo/${idCatalogoLocation}/relacionamento-sistema-local/${idPaginaLocation}`
//       )
//       .then((res) => {
//         const { relacPaginaSistLoc } =
//           res.data.relacPaginaSistLoc.length > 0 && res.data;

//         const fmtRelacPaginaSistLoc =
//           relacPaginaSistLoc && relacPaginaSistLoc.pop();

//         const output = fmtRelacPaginaSistLoc
//           ? {
//               composicaoEnabled: true,
//               label: `${fmtRelacPaginaSistLoc.sistema?.codiSist} - ${fmtRelacPaginaSistLoc.sistema?.descricao}`,
//               value: fmtRelacPaginaSistLoc.sistema?.codiSist,
//             }
//           : null;

//         return output;
//       });

//     return relac;
//   }, [
//     idCatalogoLocation,
//     idPaginaLocation,
//     profile.idEmpresa,
//     location.search,
//   ]);

//   useEffect(() => {
//     async function loadDefaultSistema() {
//       const defaultValue = await handleRelacPagSistLoc();
//       setSistemaSelecionado(defaultValue);
//     }
//     if (criaItemOSSisma()) loadDefaultSistema();
//   }, [handleRelacPagSistLoc, location.search]);

//   // useEffect(() => {
//   //   const { ERP } = paramRoute;

//   //   if (ERP) {
//   //     paramQuery.delete('ERP');
//   //     history.replace({
//   //       pathname: location.pathname,
//   //       search: `?${paramQuery.toString()}`,
//   //     });
//   //   }
//   // }, [location.search, location.pathname]);

//   /**
//    * Não limpamos o ERP ao montar o modal.
//    * O ERP precisa permanecer na URL até o ItemCart preencher o material correto.
//    * A limpeza dos parâmetros temporários da busca (IDI/ERP) é feita no fechamento
//    * do modal pelo componente da página.
//    */

//   // const montarItensCarrinho = useCallback(
//   //   ({
//   //     itemPrincipal,
//   //     quantidadePrincipal,
//   //     materialEmpresaPrincipal,
//   //     imagemCatalogoPrincipal,
//   //     itemOS,
//   //     codiAgente,
//   //     codiMofa,
//   //     codiSetr,
//   //     codiSist,
//   //     codiLoca,
//   //   }) => {
//   //     const itensSelecionadosConjunto = itensConjuntoSelecionados
//   //       .filter((conjuntoItem) => conjuntoItem.checked)
//   //       .map((conjuntoItem) => ({
//   //         idCatalogo: conjuntoItem.idCatalogo,
//   //         idPagina: conjuntoItem.idPagina,
//   //         idItem: conjuntoItem.idItem,
//   //         idMaterial: conjuntoItem.idMaterial,
//   //         quantidade: Number(conjuntoItem.quantidade || 1),
//   //         materialEmpresa:
//   //           conjuntoItem.materialEmpresa?.length === 1
//   //             ? conjuntoItem.materialEmpresa[0].codimate
//   //             : null,
//   //         imagemCatalogo:
//   //           conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
//   //         itemOS,
//   //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
//   //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
//   //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
//   //         codiSist: criaItemOSSisma() ? codiSist : 0,
//   //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
//   //       }));

//   //     const itemPrincipalFormatado = {
//   //       idCatalogo: itemPrincipal.idCatalogo,
//   //       idPagina: itemPrincipal.idPagina,
//   //       idItem: itemPrincipal.idItem,
//   //       idMaterial: itemPrincipal.idMaterial,
//   //       quantidade: Number(quantidadePrincipal),
//   //       materialEmpresa: materialEmpresaPrincipal,
//   //       imagemCatalogo: imagemCatalogoPrincipal,
//   //       itemOS,
//   //       codiAgente: criaItemOSSisma() ? codiAgente : 0,
//   //       codiMofa: criaItemOSSisma() ? codiMofa : 0,
//   //       codiSetr: criaItemOSSisma() ? codiSetr : 0,
//   //       codiSist: criaItemOSSisma() ? codiSist : 0,
//   //       codiLoca: criaItemOSSisma() ? codiLoca : 0,
//   //     };

//   //     return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
//   //   },
//   //   [itensConjuntoSelecionados]
//   // );

//   const montarItensCarrinho = useCallback(
//     ({
//       itemPrincipal,
//       partnumber,
//       quantidadePrincipal,
//       materialEmpresaPrincipal,
//       imagemCatalogoPrincipal,
//       itemOS,
//       codiAgente,
//       codiMofa,
//       codiSetr,
//       codiSist,
//       codiLoca,
//     }) => {
//       const itensSelecionadosConjunto = itensConjuntoSelecionados
//         .filter((conjuntoItem) => conjuntoItem.checked)
//         .map((conjuntoItem) => ({
//           idCatalogo: conjuntoItem.idCatalogo,
//           idPagina: conjuntoItem.idPagina,
//           idItem: conjuntoItem.idItem,
//           idMaterial: conjuntoItem.idMaterial,
//           partnumber: conjuntoItem.partnumber,
//           quantidade: Number(conjuntoItem.quantidade || 1),
//           codimate:
//             conjuntoItem.materialEmpresa?.length === 1
//               ? conjuntoItem.materialEmpresa[0].codimate
//               : null,
//           imagemCatalogo:
//             conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
//           itemOS,
//           codiAgente: criaItemOSSisma() ? codiAgente : 0,
//           codiMofa: criaItemOSSisma() ? codiMofa : 0,
//           codiSetr: criaItemOSSisma() ? codiSetr : 0,
//           codiSist: criaItemOSSisma() ? codiSist : 0,
//           codiLoca: criaItemOSSisma() ? codiLoca : 0,
//         }));

//       const itemPrincipalFormatado = {
//         idCatalogo: itemPrincipal.idCatalogo,
//         idPagina: itemPrincipal.idPagina,
//         idItem: itemPrincipal.idItem,
//         idMaterial: itemPrincipal.idMaterial,
//         partnumber: partnumber || itemPrincipal.partnumber,
//         quantidade: Number(quantidadePrincipal),
//         codimate: materialEmpresaPrincipal,
//         imagemCatalogo: imagemCatalogoPrincipal,
//         itemOS,
//         codiAgente: criaItemOSSisma() ? codiAgente : 0,
//         codiMofa: criaItemOSSisma() ? codiMofa : 0,
//         codiSetr: criaItemOSSisma() ? codiSetr : 0,
//         codiSist: criaItemOSSisma() ? codiSist : 0,
//         codiLoca: criaItemOSSisma() ? codiLoca : 0,
//       };

//       return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
//     },
//     [itensConjuntoSelecionados]
//   );

//   const handleConfirmar = useCallback(
//     async (data) => {
//       try {
//         if (item.materialEmpresa.length > 0) {
//           const schema = Yup.object().shape({
//             materialEmpresa: Yup.string().required('Selecione um material'),
//           });

//           await schema.validate(data, { abortEarly: false });
//         }

//         const {
//           idCatalogo,
//           idPagina,
//           idItem,
//           idMaterial,
//           imagemCatalogo,
//         } = item;

//         const { quantidade, materialEmpresa, itemOS } = data;

//         if (limiteItemQtdZero().active) {
//           if (
//             Number(item.quantidade) === 0 &&
//             Number(quantidade) > Number(limiteItemQtdZero().value)
//           ) {
//             window.confirm(
//               `A quantidade não pode ser maior que ${
//                 limiteItemQtdZero().value
//               } para itens que o catálogo indique a quantidade 0`
//             );
//             return;
//           }
//         }

//         if (limitaQtdMax().active && !limitaQtdMin().active) {
//           if (Number(limitaQtdMax().value) === 1) {
//             if (Number(quantidade) > Number(item.quantidade)) {
//               window.confirm(
//                 'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
//               );
//               return;
//             }
//           }
//           if (Number(limitaQtdMax().value) === 2) {
//             if (Number(quantidade) > Number(item.quantidade)) {
//               window.confirm(
//                 'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
//               );
//             }
//           }
//         }

//         if (limitaQtdMin().active && !limitaQtdMax().active) {
//           if (Number(limitaQtdMin().value) === 1) {
//             if (Number(quantidade) < Number(item.quantidade)) {
//               window.confirm(
//                 'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
//               );
//               return;
//             }
//           }
//           if (Number(limitaQtdMin().value) === 2) {
//             if (Number(quantidade) < Number(item.quantidade)) {
//               window.confirm(
//                 'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
//               );
//             }
//           }
//         }

//         if (limitaQtdMin().active && limitaQtdMax().active) {
//           if (
//             Number(limitaQtdMax().value) === 1 &&
//             Number(limitaQtdMin().value) === 1
//           ) {
//             if (Number(quantidade) !== Number(item.quantidade)) {
//               window.confirm(
//                 'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
//               );
//               return;
//             }
//           }
//           if (
//             Number(limitaQtdMax().value) === 2 &&
//             Number(limitaQtdMin().value) === 2
//           ) {
//             if (Number(quantidade) !== Number(item.quantidade)) {
//               window.confirm(
//                 'A quantidade esta diferente da estabelecida no catálogo'
//               );
//             }
//           }
//         }

//         const objAgenteCausa = agenteCausa[agenteCausa.length - 1] || {};
//         const objMotivoFalha = motivoFalha[motivoFalha.length - 1] || {};
//         const objSecaoTrab = secaoTrab[secaoTrab.length - 1] || {};

//         const { codiAgente = 0 } = objAgenteCausa;
//         const { codiMofa = 0 } = objMotivoFalha;
//         const { codiSetr = 0 } = objSecaoTrab;

//         const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
//         const codiLoca = localSelecionado ? localSelecionado.value : 0;

//         console.log(partnumberSelecionado);
//         console.log(item);

//         const partnumber =
//           partnumberSelecionado !== null
//             ? partnumberSelecionado.value
//             : item.partnumber;

//         //* ********************************************************* */

//         // dispatch(
//         //   adicionaCarrinhoRequest(
//         //     idCatalogo,
//         //     idPagina,
//         //     idItem,
//         //     idMaterial,
//         //     Number(quantidade),
//         //     materialEmpresa,
//         //     imagemCatalogo,
//         //     itemOS,
//         //     criaItemOSSisma() ? codiAgente : 0,
//         //     criaItemOSSisma() ? codiMofa : 0,
//         //     criaItemOSSisma() ? codiSetr : 0,
//         //     criaItemOSSisma() ? codiSist : 0,
//         //     criaItemOSSisma() ? codiLoca : 0
//         //   )
//         // );

//         // itensConjuntoSelecionados
//         //   .filter((conjuntoItem) => conjuntoItem.checked)
//         //   .forEach((conjuntoItem) => {
//         //     dispatch(
//         //       adicionaCarrinhoRequest(
//         //         conjuntoItem.idCatalogo,
//         //         conjuntoItem.idPagina,
//         //         conjuntoItem.idItem,
//         //         conjuntoItem.idMaterial,
//         //         Number(conjuntoItem.quantidade || 1),
//         //         conjuntoItem.materialEmpresa?.length === 1
//         //           ? conjuntoItem.materialEmpresa[0].codimate
//         //           : null,
//         //         conjuntoItem.imagemCatalogo || imagemCatalogo,
//         //         itemOS,
//         //         criaItemOSSisma() ? codiAgente : 0,
//         //         criaItemOSSisma() ? codiMofa : 0,
//         //         criaItemOSSisma() ? codiSetr : 0,
//         //         criaItemOSSisma() ? codiSist : 0,
//         //         criaItemOSSisma() ? codiLoca : 0
//         //       )
//         //     );
//         //   });

//         //* ********************************************************* */

//         // const itensParaAdicionar = montarItensCarrinho({
//         //   itemPrincipal: item,
//         //   quantidadePrincipal: quantidade,
//         //   materialEmpresaPrincipal: materialEmpresa,
//         //   imagemCatalogoPrincipal: imagemCatalogo,
//         //   itemOS,
//         //   codiAgente,
//         //   codiMofa,
//         //   codiSetr,
//         //   codiSist,
//         //   codiLoca,
//         // });

//         // dispatch(adicionaCarrinhoRequest(itensParaAdicionar));

//         //* ********************************************************* */

//         const itensParaAdicionar = montarItensCarrinho({
//           itemPrincipal: item,
//           partnumber,
//           quantidadePrincipal: quantidade,
//           materialEmpresaPrincipal: materialEmpresa,
//           imagemCatalogoPrincipal: imagemCatalogo,
//           itemOS,
//           codiAgente,
//           codiMofa,
//           codiSetr,
//           codiSist,
//           codiLoca,
//         });

//         if (itensParaAdicionar.length === 1) {
//           const itemUnico = itensParaAdicionar[0];

//           dispatch(
//             adicionaCarrinhoRequest(
//               itemUnico.idCatalogo,
//               itemUnico.idPagina,
//               itemUnico.idItem,
//               itemUnico.idMaterial,
//               itemUnico.partnumber,
//               itemUnico.quantidade,
//               itemUnico.codimate,
//               itemUnico.imagemCatalogo,
//               itemUnico.itemOS,
//               itemUnico.codiAgente,
//               itemUnico.codiMofa,
//               itemUnico.codiSetr,
//               itemUnico.codiSist,
//               itemUnico.codiLoca
//             )
//           );
//         } else {
//           dispatch(
//             adicionaCarrinhoArrayRequest(
//               itensParaAdicionar[0].idCatalogo,
//               itensParaAdicionar
//             )
//           );
//         }

//         onClose(data);
//       } catch (err) {
//         AppError(err, formRef);
//       }
//     },
//     [
//       item,
//       dispatch,
//       onClose,
//       sistemaSelecionado,
//       localSelecionado,
//       partnumberSelecionado,
//       agenteCausa,
//       motivoFalha,
//       secaoTrab,
//       itensConjuntoSelecionados,
//     ]
//   );

//   const handleAdicionar = useCallback(() => {
//     const quantidade = Number(formRef.current.getFieldValue('quantidade'));
//     formRef.current.setFieldValue('quantidade', quantidade + 1);
//   }, []);

//   const handleRemover = useCallback(() => {
//     const quantidade = Number(formRef.current.getFieldValue('quantidade'));

//     if (quantidade > 1) {
//       formRef.current.setFieldValue('quantidade', quantidade - 1);
//     }
//   }, []);

//   const handleMouseMove = useCallback(
//     (e) => {
//       const {
//         left: leftContainer,
//         top: topContainer,
//       } = containerRef.current.getBoundingClientRect();
//       const { width } = modalRef.current.getBoundingClientRect();

//       setLeft(e.pageX - leftContainer - width / 2);
//       setTop(e.pageY - topContainer - 5);

//       e.stopPropagation();
//       e.preventDefault();
//     },
//     [containerRef]
//   );

//   const handleMouseUp = useCallback(
//     (e) => {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);

//       e.stopPropagation();
//       e.preventDefault();
//     },
//     [handleMouseMove]
//   );

//   const handleMouseDown = useCallback(
//     (e) => {
//       document.addEventListener('mousemove', handleMouseMove);
//       document.addEventListener('mouseup', handleMouseUp);

//       e.stopPropagation();
//       e.preventDefault();
//     },
//     [handleMouseMove, handleMouseUp]
//   );

//   // const handleSelecionado = useCallback(
//   //   ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//   //     const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//   //     dispatch(
//   //       atualizaItemOSRequest(
//   //         idCatalogo,
//   //         idPagina,
//   //         idItem,
//   //         idMaterial,
//   //         value,
//   //         codimate
//   //       )
//   //     );
//   //   },
//   //   [dispatch]
//   // );

//   const handleSelecionado = useCallback(
//     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//       const codimate = Array.isArray(materialEmpresa)
//         ? materialEmpresa[0]?.codimate || null
//         : materialEmpresa?.codimate || null;

//       dispatch(
//         atualizaItemOSRequest(
//           idCatalogo,
//           idPagina,
//           idItem,
//           idMaterial,
//           value,
//           codimate
//         )
//       );
//     },
//     [dispatch]
//   );

//   useEffect(() => {
//     if (local.length === 1 && !localSelecionado) {
//       const selectedOption = {
//         value: local[0].codiLoca,
//         label: `${local[0].codiLoca} - ${local[0].descricao}`,
//         color: '#2c405a',
//       };
//       setLocalSelecionado(selectedOption);
//       formRef.current.setFieldValue('local', selectedOption);
//     }
//   }, [local, localSelecionado]);

//   const handleToggleItemConjunto = useCallback((idItem, idMaterial) => {
//     setItensConjuntoSelecionados((state) =>
//       state.map((conjuntoItem) =>
//         String(conjuntoItem.idItem) === String(idItem) &&
//         Number(conjuntoItem.idMaterial) === Number(idMaterial)
//           ? { ...conjuntoItem, checked: !conjuntoItem.checked }
//           : conjuntoItem
//       )
//     );
//   }, []);

//   const handleQuantidadeItemConjunto = useCallback(
//     (idItem, idMaterial, valor) => {
//       setItensConjuntoSelecionados((state) =>
//         state.map((conjuntoItem) => {
//           if (
//             String(conjuntoItem.idItem) !== String(idItem) ||
//             Number(conjuntoItem.idMaterial) !== Number(idMaterial)
//           ) {
//             return conjuntoItem;
//           }

//           const quantidadeNormalizada = Number(valor);

//           return {
//             ...conjuntoItem,
//             quantidade:
//               Number.isNaN(quantidadeNormalizada) || quantidadeNormalizada < 0
//                 ? 0
//                 : quantidadeNormalizada,
//           };
//         })
//       );
//     },
//     []
//   );

//   const handleToggleTodosItensConjunto = useCallback(() => {
//     setItensConjuntoSelecionados((state) => {
//       const todosMarcados =
//         state.length > 0 && state.every((conjuntoItem) => conjuntoItem.checked);

//       return state.map((conjuntoItem) => ({
//         ...conjuntoItem,
//         checked: !todosMarcados,
//       }));
//     });
//   }, []);

//   // useEffect(() => {
//   //   if (!utilizaConjunto()) return;

//   //   const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

//   //   if (!idItemReferencia) return;

//   //   if (String(item.idItem) === String(idItemReferencia)) return;

//   //   const input = itensPagina.find(
//   //     (i) => String(i.idItem) === String(idItemReferencia)
//   //   );

//   //   if (!input) return;

//   //   setItensConjuntoSelecionados((prev) => {
//   //     const listaSemItemClicado = prev.filter(
//   //       (i) => String(i.idItem) !== String(item.idItem)
//   //     );

//   //     const jaExiste = listaSemItemClicado.some(
//   //       (i) => String(i.idItem) === String(input.idItem)
//   //     );

//   //     if (jaExiste) return listaSemItemClicado;

//   //     return [
//   //       {
//   //         ...input,
//   //         checked: false,
//   //         quantidade:
//   //           qtdItemInic0() && Number(input.quantidade) !== 0
//   //             ? 0
//   //             : Number(input.quantidade || 1),
//   //       },
//   //       ...listaSemItemClicado,
//   //     ];
//   //   });
//   // }, [item, itensPagina]);

//   const normalizaQuantidadeConjunto = useCallback(
//     (conjuntoItem) =>
//       qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
//         ? 0
//         : Number(conjuntoItem.quantidade || 1),
//     []
//   );

//   const normalizaLevaItemOri = useCallback(
//     (valor) => valor === true || valor === 1 || valor === '1',
//     []
//   );

//   // useEffect(() => {
//   //   if (!item) {
//   //     setItensConjuntoSelecionados([]);
//   //     return;
//   //   }

//   //   const itemClicadoId = String(item.idItem);
//   //   const itemClicadoMaterial = Number(item.idMaterial);

//   //   let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
//   //     ...conjuntoItem,
//   //     checked: false,
//   //     quantidade: normalizaQuantidadeConjunto(conjuntoItem),
//   //   }));

//   //   listaConjunto = listaConjunto.filter(
//   //     (conjuntoItem) =>
//   //       !(
//   //         String(conjuntoItem.idItem) === itemClicadoId &&
//   //         Number(conjuntoItem.idMaterial) === itemClicadoMaterial
//   //       )
//   //   );

//   //   if (utilizaConjunto()) {
//   //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

//   //     // const deveLevarItemOrigem =
//   //     //   item?.conjuntoReferencia?.levaItemOri === true ||
//   //     //   item?.conjuntoReferencia?.levaItemOri === 1 ||
//   //     //   item?.conjuntoReferencia?.levaItemOri === '1';

//   //     const deveLevarItemOrigem = normalizaLevaItemOri(
//   //       item?.conjuntoReferencia?.levaItemOri
//   //     );

//   //     const itemClicadoEhReferencia =
//   //       idItemReferencia && String(idItemReferencia) === itemClicadoId;

//   //     if (deveLevarItemOrigem && idItemReferencia && !itemClicadoEhReferencia) {
//   //       const itemReferencia = itensPagina.find(
//   //         (i) => String(i.idItem) === String(idItemReferencia)
//   //       );

//   //       if (itemReferencia) {
//   //         const referenciaJaExiste = listaConjunto.some(
//   //           (conjuntoItem) =>
//   //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
//   //             Number(conjuntoItem.idMaterial) ===
//   //               Number(itemReferencia.idMaterial)
//   //         );

//   //         if (!referenciaJaExiste) {
//   //           listaConjunto = [
//   //             {
//   //               ...itemReferencia,
//   //               checked: false,
//   //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
//   //             },
//   //             ...listaConjunto,
//   //           ];
//   //         }
//   //       }
//   //     }
//   //   }

//   //   setItensConjuntoSelecionados(listaConjunto);
//   // }, [item, itensPagina, normalizaQuantidadeConjunto]);

//   useEffect(() => {
//     if (!item) {
//       setItensConjuntoSelecionados([]);
//       return;
//     }

//     const itemClicadoId = String(item.idItem);
//     const itemClicadoMaterial = Number(item.idMaterial);

//     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;
//     const idMaterialReferencia = item?.conjuntoReferencia?.idMaterialOri;

//     const deveLevarItemOrigem = normalizaLevaItemOri(
//       item?.conjuntoReferencia?.levaItemOri
//     );

//     const itemClicadoEhReferencia =
//       idItemReferencia &&
//       String(idItemReferencia) === itemClicadoId &&
//       Number(idMaterialReferencia) === itemClicadoMaterial;

//     /**
//      * REGRA NOVA:
//      * Se levaItemOri for false/0/'0' e o item clicado não for a origem,
//      * o modal deve exibir somente o item clicado.
//      */
//     if (
//       item.conjuntoReferencia &&
//       !deveLevarItemOrigem &&
//       !itemClicadoEhReferencia
//     ) {
//       setItensConjuntoSelecionados([]);
//       return;
//     }

//     let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
//       ...conjuntoItem,
//       checked: false,
//       quantidade: normalizaQuantidadeConjunto(conjuntoItem),
//     }));

//     listaConjunto = listaConjunto.filter(
//       (conjuntoItem) =>
//         !(
//           String(conjuntoItem.idItem) === itemClicadoId &&
//           Number(conjuntoItem.idMaterial) === itemClicadoMaterial
//         )
//     );

//     if (
//       utilizaConjunto() &&
//       deveLevarItemOrigem &&
//       idItemReferencia &&
//       !itemClicadoEhReferencia
//     ) {
//       const itemReferencia = itensPagina.find(
//         (i) =>
//           String(i.idItem) === String(idItemReferencia) &&
//           Number(i.idMaterial) === Number(idMaterialReferencia)
//       );

//       if (itemReferencia) {
//         const referenciaJaExiste = listaConjunto.some(
//           (conjuntoItem) =>
//             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
//             Number(conjuntoItem.idMaterial) ===
//               Number(itemReferencia.idMaterial)
//         );

//         if (!referenciaJaExiste) {
//           listaConjunto = [
//             {
//               ...itemReferencia,
//               checked: false,
//               quantidade: normalizaQuantidadeConjunto(itemReferencia),
//             },
//             ...listaConjunto,
//           ];
//         }
//       }
//     }

//     setItensConjuntoSelecionados(listaConjunto);
//   }, [item, itensPagina, normalizaQuantidadeConjunto, normalizaLevaItemOri]);

//   const todosItensConjuntoMarcados =
//     itensConjuntoSelecionados.length > 0 &&
//     itensConjuntoSelecionados.every((conjuntoItem) => conjuntoItem.checked);

//   const handleSolicitaAtualizacaoPN = useCallback(() => {
//     setNovoPartnumber('');
//     setModalUpdatePN(true);
//   }, []);

//   const handleConfirmUpdatePN = useCallback(async () => {
//     const partnumber = String(novoPartnumber || '').trim();

//     // console.log(profile);
//     // console.log(item);

//     const { idEmpresa } = profile;

//     if (!partnumber) {
//       toast.error('Informe o novo partnumber');
//       return;
//     }

//     await api.post(`empresa/${idEmpresa}/update-pn`, {
//       idMaterial: Number(item.idMaterial),
//       novoPartnumber: partnumber,
//     });

//     toast.success('Solicitação de atualização enviada com sucesso');
//     setModalUpdatePN(false);
//     setNovoPartnumber('');
//   }, [novoPartnumber]);

//   useEffect(() => {
//     const { idEmpresa } = profile;

//     api
//       .get(`empresa/${idEmpresa}/${item.idMaterial}/update-pn`)
//       .then((response) => setPartnumbersMaterial(response.data.updatePN));
//   }, [item]);

//   const handleListImages = useCallback(() => {
//     const { idEmpresa } = profile;
//     const { idCatalogo, idPagina, idItem, idMaterial } = item;

//     api
//       .get(
//         `/empresa/${idEmpresa}/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/material/${idMaterial}/imagens`
//       )
//       .then((response) => setListImg(response.data.imagens))
//       .catch(() => {
//         setListImg([]);
//         toast.error('Não foi possível carregar a imagem');
//       });
//   }, [item]);

//   useEffect(() => {
//     handleListImages();
//   }, [item]);

//   return (
//     <>
//       <CartModal ref={modalRef} top={top} left={left}>
//         <Content>
//           <Content.Move onMouseDown={handleMouseDown}>
//             <MdMoreHoriz size={24} />
//           </Content.Move>

//           <Content.BtnClose type="button" onClick={() => onClose()}>
//             <MdClose size={20} />
//           </Content.BtnClose>

//           <Content.Title>
//             {/**
//              *
//             <strong>
//               {item.descricao}
//               {item.partnumber === '8C0143' && (
//               {item.partnumber === 'AT458609' && ( // PRD 8C0143 QAS AT458609
//                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
//                 <ImagePreviewModal imagePaths={[mep001, mep002, mep003]} />
//               )}
//               {item.partnumber === '19M7865' && ( // PRD 5G0128 QAS 19M7865
//                 // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
//                 <ImagePreviewModal imagePaths={[mep004, mep005, mep006]} />
//               )}
//             </strong>
//              */}
//             <strong>
//               {item.descricao}

//               {listImg.length > 0 && (
//                 <ImagePreviewModal
//                   imagens={listImg}
//                   idEmpresa={profile.idEmpresa}
//                   idCatalogo={item.idCatalogo}
//                   idPagina={item.idPagina}
//                   idItem={item.idItem}
//                   idMaterial={item.idMaterial}
//                 />
//               )}
//             </strong>
//             <div
//               style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'flex-start',
//                 alignItems: 'center',
//                 width: '100%',
//               }}
//             >
//               <span>{item.partnumber}</span>
//               {solicitaAtualizacaoPartnumber() && (
//                 <Row>
//                   <ButtonUpdatePN
//                     type="button"
//                     onClick={handleSolicitaAtualizacaoPN}
//                   >
//                     <IoGitPullRequestSharp
//                       size={20}
//                       style={{ marginLeft: '5px' }}
//                     />
//                   </ButtonUpdatePN>
//                 </Row>
//               )}
//             </div>

//             {partnumbersMaterial && !permitePartnumberAnteriores() && (
//               <Content.Title.Hist>
//                 {partnumbersMaterial.map((pn, index) => {
//                   if (partnumbersMaterial.length === index + 1)
//                     return `${pn.partnumber}`;
//                   return `${pn.partnumber}; `;
//                 })}
//               </Content.Title.Hist>
//             )}

//             {item.especTecnica && (
//               <Content.Title.Espec>{item.especTecnica}</Content.Title.Espec>
//             )}

//             {(item.nota || item.especTecnica) && (
//               <Info.Root rightIcon="0" topIcon="0">
//                 {item.nota && (
//                   <div>
//                     <strong>Nota:</strong>
//                     <span>{item.nota}</span>
//                   </div>
//                 )}
//                 {item.especTecnica && (
//                   <div>
//                     <strong>Esp.Tec.:</strong>
//                     <span>{item.especTecnica}</span>
//                   </div>
//                 )}
//                 {item.materialEmpresa.map((material, index) => (
//                   <div key={index}>
//                     <strong>Material ERP:</strong>
//                     <ul>
//                       <li>{`${material.descricao || ' - '}`}</li>
//                       <li>{`Cod.Mat: ${material.codimate || ' -'} | UN: ${
//                         material.unidade || ' - '
//                       } | Paralelo: ${material.paralelo ? 'Sim' : 'Não'}`}</li>
//                     </ul>
//                   </div>
//                 ))}
//               </Info.Root>
//             )}
//           </Content.Title>

//           {/* {solicitaAtualizacaoPartnumber() && (
//             <Row>
//               <ButtonUpdatePN
//                 type="button"
//                 onClick={handleSolicitaAtualizacaoPN}
//               >
//                 <IoGitPullRequestSharp
//                   size={20}
//                   style={{ marginRight: '5px' }}
//                 />
//                 Solicitar Atualização de Partnumber
//               </ButtonUpdatePN>
//             </Row>
//           )} */}

//           <Row>
//             {podeCriarConjunto && (
//               <button
//                 type="button"
//                 onClick={() => setCriarConjuntoAberto(true)}
//                 style={{
//                   width: '100%',
//                   padding: '10px 16px',
//                   marginTop: '10px',
//                   borderRadius: 12,
//                   border: 'none',
//                   background: '#1e3a8a',
//                   color: '#fff',
//                   fontSize: 13,
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                 }}
//               >
//                 {CREATE_SET_KIT[idioma]}
//               </button>
//             )}
//           </Row>

//           <Content.Form>
//             {item && (
//               <Form id="formCart" ref={formRef} onSubmit={handleConfirmar}>
//                 <Column borderTop>
//                   {item.materialEmpresa.length > 0 && (
//                     <SelectInput
//                       id="materialEmpresa"
//                       name="materialEmpresa"
//                       label="Código ERP"
//                       isClearable
//                       options={item.materialEmpresa.map((material) => ({
//                         value: material.codimate,
//                         label: `${material.codimate} - ${material.descricao}`,
//                         color:
//                           material.paralelo === '0' ? '#2c405a' : '#de3b3b',
//                         fontStyle:
//                           material.paralelo === '0' ? 'normal' : 'italic',
//                       }))}
//                       styles={{
//                         option: (styles, { data }) => ({
//                           ...styles,
//                           color: data.color,
//                           fontStyle: data.fontStyle,
//                         }),
//                       }}
//                     />
//                   )}
//                   <Content.Form.Error>
//                     {item.materialEmpresa.length > 0
//                       ? NON_ORIGINAL_MATERIALS_WARNING[idioma]
//                       : NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
//                   </Content.Form.Error>
//                 </Column>

//                 {partnumbersMaterial && permitePartnumberAnteriores() && (
//                   <Column borderTop>
//                     {item.materialEmpresa.length > 0 && (
//                       <SelectInput
//                         id="partnumbersMaterial"
//                         name="partnumbersMaterial"
//                         label="Partnumber"
//                         isClearable
//                         isSearchable
//                         isDisabled={!partnumbersMaterial}
//                         value={partnumberSelecionado}
//                         placeholder="Selecione..."
//                         options={partnumbersMaterial.map((pn) => ({
//                           value: String(pn.partnumber),
//                           label: `${pn.partnumber}`,
//                         }))}
//                         styles={{
//                           option: (styles, { data }) => ({
//                             ...styles,
//                             color: data.color,
//                             fontStyle: data.fontStyle,
//                           }),
//                         }}
//                         onChange={(select) =>
//                           setPartnumberSelecionado(
//                             select
//                               ? {
//                                   label: String(select.label),
//                                   value: String(select.value),
//                                 }
//                               : null
//                           )
//                         }
//                       />
//                     )}
//                   </Column>
//                 )}

//                 {criaItemOSSisma() && (
//                   <>
//                     <WrapperItemOS>
//                       {(usaMotivoFalha() ||
//                         usaAgenteCausa() ||
//                         usaSecaoTrab()) && (
//                         <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
//                           <SubtitleItemOS>Criação Item OS</SubtitleItemOS>
//                         </Row>
//                       )}

//                       {(usaMotivoFalha() ||
//                         usaAgenteCausa() ||
//                         usaSecaoTrab()) && (
//                         <Row>
//                           {usaMotivoFalha() && (
//                             <SelectInput
//                               id="motivoFalha"
//                               name="motivoFalha"
//                               label="Motivo Falha"
//                               width={200}
//                               isSearchable
//                               placeholder="Selecione..."
//                               options={motivoFalha.map((m) => ({
//                                 value: m.codiMofa,
//                                 label: m.descricao,
//                               }))}
//                             />
//                           )}

//                           {usaAgenteCausa() && (
//                             <SelectInput
//                               id="agenteCausa"
//                               name="agenteCausa"
//                               label="Agente Causa"
//                               width={200}
//                               isSearchable
//                               placeholder="Selecione..."
//                               options={agenteCausa.map((a) => ({
//                                 value: a.codiAgente,
//                                 label: a.descricao,
//                               }))}
//                             />
//                           )}

//                           {usaSecaoTrab() && (
//                             <SelectInput
//                               id="secaoTrab"
//                               name="secaoTrab"
//                               label="Seção Trabalho"
//                               width={200}
//                               isSearchable
//                               placeholder="Selecione..."
//                               options={secaoTrab.map((s) => ({
//                                 value: s.codiSetr,
//                                 label: s.descrResum,
//                               }))}
//                             />
//                           )}
//                         </Row>
//                       )}

//                       <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
//                         <SubtitleItemOS>Composição</SubtitleItemOS>
//                       </Row>

//                       <Row>
//                         <SelectInput
//                           id="sistema"
//                           name="sistema"
//                           label="Sistema"
//                           width={300}
//                           isSearchable
//                           isDisabled={sistemaSelecionado}
//                           placeholder="Selecione..."
//                           value={sistemaSelecionado}
//                           options={sistema.map((s) => ({
//                             value: s.codiSist,
//                             label: `${s.codiSist} - ${s.descricao}`,
//                             composicaoEnabled: s.composicaoEnabled,
//                             color:
//                               s.composicaoEnabled === true
//                                 ? '#334155'
//                                 : '#64748b',
//                             fontWeight:
//                               s.composicaoEnabled === true
//                                 ? 'bolder'
//                                 : 'lighter',
//                           }))}
//                           styles={{
//                             option: (styles, { data }) => ({
//                               ...styles,
//                               backgroundColor: data.backgroundColor,
//                               color: data.color,
//                               fontWeight: data.fontWeight,
//                             }),
//                           }}
//                           onChange={(select) => {
//                             setSistemaSelecionado({
//                               composicaoEnabled: select.composicaoEnabled,
//                               label: select.label,
//                               value: select.value,
//                             });
//                           }}
//                         />

//                         <SelectInput
//                           id="local"
//                           name="local"
//                           label="Local"
//                           width={300}
//                           isSearchable
//                           isDisabled={!sistemaSelecionado}
//                           value={localSelecionado}
//                           placeholder="Selecione..."
//                           options={local.map((l) => ({
//                             value: l.codiLoca,
//                             label: `${l.codiLoca} - ${l.descricao}`,
//                             composicaoEnabled: l.composicaoEnabled,
//                             color:
//                               l.composicaoEnabled === true
//                                 ? '#334155'
//                                 : '#64748b',
//                             fontWeight:
//                               l.composicaoEnabled === true
//                                 ? 'bolder'
//                                 : 'lighter',
//                           }))}
//                           styles={{
//                             option: (styles, { data }) => ({
//                               ...styles,
//                               backgroundColor: data.backgroundColor,
//                               color: data.color,
//                               fontWeight: data.fontWeight,
//                             }),
//                           }}
//                           onChange={(select) =>
//                             setLocalSelecionado({
//                               composicaoEnabled: select.composicaoEnabled,
//                               label: select.label,
//                               value: select.value,
//                             })
//                           }
//                         />
//                       </Row>
//                     </WrapperItemOS>
//                   </>
//                 )}

//                 {itensOS.length > 0 && !criaItemOSSisma() && (
//                   <Row>
//                     <SelectInput
//                       id="itemOS"
//                       name="itemOS"
//                       label="Item O.S."
//                       width={335}
//                       isSearchable
//                       options={itensOS.map((i) => ({
//                         value: i.value,
//                         label: i.label,
//                       }))}
//                       defaultValue={{
//                         value: itensOS[0].value,
//                         label: itensOS[0].label,
//                       }}
//                       onChange={(select) =>
//                         handleSelecionado(
//                           select,
//                           item.idCatalogo,
//                           item.idPagina,
//                           item.idItem,
//                           item.idMaterial,
//                           item.materialEmpresa
//                         )
//                       }
//                     />
//                   </Row>
//                 )}

//                 <Row>
//                   <Content.Form.Quantity>
//                     <label htmlFor="quantidade">
//                       {HEADER_TABLE_ITENS_QTD[idioma]}
//                     </label>
//                     <div>
//                       <button type="button" onClick={handleRemover}>
//                         <MdChevronLeft size={25} />
//                       </button>

//                       <Input
//                         id="quantidade"
//                         name="quantidade"
//                         flexDirection="row"
//                         type="number"
//                         min="1"
//                         max="9999999.9999"
//                         width={80}
//                       />

//                       <button type="button" onClick={handleAdicionar}>
//                         <MdChevronRight size={25} />
//                       </button>
//                     </div>
//                   </Content.Form.Quantity>
//                 </Row>

//                 {/* {solicitaAtualizacaoPartnumber() && (
//                   <Row>
//                     <button
//                       type="button"
//                       onClick={handleSolicitaAtualizacaoPN}
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: '100%',
//                         padding: '10px',
//                         margin: '10px auto',
//                         border: 'none',
//                         background: '#64748b',
//                         color: '#f8fafc',
//                         borderRadius: '5px',
//                       }}
//                     >
//                       <IoGitPullRequestSharp
//                         size={20}
//                         style={{ marginRight: '5px' }}
//                       />
//                       Solicitar Atualização de Partnumber
//                     </button>
//                   </Row>
//                 )} */}

//                 {utilizaConjunto() && !!itensConjuntoSelecionados.length && (
//                   <Row style={{ marginTop: 16 }}>
//                     <div style={{ width: '100%' }}>
//                       <div
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           marginBottom: 10,
//                         }}
//                       >
//                         <label
//                           style={{
//                             display: 'block',
//                             fontWeight: 600,
//                             marginBottom: 0,
//                           }}
//                         >
//                           Kit sugerido
//                         </label>

//                         <button
//                           type="button"
//                           onClick={handleToggleTodosItensConjunto}
//                           style={{
//                             background: 'transparent',
//                             border: 'none',
//                             color: '#2563eb',
//                             cursor: 'pointer',
//                             fontWeight: 600,
//                             fontSize: 13,
//                             padding: 0,
//                           }}
//                         >
//                           {todosItensConjuntoMarcados
//                             ? CLEAR_ALL[idioma]
//                             : MARK_ALL[idioma]}
//                         </button>
//                       </div>

//                       <div
//                         style={{
//                           maxHeight: 240,
//                           overflowY: 'auto',
//                           border: '1px solid #dbe1e9',
//                           borderRadius: 8,
//                           padding: 10,
//                           background: '#fff',
//                         }}
//                       >
//                         {itensConjuntoSelecionados.map((conjuntoItem) => (
//                           <div
//                             key={`${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
//                             style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: 12,
//                               padding: '10px 0',
//                               borderBottom: '1px solid #eef2f7',
//                               opacity: conjuntoItem.checked ? 1 : 0.45,
//                               transition: 'opacity 0.2s ease',
//                             }}
//                           >
//                             <input
//                               type="checkbox"
//                               checked={conjuntoItem.checked}
//                               onChange={() =>
//                                 handleToggleItemConjunto(
//                                   conjuntoItem.idItem,
//                                   conjuntoItem.idMaterial
//                                 )
//                               }
//                             />

//                             <div style={{ flex: 1, minWidth: 0 }}>
//                               <div style={{ fontWeight: 600 }}>
//                                 {conjuntoItem.itemResum || conjuntoItem.idItem}{' '}
//                                 - {conjuntoItem.partnumber}
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: 13,
//                                   color: '#64748b',
//                                   marginTop: 2,
//                                 }}
//                               >
//                                 {conjuntoItem.descricao}
//                               </div>
//                             </div>

//                             <div
//                               style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: 8,
//                               }}
//                             >
//                               <label
//                                 htmlFor={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
//                                 style={{ fontSize: 13 }}
//                               >
//                                 Qtd.
//                               </label>

//                               <input
//                                 id={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
//                                 type="number"
//                                 min="0"
//                                 value={conjuntoItem.quantidade}
//                                 disabled={!conjuntoItem.checked}
//                                 onChange={(e) =>
//                                   handleQuantidadeItemConjunto(
//                                     conjuntoItem.idItem,
//                                     conjuntoItem.idMaterial,
//                                     e.target.value
//                                   )
//                                 }
//                                 style={{
//                                   width: 50,
//                                   height: 34,
//                                   border: '1px solid #cbd5e1',
//                                   borderRadius: 6,
//                                   padding: '0 8px',
//                                 }}
//                               />
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </Row>
//                 )}
//               </Form>
//             )}

//             <Content.BtnAddCart type="submit" form="formCart">
//               <MdShoppingCart size={20} /> {ADD_TO_CART[idioma]}
//             </Content.BtnAddCart>

//             {/* {podeCriarConjunto && (
//               <button
//                 type="button"
//                 onClick={() => setCriarConjuntoAberto(true)}
//                 style={{
//                   marginTop: 8,
//                   width: '100%',
//                   padding: '10px 16px',
//                   borderRadius: 6,
//                   border: 'none',
//                   background: '#1789dd',
//                   color: '#fff',
//                   fontSize: 13,
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                 }}
//               >
//                 {CREATE_SET_KIT[idioma]}
//               </button>
//             )} */}
//           </Content.Form>
//         </Content>

//         {criarConjuntoAberto && (
//           <ModalCriarConjunto
//             item={item}
//             itensPagina={itensPagina}
//             onClose={() => setCriarConjuntoAberto(false)}
//           />
//         )}
//       </CartModal>

//       {/* {modalUpdatePN && (
//         <CartModal>
//           <Content>
//             <Content.BtnClose
//               type="button"
//               onClick={() => setModalUpdatePN(false)}
//             >
//               <MdClose size={20} />
//             </Content.BtnClose>
//             <Content.Title>
//               <strong>Atualização de Partnumber</strong>
//             </Content.Title>
//             <WrapperUpdatePN>
//               <p>Partnumber Atual:</p>
//               <h4>{item.partnumber}</h4>
//               <p>Solicitar Atualização Para:</p>
//               <input placeholder="Novo Partnumber" />
//             </WrapperUpdatePN>
//           </Content>
//         </CartModal>
//       )} */}

//       {modalUpdatePN && (
//         <CartModal>
//           <Content>
//             <Content.BtnClose
//               type="button"
//               onClick={() => setModalUpdatePN(false)}
//             >
//               <MdClose size={20} />
//             </Content.BtnClose>

//             <Content.Title>
//               <strong>Atualização de Partnumber</strong>
//             </Content.Title>

//             <WrapperUpdatePN>
//               <div className="current-box">
//                 <span>Partnumber atual</span>
//                 <strong>{item.partnumber}</strong>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="new-partnumber">
//                   Solicitar atualização para
//                 </label>

//                 {/* <input
//                   id="new-partnumber"
//                   type="text"
//                   placeholder="Digite o novo partnumber"
//                 /> */}
//                 <input
//                   id="new-partnumber"
//                   type="text"
//                   placeholder="Digite o novo partnumber"
//                   value={novoPartnumber}
//                   onChange={(e) => setNovoPartnumber(e.target.value)}
//                 />
//               </div>

//               <div className="actions">
//                 <button
//                   type="button"
//                   className="cancel"
//                   onClick={() => setModalUpdatePN(false)}
//                 >
//                   Cancelar
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleConfirmUpdatePN(novoPartnumber)}
//                 >
//                   Solicitar atualização
//                 </button>
//               </div>
//             </WrapperUpdatePN>
//           </Content>
//         </CartModal>
//       )}
//     </>
//   );
// }

// export default ItemCart;

/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  MdShoppingCart,
  MdClose,
  MdChevronLeft,
  MdChevronRight,
  MdMoreHoriz,
  MdCheckCircle,
  MdOutlineError,
} from 'react-icons/md';
import { IoGitPullRequestSharp } from 'react-icons/io5';
import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

// import { Scope } from '@unform/core';
import { toast } from 'react-toastify';
// import history from '../../services/history';
import { AppError } from '../../errors/AppError';

import { Form, Row, Column } from '../Form';
import SelectInput from '../Form/Input/Select';
import Input from '../Form/Input';

import {
  adicionaCarrinhoArrayRequest,
  adicionaCarrinhoRequest,
  atualizaItemOSRequest,
} from '../../store/modules/cart/actions';

import { Info } from '../Info';

import {
  CartModal,
  Content,
  WrapperItemOS,
  SubtitleItemOS,
  WrapperUpdatePN,
  ButtonUpdatePN,
} from './styles';
// import InputViewer from '../Form/Input/Viewer';
// import { Table } from '../../pages/Home/Carrinho/styles';
import {
  bloqueiaPartnumberAnteriores,
  criaItemOSSisma,
  limitaQtdMax,
  limitaQtdMin,
  limiteItemQtdZero,
  permitePartnumberAnteriores,
  qtdItemInic0,
  removeERPHome,
  solicitaAtualizacaoPartnumber,
  usaAgenteCausa,
  usaMotivoFalha,
  usaSecaoTrab,
  utilizaConjunto,
} from '../../lib/paramUtils';
import api from '../../services/api';
import ImagePreviewModal from '../prototipoImagemPeca';
import ModalCriarConjunto from '../ModalCriarConjunto';
import {
  ADD_TO_CART,
  CLEAR_ALL,
  CREATE_SET_KIT,
  HEADER_TABLE_ITENS_QTD,
  MARK_ALL,
  NO_ERP_CODE_RELATED_TO_MATERIAL,
  NON_ORIGINAL_MATERIALS_WARNING,
  opIdiomaCatalogo,
} from '../../lib/idiomaAppOptions';
// import cdiNoPhotoAvailable from '../../assets/cdi-no-photo-available.png';
// import mep001 from '../../assets/mep/001.jpeg';
// import mep002 from '../../assets/mep/002.jpeg';
// import mep003 from '../../assets/mep/003.jpeg';
// import mep004 from '../../assets/mep/004.jpeg';
// import mep005 from '../../assets/mep/005.jpeg';
// import mep006 from '../../assets/mep/006.jpeg';

/** margem mínima entre o modal e as bordas da tela */
const MARGEM_TELA = 12;

// function ItemCart({ containerRef, item, onClose }) {
/**
 * containerRef permanece na assinatura por compatibilidade com as chamadas
 * existentes, mas não é mais usado para posicionar o modal: com o portal e
 * position: fixed a referência passou a ser a própria viewport.
 */
// eslint-disable-next-line no-unused-vars
function ItemCart({ containerRef, item, itensPagina, onClose }) {
  const modalRef = useRef();
  const formRef = useRef();

  const location = useLocation();
  const dispatch = useDispatch();

  /**
   * O modal é renderizado em um portal no document.body e usa
   * position: fixed. Assim fica disponível na tela inteira e não é
   * recortado pelo bloco da imagem (ZoomArea/Wrapper), que tem
   * overflow: hidden.
   *
   * ATENÇÃO: o nó do portal é criado de forma SÍNCRONA (inicializador do
   * useState) e não dentro de um useEffect. Criá-lo em efeito faria o
   * primeiro render retornar null, o formulário não seria montado e os
   * efeitos que usam formRef.current (quantidade, código ERP, local)
   * quebrariam com "Cannot read properties of undefined".
   */
  const [portalContainer] = useState(() => document.createElement('div'));

  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);

  /** evita o "salto" visual antes de medir e centralizar o modal */
  const [posicionado, setPosicionado] = useState(false);
  // const [move, setMove] = useState(false);

  const [motivoFalha, setMotivoFalha] = useState([]);
  const [agenteCausa, setAgenteCausa] = useState([]);
  const [secaoTrab, setSecaoTrab] = useState([]);
  const [sistema, setSistema] = useState([]);
  const [local, setLocal] = useState([]);

  const [sistemaSelecionado, setSistemaSelecionado] = useState(null);
  const [localSelecionado, setLocalSelecionado] = useState(null);

  const [partnumberSelecionado, setPartnumberSelecionado] = useState(null);

  const [itensConjuntoSelecionados, setItensConjuntoSelecionados] = useState(
    []
  );

  const [modalUpdatePN, setModalUpdatePN] = useState(false);
  const [novoPartnumber, setNovoPartnumber] = useState('');

  /** modal de criação de conjunto/kit (somente ADM = 4) */
  const [criarConjuntoAberto, setCriarConjuntoAberto] = useState(false);

  const [partnumbersMaterial, setPartnumbersMaterial] = useState([]);

  const [listImg, setListImg] = useState([]);

  //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
  const idiomaCatalogo = useSelector(
    (state) => state.param.idiomaCatalogo || null
  );

  const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

  const itensOS = useSelector((state) => {
    const { cart } = state;
    const {
      order: { extItemOS },
    } = cart || {};

    return extItemOS;
  });

  const profile = useSelector((state) => {
    const { userId, adm, empresa } = state.user.profile || {};
    const { idEmpresa } = empresa || {};

    return { userId, adm, idEmpresa };
  });

  /** ADM = 4 pode criar conjunto/kit pela Home */
  const podeCriarConjunto = String(profile.adm) === '2' && utilizaConjunto();

  /**
   * Parâmetro global 35 (REMOVE_ERP_HOME): oculta o Código ERP do material na
   * Home. Com o parâmetro ativo, a seleção de "Código ERP" e as informações de
   * material ERP não são exibidas e o material é resolvido automaticamente
   * (primeiro material relacionado ao item, quando existir).
   */
  const ocultaERPHome = removeERPHome();

  const paramQuery = new URLSearchParams(location.search);

  const paramRoute = {
    ...Object.fromEntries(paramQuery),
  };

  const idCatalogoLocation = location.pathname.split('/').pop();
  const idPaginaLocation = paramRoute.IDP;

  useEffect(() => {
    const { quantidade, materialEmpresa } = item || { quantidade: 0 };

    const { ERP } = paramRoute;

    const materialEmpresaURL = ERP
      ? materialEmpresa.filter((e) => e.codimate === ERP)
      : [];

    /** com o parâmetro 35 ativo o campo de Código ERP não é renderizado */
    if (
      !ocultaERPHome &&
      (materialEmpresa.length === 1 || materialEmpresaURL.length === 1)
    ) {
      const selectedOption = {
        value: (materialEmpresaURL[0] || materialEmpresa[0]).codimate,
        label: `${(materialEmpresaURL[0] || materialEmpresa[0]).codimate} - ${
          (materialEmpresaURL[0] || materialEmpresa[0]).descricao
        }`,
        color:
          (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
            ? '#2c405a'
            : '#de3b3b',
        fontStyle:
          (materialEmpresaURL[0] || materialEmpresa[0]).paralelo === '0'
            ? 'normal'
            : 'italic',
      };
      formRef.current.setFieldValue('materialEmpresa', selectedOption);
    }

    if (qtdItemInic0()) {
      formRef.current.setFieldValue('quantidade', 0);
    } else {
      formRef.current.setFieldValue('quantidade', quantidade);
    }
  }, [item, location.search]);

  useEffect(() => {
    const itensConjunto = item?.itensConjuntoModal || [];

    setItensConjuntoSelecionados(
      itensConjunto.map((conjuntoItem) => ({
        ...conjuntoItem,
        // checked: false,
        checked: true,
        quantidade:
          qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
            ? 0
            : Number(conjuntoItem.quantidade || 1),
      }))
    );
  }, [item]);

  useEffect(() => {
    async function fetchData() {
      const responseMotivoFalha = await api
        .get(`/empresa/${profile.idEmpresa}/itemos/motivofalha`)
        .then((res) => res.data);
      setMotivoFalha(responseMotivoFalha);

      const responseAgenteCausa = await api
        .get(`/empresa/${profile.idEmpresa}/itemos/agentecausa`)
        .then((res) => res.data);
      setAgenteCausa(responseAgenteCausa);

      const responseSecaoTrab = await api
        .get(`/empresa/${profile.idEmpresa}/itemos/secaotrab`)
        .then((res) => res.data);
      setSecaoTrab(responseSecaoTrab);

      const responseSistema = await api
        .get(
          `/empresa/${profile.idEmpresa}/itemos/sistema/${Number(
            idCatalogoLocation
          )}/pagina/${Number(idPaginaLocation)}`,
          {
            params: {
              local: localSelecionado ? Number(localSelecionado.value) : null,
            },
          }
        )
        .then((res) => res.data);
      setSistema(responseSistema);

      const responseLocal = await api
        .get(
          `/empresa/${profile.idEmpresa}/itemos/local/${Number(
            idCatalogoLocation
          )}`,
          {
            params: {
              sistema: sistemaSelecionado
                ? Number(sistemaSelecionado.value)
                : null,
            },
          }
        )
        .then((res) => res.data);
      setLocal(responseLocal);
    }

    if (criaItemOSSisma()) {
      fetchData();
    } else {
      setAgenteCausa([{ codiAgente: 0 }]);
      setMotivoFalha([{ codiMofa: 0 }]);
      setSecaoTrab([{ codiSetr: 0 }]);
      setSistema([{ codiSist: 0 }]);
      setLocal([{ codiLoca: 0 }]);
    }
  }, [
    sistemaSelecionado,
    localSelecionado,
    idCatalogoLocation,
    profile.idEmpresa,
    idPaginaLocation,
  ]);

  const handleRelacPagSistLoc = useCallback(async () => {
    const relac = await api
      .get(
        `/empresa/${profile.idEmpresa}/catalogo/${idCatalogoLocation}/relacionamento-sistema-local/${idPaginaLocation}`
      )
      .then((res) => {
        const { relacPaginaSistLoc } =
          res.data.relacPaginaSistLoc.length > 0 && res.data;

        const fmtRelacPaginaSistLoc =
          relacPaginaSistLoc && relacPaginaSistLoc.pop();

        const output = fmtRelacPaginaSistLoc
          ? {
              composicaoEnabled: true,
              label: `${fmtRelacPaginaSistLoc.sistema?.codiSist} - ${fmtRelacPaginaSistLoc.sistema?.descricao}`,
              value: fmtRelacPaginaSistLoc.sistema?.codiSist,
            }
          : null;

        return output;
      });

    return relac;
  }, [
    idCatalogoLocation,
    idPaginaLocation,
    profile.idEmpresa,
    location.search,
  ]);

  useEffect(() => {
    async function loadDefaultSistema() {
      const defaultValue = await handleRelacPagSistLoc();
      setSistemaSelecionado(defaultValue);
    }
    if (criaItemOSSisma()) loadDefaultSistema();
  }, [handleRelacPagSistLoc, location.search]);

  // useEffect(() => {
  //   const { ERP } = paramRoute;

  //   if (ERP) {
  //     paramQuery.delete('ERP');
  //     history.replace({
  //       pathname: location.pathname,
  //       search: `?${paramQuery.toString()}`,
  //     });
  //   }
  // }, [location.search, location.pathname]);

  /**
   * Não limpamos o ERP ao montar o modal.
   * O ERP precisa permanecer na URL até o ItemCart preencher o material correto.
   * A limpeza dos parâmetros temporários da busca (IDI/ERP) é feita no fechamento
   * do modal pelo componente da página.
   */

  // const montarItensCarrinho = useCallback(
  //   ({
  //     itemPrincipal,
  //     quantidadePrincipal,
  //     materialEmpresaPrincipal,
  //     imagemCatalogoPrincipal,
  //     itemOS,
  //     codiAgente,
  //     codiMofa,
  //     codiSetr,
  //     codiSist,
  //     codiLoca,
  //   }) => {
  //     const itensSelecionadosConjunto = itensConjuntoSelecionados
  //       .filter((conjuntoItem) => conjuntoItem.checked)
  //       .map((conjuntoItem) => ({
  //         idCatalogo: conjuntoItem.idCatalogo,
  //         idPagina: conjuntoItem.idPagina,
  //         idItem: conjuntoItem.idItem,
  //         idMaterial: conjuntoItem.idMaterial,
  //         quantidade: Number(conjuntoItem.quantidade || 1),
  //         materialEmpresa:
  //           conjuntoItem.materialEmpresa?.length === 1
  //             ? conjuntoItem.materialEmpresa[0].codimate
  //             : null,
  //         imagemCatalogo:
  //           conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
  //         itemOS,
  //         codiAgente: criaItemOSSisma() ? codiAgente : 0,
  //         codiMofa: criaItemOSSisma() ? codiMofa : 0,
  //         codiSetr: criaItemOSSisma() ? codiSetr : 0,
  //         codiSist: criaItemOSSisma() ? codiSist : 0,
  //         codiLoca: criaItemOSSisma() ? codiLoca : 0,
  //       }));

  //     const itemPrincipalFormatado = {
  //       idCatalogo: itemPrincipal.idCatalogo,
  //       idPagina: itemPrincipal.idPagina,
  //       idItem: itemPrincipal.idItem,
  //       idMaterial: itemPrincipal.idMaterial,
  //       quantidade: Number(quantidadePrincipal),
  //       materialEmpresa: materialEmpresaPrincipal,
  //       imagemCatalogo: imagemCatalogoPrincipal,
  //       itemOS,
  //       codiAgente: criaItemOSSisma() ? codiAgente : 0,
  //       codiMofa: criaItemOSSisma() ? codiMofa : 0,
  //       codiSetr: criaItemOSSisma() ? codiSetr : 0,
  //       codiSist: criaItemOSSisma() ? codiSist : 0,
  //       codiLoca: criaItemOSSisma() ? codiLoca : 0,
  //     };

  //     return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
  //   },
  //   [itensConjuntoSelecionados]
  // );

  const montarItensCarrinho = useCallback(
    ({
      itemPrincipal,
      partnumber,
      quantidadePrincipal,
      materialEmpresaPrincipal,
      imagemCatalogoPrincipal,
      itemOS,
      codiAgente,
      codiMofa,
      codiSetr,
      codiSist,
      codiLoca,
    }) => {
      const itensSelecionadosConjunto = itensConjuntoSelecionados
        .filter((conjuntoItem) => conjuntoItem.checked)
        .map((conjuntoItem) => ({
          idCatalogo: conjuntoItem.idCatalogo,
          idPagina: conjuntoItem.idPagina,
          idItem: conjuntoItem.idItem,
          idMaterial: conjuntoItem.idMaterial,
          partnumber: conjuntoItem.partnumber,
          quantidade: Number(conjuntoItem.quantidade || 1),
          codimate:
            conjuntoItem.materialEmpresa?.length === 1
              ? conjuntoItem.materialEmpresa[0].codimate
              : null,
          imagemCatalogo:
            conjuntoItem.imagemCatalogo || imagemCatalogoPrincipal,
          itemOS,
          codiAgente: criaItemOSSisma() ? codiAgente : 0,
          codiMofa: criaItemOSSisma() ? codiMofa : 0,
          codiSetr: criaItemOSSisma() ? codiSetr : 0,
          codiSist: criaItemOSSisma() ? codiSist : 0,
          codiLoca: criaItemOSSisma() ? codiLoca : 0,
        }));

      const itemPrincipalFormatado = {
        idCatalogo: itemPrincipal.idCatalogo,
        idPagina: itemPrincipal.idPagina,
        idItem: itemPrincipal.idItem,
        idMaterial: itemPrincipal.idMaterial,
        partnumber: partnumber || itemPrincipal.partnumber,
        quantidade: Number(quantidadePrincipal),
        codimate: materialEmpresaPrincipal,
        imagemCatalogo: imagemCatalogoPrincipal,
        itemOS,
        codiAgente: criaItemOSSisma() ? codiAgente : 0,
        codiMofa: criaItemOSSisma() ? codiMofa : 0,
        codiSetr: criaItemOSSisma() ? codiSetr : 0,
        codiSist: criaItemOSSisma() ? codiSist : 0,
        codiLoca: criaItemOSSisma() ? codiLoca : 0,
      };

      return [itemPrincipalFormatado, ...itensSelecionadosConjunto];
    },
    [itensConjuntoSelecionados]
  );

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        /**
         * Com o parâmetro 35 (REMOVE_ERP_HOME) ativo o campo de Código ERP não
         * é exibido, portanto não há seleção de material a validar.
         */
        if (item.materialEmpresa.length > 0 && !ocultaERPHome) {
          const schema = Yup.object().shape({
            materialEmpresa: Yup.string().required('Selecione um material'),
          });

          await schema.validate(data, { abortEarly: false });
        }

        const {
          idCatalogo,
          idPagina,
          idItem,
          idMaterial,
          imagemCatalogo,
        } = item;

        const { quantidade, materialEmpresa, itemOS } = data;

        /**
         * Parâmetro 35: sem o campo de Código ERP na tela, usa o material
         * relacionado ao item (o primeiro, quando houver mais de um).
         */
        const materialEmpresaSelecionado = ocultaERPHome
          ? (item.materialEmpresa || [])[0]?.codimate || null
          : materialEmpresa;

        if (limiteItemQtdZero().active) {
          if (
            Number(item.quantidade) === 0 &&
            Number(quantidade) > Number(limiteItemQtdZero().value)
          ) {
            window.confirm(
              `A quantidade não pode ser maior que ${
                limiteItemQtdZero().value
              } para itens que o catálogo indique a quantidade 0`
            );
            return;
          }
        }

        if (limitaQtdMax().active && !limitaQtdMin().active) {
          if (Number(limitaQtdMax().value) === 1) {
            if (Number(quantidade) > Number(item.quantidade)) {
              window.confirm(
                'Não é permitido adicionar uma quantidade maior do que a estabelecida pelo catálogo'
              );
              return;
            }
          }
          if (Number(limitaQtdMax().value) === 2) {
            if (Number(quantidade) > Number(item.quantidade)) {
              window.confirm(
                'Uma quantidade maior do que a estabelecida pelo catálogo esta sendo adicionada'
              );
            }
          }
        }

        if (limitaQtdMin().active && !limitaQtdMax().active) {
          if (Number(limitaQtdMin().value) === 1) {
            if (Number(quantidade) < Number(item.quantidade)) {
              window.confirm(
                'Não é permitido adicionar uma quantidade menor do que a estabelecida pelo catálogo'
              );
              return;
            }
          }
          if (Number(limitaQtdMin().value) === 2) {
            if (Number(quantidade) < Number(item.quantidade)) {
              window.confirm(
                'Uma quantidade menor do que a estabelecida pelo catálogo esta sendo adicionada'
              );
            }
          }
        }

        if (limitaQtdMin().active && limitaQtdMax().active) {
          if (
            Number(limitaQtdMax().value) === 1 &&
            Number(limitaQtdMin().value) === 1
          ) {
            if (Number(quantidade) !== Number(item.quantidade)) {
              window.confirm(
                'Somente a quantidade exata estabelecida pelo catálogo pode ser adicionada'
              );
              return;
            }
          }
          if (
            Number(limitaQtdMax().value) === 2 &&
            Number(limitaQtdMin().value) === 2
          ) {
            if (Number(quantidade) !== Number(item.quantidade)) {
              window.confirm(
                'A quantidade esta diferente da estabelecida no catálogo'
              );
            }
          }
        }

        const objAgenteCausa = agenteCausa[agenteCausa.length - 1] || {};
        const objMotivoFalha = motivoFalha[motivoFalha.length - 1] || {};
        const objSecaoTrab = secaoTrab[secaoTrab.length - 1] || {};

        const { codiAgente = 0 } = objAgenteCausa;
        const { codiMofa = 0 } = objMotivoFalha;
        const { codiSetr = 0 } = objSecaoTrab;

        const codiSist = sistemaSelecionado ? sistemaSelecionado.value : 0;
        const codiLoca = localSelecionado ? localSelecionado.value : 0;

        console.log(partnumberSelecionado);
        console.log(item);

        const partnumber =
          partnumberSelecionado !== null
            ? partnumberSelecionado.value
            : item.partnumber;

        //* ********************************************************* */

        // dispatch(
        //   adicionaCarrinhoRequest(
        //     idCatalogo,
        //     idPagina,
        //     idItem,
        //     idMaterial,
        //     Number(quantidade),
        //     materialEmpresa,
        //     imagemCatalogo,
        //     itemOS,
        //     criaItemOSSisma() ? codiAgente : 0,
        //     criaItemOSSisma() ? codiMofa : 0,
        //     criaItemOSSisma() ? codiSetr : 0,
        //     criaItemOSSisma() ? codiSist : 0,
        //     criaItemOSSisma() ? codiLoca : 0
        //   )
        // );

        // itensConjuntoSelecionados
        //   .filter((conjuntoItem) => conjuntoItem.checked)
        //   .forEach((conjuntoItem) => {
        //     dispatch(
        //       adicionaCarrinhoRequest(
        //         conjuntoItem.idCatalogo,
        //         conjuntoItem.idPagina,
        //         conjuntoItem.idItem,
        //         conjuntoItem.idMaterial,
        //         Number(conjuntoItem.quantidade || 1),
        //         conjuntoItem.materialEmpresa?.length === 1
        //           ? conjuntoItem.materialEmpresa[0].codimate
        //           : null,
        //         conjuntoItem.imagemCatalogo || imagemCatalogo,
        //         itemOS,
        //         criaItemOSSisma() ? codiAgente : 0,
        //         criaItemOSSisma() ? codiMofa : 0,
        //         criaItemOSSisma() ? codiSetr : 0,
        //         criaItemOSSisma() ? codiSist : 0,
        //         criaItemOSSisma() ? codiLoca : 0
        //       )
        //     );
        //   });

        //* ********************************************************* */

        // const itensParaAdicionar = montarItensCarrinho({
        //   itemPrincipal: item,
        //   quantidadePrincipal: quantidade,
        //   materialEmpresaPrincipal: materialEmpresa,
        //   imagemCatalogoPrincipal: imagemCatalogo,
        //   itemOS,
        //   codiAgente,
        //   codiMofa,
        //   codiSetr,
        //   codiSist,
        //   codiLoca,
        // });

        // dispatch(adicionaCarrinhoRequest(itensParaAdicionar));

        //* ********************************************************* */

        const itensParaAdicionar = montarItensCarrinho({
          itemPrincipal: item,
          partnumber,
          quantidadePrincipal: quantidade,
          materialEmpresaPrincipal: materialEmpresaSelecionado,
          imagemCatalogoPrincipal: imagemCatalogo,
          itemOS,
          codiAgente,
          codiMofa,
          codiSetr,
          codiSist,
          codiLoca,
        });

        if (itensParaAdicionar.length === 1) {
          const itemUnico = itensParaAdicionar[0];

          dispatch(
            adicionaCarrinhoRequest(
              itemUnico.idCatalogo,
              itemUnico.idPagina,
              itemUnico.idItem,
              itemUnico.idMaterial,
              itemUnico.partnumber,
              itemUnico.quantidade,
              itemUnico.codimate,
              itemUnico.imagemCatalogo,
              itemUnico.itemOS,
              itemUnico.codiAgente,
              itemUnico.codiMofa,
              itemUnico.codiSetr,
              itemUnico.codiSist,
              itemUnico.codiLoca
            )
          );
        } else {
          dispatch(
            adicionaCarrinhoArrayRequest(
              itensParaAdicionar[0].idCatalogo,
              itensParaAdicionar
            )
          );
        }

        onClose(data);
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [
      item,
      dispatch,
      onClose,
      sistemaSelecionado,
      localSelecionado,
      partnumberSelecionado,
      agenteCausa,
      motivoFalha,
      secaoTrab,
      itensConjuntoSelecionados,
      ocultaERPHome,
    ]
  );

  const handleAdicionar = useCallback(() => {
    const quantidade = Number(formRef.current.getFieldValue('quantidade'));
    formRef.current.setFieldValue('quantidade', quantidade + 1);
  }, []);

  const handleRemover = useCallback(() => {
    const quantidade = Number(formRef.current.getFieldValue('quantidade'));

    if (quantidade > 1) {
      formRef.current.setFieldValue('quantidade', quantidade - 1);
    }
  }, []);

  /**
   * Arraste em coordenadas da viewport (clientX/clientY), coerente com o
   * position: fixed do modal, e limitado à área visível para que ele nunca
   * seja arrastado para fora do alcance do usuário.
   *
   * Usa Pointer Events para funcionar com mouse e com toque (tablet) —
   * antes eram apenas eventos de mouse, que não disparam durante o
   * arraste por toque.
   */
  const handleMouseMove = useCallback((e) => {
    if (!modalRef.current) return;

    const { width, height } = modalRef.current.getBoundingClientRect();

    const maxLeft = Math.max(
      MARGEM_TELA,
      window.innerWidth - width - MARGEM_TELA
    );
    const maxTop = Math.max(
      MARGEM_TELA,
      window.innerHeight - height - MARGEM_TELA
    );

    setLeft(Math.min(Math.max(MARGEM_TELA, e.clientX - width / 2), maxLeft));
    setTop(Math.min(Math.max(MARGEM_TELA, e.clientY - 5), maxTop));

    e.stopPropagation();
    e.preventDefault();
  }, []);

  const handleMouseUp = useCallback(
    (e) => {
      document.removeEventListener('pointermove', handleMouseMove);
      document.removeEventListener('pointerup', handleMouseUp);
      document.removeEventListener('pointercancel', handleMouseUp);

      e.stopPropagation();
      e.preventDefault();
    },
    [handleMouseMove]
  );

  const handleMouseDown = useCallback(
    (e) => {
      document.addEventListener('pointermove', handleMouseMove);
      document.addEventListener('pointerup', handleMouseUp);
      document.addEventListener('pointercancel', handleMouseUp);

      e.stopPropagation();
      e.preventDefault();
    },
    [handleMouseMove, handleMouseUp]
  );

  /**
   * Anexa o nó do portal ao document.body e faz a limpeza ao desmontar.
   * Declarado ANTES do efeito de centralização para que o nó já esteja no
   * documento quando o modal for medido.
   */
  useEffect(() => {
    document.body.appendChild(portalContainer);

    return () => {
      document.removeEventListener('pointermove', handleMouseMove);
      document.removeEventListener('pointerup', handleMouseUp);
      document.removeEventListener('pointercancel', handleMouseUp);

      document.body.removeChild(portalContainer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Centraliza o modal na tela ao abrir. Depois disso a posição é do
   * usuário (arraste), por isso o efeito não observa o item selecionado.
   */
  useEffect(() => {
    if (!modalRef.current) return;

    const { width, height } = modalRef.current.getBoundingClientRect();

    setLeft(Math.max(MARGEM_TELA, Math.round((window.innerWidth - width) / 2)));
    setTop(
      Math.max(MARGEM_TELA, Math.round((window.innerHeight - height) / 2))
    );
    setPosicionado(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** mantém o modal dentro da tela ao redimensionar / rotacionar o tablet */
  useEffect(() => {
    const handleResize = () => {
      if (!modalRef.current) return;

      const { width, height } = modalRef.current.getBoundingClientRect();

      setLeft((state) =>
        Math.min(
          Math.max(MARGEM_TELA, state),
          Math.max(MARGEM_TELA, window.innerWidth - width - MARGEM_TELA)
        )
      );
      setTop((state) =>
        Math.min(
          Math.max(MARGEM_TELA, state),
          Math.max(MARGEM_TELA, window.innerHeight - height - MARGEM_TELA)
        )
      );
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // const handleSelecionado = useCallback(
  //   ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
  //     const codimate = materialEmpresa ? materialEmpresa.codimate : null;

  //     dispatch(
  //       atualizaItemOSRequest(
  //         idCatalogo,
  //         idPagina,
  //         idItem,
  //         idMaterial,
  //         value,
  //         codimate
  //       )
  //     );
  //   },
  //   [dispatch]
  // );

  const handleSelecionado = useCallback(
    ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
      const codimate = Array.isArray(materialEmpresa)
        ? materialEmpresa[0]?.codimate || null
        : materialEmpresa?.codimate || null;

      dispatch(
        atualizaItemOSRequest(
          idCatalogo,
          idPagina,
          idItem,
          idMaterial,
          value,
          codimate
        )
      );
    },
    [dispatch]
  );

  useEffect(() => {
    if (local.length === 1 && !localSelecionado) {
      const selectedOption = {
        value: local[0].codiLoca,
        label: `${local[0].codiLoca} - ${local[0].descricao}`,
        color: '#2c405a',
      };
      setLocalSelecionado(selectedOption);
      formRef.current.setFieldValue('local', selectedOption);
    }
  }, [local, localSelecionado]);

  const handleToggleItemConjunto = useCallback((idItem, idMaterial) => {
    setItensConjuntoSelecionados((state) =>
      state.map((conjuntoItem) =>
        String(conjuntoItem.idItem) === String(idItem) &&
        Number(conjuntoItem.idMaterial) === Number(idMaterial)
          ? { ...conjuntoItem, checked: !conjuntoItem.checked }
          : conjuntoItem
      )
    );
  }, []);

  const handleQuantidadeItemConjunto = useCallback(
    (idItem, idMaterial, valor) => {
      setItensConjuntoSelecionados((state) =>
        state.map((conjuntoItem) => {
          if (
            String(conjuntoItem.idItem) !== String(idItem) ||
            Number(conjuntoItem.idMaterial) !== Number(idMaterial)
          ) {
            return conjuntoItem;
          }

          const quantidadeNormalizada = Number(valor);

          return {
            ...conjuntoItem,
            quantidade:
              Number.isNaN(quantidadeNormalizada) || quantidadeNormalizada < 0
                ? 0
                : quantidadeNormalizada,
          };
        })
      );
    },
    []
  );

  const handleToggleTodosItensConjunto = useCallback(() => {
    setItensConjuntoSelecionados((state) => {
      const todosMarcados =
        state.length > 0 && state.every((conjuntoItem) => conjuntoItem.checked);

      return state.map((conjuntoItem) => ({
        ...conjuntoItem,
        checked: !todosMarcados,
      }));
    });
  }, []);

  // useEffect(() => {
  //   if (!utilizaConjunto()) return;

  //   const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

  //   if (!idItemReferencia) return;

  //   if (String(item.idItem) === String(idItemReferencia)) return;

  //   const input = itensPagina.find(
  //     (i) => String(i.idItem) === String(idItemReferencia)
  //   );

  //   if (!input) return;

  //   setItensConjuntoSelecionados((prev) => {
  //     const listaSemItemClicado = prev.filter(
  //       (i) => String(i.idItem) !== String(item.idItem)
  //     );

  //     const jaExiste = listaSemItemClicado.some(
  //       (i) => String(i.idItem) === String(input.idItem)
  //     );

  //     if (jaExiste) return listaSemItemClicado;

  //     return [
  //       {
  //         ...input,
  //         checked: false,
  //         quantidade:
  //           qtdItemInic0() && Number(input.quantidade) !== 0
  //             ? 0
  //             : Number(input.quantidade || 1),
  //       },
  //       ...listaSemItemClicado,
  //     ];
  //   });
  // }, [item, itensPagina]);

  const normalizaQuantidadeConjunto = useCallback(
    (conjuntoItem) =>
      qtdItemInic0() && Number(conjuntoItem.quantidade) !== 0
        ? 0
        : Number(conjuntoItem.quantidade || 1),
    []
  );

  const normalizaLevaItemOri = useCallback(
    (valor) => valor === true || valor === 1 || valor === '1',
    []
  );

  // useEffect(() => {
  //   if (!item) {
  //     setItensConjuntoSelecionados([]);
  //     return;
  //   }

  //   const itemClicadoId = String(item.idItem);
  //   const itemClicadoMaterial = Number(item.idMaterial);

  //   let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
  //     ...conjuntoItem,
  //     checked: false,
  //     quantidade: normalizaQuantidadeConjunto(conjuntoItem),
  //   }));

  //   listaConjunto = listaConjunto.filter(
  //     (conjuntoItem) =>
  //       !(
  //         String(conjuntoItem.idItem) === itemClicadoId &&
  //         Number(conjuntoItem.idMaterial) === itemClicadoMaterial
  //       )
  //   );

  //   if (utilizaConjunto()) {
  //     const idItemReferencia = item?.conjuntoReferencia?.idItemOri;

  //     // const deveLevarItemOrigem =
  //     //   item?.conjuntoReferencia?.levaItemOri === true ||
  //     //   item?.conjuntoReferencia?.levaItemOri === 1 ||
  //     //   item?.conjuntoReferencia?.levaItemOri === '1';

  //     const deveLevarItemOrigem = normalizaLevaItemOri(
  //       item?.conjuntoReferencia?.levaItemOri
  //     );

  //     const itemClicadoEhReferencia =
  //       idItemReferencia && String(idItemReferencia) === itemClicadoId;

  //     if (deveLevarItemOrigem && idItemReferencia && !itemClicadoEhReferencia) {
  //       const itemReferencia = itensPagina.find(
  //         (i) => String(i.idItem) === String(idItemReferencia)
  //       );

  //       if (itemReferencia) {
  //         const referenciaJaExiste = listaConjunto.some(
  //           (conjuntoItem) =>
  //             String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
  //             Number(conjuntoItem.idMaterial) ===
  //               Number(itemReferencia.idMaterial)
  //         );

  //         if (!referenciaJaExiste) {
  //           listaConjunto = [
  //             {
  //               ...itemReferencia,
  //               checked: false,
  //               quantidade: normalizaQuantidadeConjunto(itemReferencia),
  //             },
  //             ...listaConjunto,
  //           ];
  //         }
  //       }
  //     }
  //   }

  //   setItensConjuntoSelecionados(listaConjunto);
  // }, [item, itensPagina, normalizaQuantidadeConjunto]);

  useEffect(() => {
    if (!item) {
      setItensConjuntoSelecionados([]);
      return;
    }

    const itemClicadoId = String(item.idItem);
    const itemClicadoMaterial = Number(item.idMaterial);

    const idItemReferencia = item?.conjuntoReferencia?.idItemOri;
    const idMaterialReferencia = item?.conjuntoReferencia?.idMaterialOri;

    const deveLevarItemOrigem = normalizaLevaItemOri(
      item?.conjuntoReferencia?.levaItemOri
    );

    const itemClicadoEhReferencia =
      idItemReferencia &&
      String(idItemReferencia) === itemClicadoId &&
      Number(idMaterialReferencia) === itemClicadoMaterial;

    /**
     * REGRA NOVA:
     * Se levaItemOri for false/0/'0' e o item clicado não for a origem,
     * o modal deve exibir somente o item clicado.
     */
    if (
      item.conjuntoReferencia &&
      !deveLevarItemOrigem &&
      !itemClicadoEhReferencia
    ) {
      setItensConjuntoSelecionados([]);
      return;
    }

    let listaConjunto = (item.itensConjuntoModal || []).map((conjuntoItem) => ({
      ...conjuntoItem,
      checked: false,
      quantidade: normalizaQuantidadeConjunto(conjuntoItem),
    }));

    listaConjunto = listaConjunto.filter(
      (conjuntoItem) =>
        !(
          String(conjuntoItem.idItem) === itemClicadoId &&
          Number(conjuntoItem.idMaterial) === itemClicadoMaterial
        )
    );

    if (
      utilizaConjunto() &&
      deveLevarItemOrigem &&
      idItemReferencia &&
      !itemClicadoEhReferencia
    ) {
      const itemReferencia = itensPagina.find(
        (i) =>
          String(i.idItem) === String(idItemReferencia) &&
          Number(i.idMaterial) === Number(idMaterialReferencia)
      );

      if (itemReferencia) {
        const referenciaJaExiste = listaConjunto.some(
          (conjuntoItem) =>
            String(conjuntoItem.idItem) === String(itemReferencia.idItem) &&
            Number(conjuntoItem.idMaterial) ===
              Number(itemReferencia.idMaterial)
        );

        if (!referenciaJaExiste) {
          listaConjunto = [
            {
              ...itemReferencia,
              checked: false,
              quantidade: normalizaQuantidadeConjunto(itemReferencia),
            },
            ...listaConjunto,
          ];
        }
      }
    }

    setItensConjuntoSelecionados(listaConjunto);
  }, [item, itensPagina, normalizaQuantidadeConjunto, normalizaLevaItemOri]);

  const todosItensConjuntoMarcados =
    itensConjuntoSelecionados.length > 0 &&
    itensConjuntoSelecionados.every((conjuntoItem) => conjuntoItem.checked);

  const handleSolicitaAtualizacaoPN = useCallback(() => {
    setNovoPartnumber('');
    setModalUpdatePN(true);
  }, []);

  const handleConfirmUpdatePN = useCallback(async () => {
    const partnumber = String(novoPartnumber || '').trim();

    // console.log(profile);
    // console.log(item);

    const { idEmpresa } = profile;

    if (!partnumber) {
      toast.error('Informe o novo partnumber');
      return;
    }

    await api.post(`empresa/${idEmpresa}/update-pn`, {
      idMaterial: Number(item.idMaterial),
      novoPartnumber: partnumber,
    });

    toast.success('Solicitação de atualização enviada com sucesso');
    setModalUpdatePN(false);
    setNovoPartnumber('');
  }, [novoPartnumber]);

  useEffect(() => {
    const { idEmpresa } = profile;

    api
      .get(`empresa/${idEmpresa}/${item.idMaterial}/update-pn`)
      .then((response) => setPartnumbersMaterial(response.data.updatePN));
  }, [item]);

  /**
   * Imagens da peça.
   *
   * A consulta é feita SOMENTE pelo idMaterial: a foto pertence ao
   * material (MATERIAL_FABRICANTE) e a mesma peça aparece em catálogos
   * diferentes. Com catálogo/página/item na URL, a mesma peça mostrava
   * imagem em um catálogo e nada em outro, conforme onde o upload
   * tivesse sido feito.
   */
  const handleListImages = useCallback(() => {
    const { idEmpresa } = profile;
    const { idMaterial } = item;

    if (!idMaterial) {
      setListImg([]);
      return;
    }

    api
      .get(`/empresa/${idEmpresa}/material/${idMaterial}/imagens`)
      .then((response) => setListImg(response.data.imagens))
      .catch(() => {
        setListImg([]);
        toast.error('Não foi possível carregar a imagem');
      });
  }, [item]);

  useEffect(() => {
    handleListImages();
  }, [item]);

  return ReactDOM.createPortal(
    <>
      <CartModal
        ref={modalRef}
        top={top}
        left={left}
        posicionado={posicionado ? 1 : 0}
      >
        <Content>
          <Content.Move onPointerDown={handleMouseDown}>
            <MdMoreHoriz size={24} />
          </Content.Move>

          <Content.BtnClose type="button" onClick={() => onClose()}>
            <MdClose size={20} />
          </Content.BtnClose>

          <Content.Title>
            {/**
             * 
            <strong>
              {item.descricao}
              {item.partnumber === '8C0143' && ( 
              {item.partnumber === 'AT458609' && ( // PRD 8C0143 QAS AT458609
                // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
                <ImagePreviewModal imagePaths={[mep001, mep002, mep003]} />
              )}
              {item.partnumber === '19M7865' && ( // PRD 5G0128 QAS 19M7865
                // <ImagePreviewModal imagePath={cdiNoPhotoAvailable} />
                <ImagePreviewModal imagePaths={[mep004, mep005, mep006]} />
              )}
            </strong>
             */}
            <strong>
              {item.descricao}

              {/**
               * Só idEmpresa e idMaterial: a imagem é do material, não
               * do catálogo/página/item em que ele está listado.
               */}
              {listImg.length > 0 && (
                <ImagePreviewModal
                  imagens={listImg}
                  idEmpresa={profile.idEmpresa}
                  idMaterial={item.idMaterial}
                />
              )}
            </strong>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <span>{item.partnumber}</span>
              {solicitaAtualizacaoPartnumber() && (
                <Row>
                  <ButtonUpdatePN
                    type="button"
                    onClick={handleSolicitaAtualizacaoPN}
                  >
                    <IoGitPullRequestSharp
                      size={20}
                      style={{ marginLeft: '5px' }}
                    />
                  </ButtonUpdatePN>
                </Row>
              )}
            </div>

            {partnumbersMaterial && !permitePartnumberAnteriores() && (
              <Content.Title.Hist>
                {partnumbersMaterial.map((pn, index) => {
                  if (partnumbersMaterial.length === index + 1)
                    return `${pn.partnumber}`;
                  return `${pn.partnumber}; `;
                })}
              </Content.Title.Hist>
            )}

            {item.especTecnica && (
              <Content.Title.Espec>{item.especTecnica}</Content.Title.Espec>
            )}

            {(item.nota || item.especTecnica) && (
              <Info.Root rightIcon="0" topIcon="0">
                {item.nota && (
                  <div>
                    <strong>Nota:</strong>
                    <span>{item.nota}</span>
                  </div>
                )}
                {item.especTecnica && (
                  <div>
                    <strong>Esp.Tec.:</strong>
                    <span>{item.especTecnica}</span>
                  </div>
                )}
                {!ocultaERPHome &&
                  item.materialEmpresa.map((material, index) => (
                    <div key={index}>
                      <strong>Material ERP:</strong>
                      <ul>
                        <li>{`${material.descricao || ' - '}`}</li>
                        <li>{`Cod.Mat: ${material.codimate || ' -'} | UN: ${
                          material.unidade || ' - '
                        } | Paralelo: ${
                          material.paralelo ? 'Sim' : 'Não'
                        }`}</li>
                      </ul>
                    </div>
                  ))}
              </Info.Root>
            )}
          </Content.Title>

          {/* {solicitaAtualizacaoPartnumber() && (
            <Row>
              <ButtonUpdatePN
                type="button"
                onClick={handleSolicitaAtualizacaoPN}
              >
                <IoGitPullRequestSharp
                  size={20}
                  style={{ marginRight: '5px' }}
                />
                Solicitar Atualização de Partnumber
              </ButtonUpdatePN>
            </Row>
          )} */}

          <Row>
            {podeCriarConjunto && (
              <button
                type="button"
                onClick={() => setCriarConjuntoAberto(true)}
                style={{
                  width: '100%',
                  padding: '10px 16px',
                  marginTop: '10px',
                  borderRadius: 12,
                  border: 'none',
                  background: '#1e3a8a',
                  color: '#fff',
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {CREATE_SET_KIT[idioma]}
              </button>
            )}
          </Row>

          <Content.Form>
            {item && (
              <Form id="formCart" ref={formRef} onSubmit={handleConfirmar}>
                {!ocultaERPHome && (
                  <Column borderTop>
                    {item.materialEmpresa.length > 0 && (
                      <SelectInput
                        id="materialEmpresa"
                        name="materialEmpresa"
                        label="Código ERP"
                        isClearable
                        options={item.materialEmpresa.map((material) => ({
                          value: material.codimate,
                          label: `${material.codimate} - ${material.descricao}`,
                          color:
                            material.paralelo === '0' ? '#2c405a' : '#de3b3b',
                          fontStyle:
                            material.paralelo === '0' ? 'normal' : 'italic',
                        }))}
                        styles={{
                          option: (styles, { data }) => ({
                            ...styles,
                            color: data.color,
                            fontStyle: data.fontStyle,
                          }),
                        }}
                      />
                    )}
                    <Content.Form.Error>
                      {item.materialEmpresa.length > 0
                        ? NON_ORIGINAL_MATERIALS_WARNING[idioma]
                        : NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
                    </Content.Form.Error>
                  </Column>
                )}

                {partnumbersMaterial && permitePartnumberAnteriores() && (
                  <Column borderTop>
                    {item.materialEmpresa.length > 0 && (
                      <SelectInput
                        id="partnumbersMaterial"
                        name="partnumbersMaterial"
                        label="Partnumber"
                        isClearable
                        isSearchable
                        isDisabled={!partnumbersMaterial}
                        value={partnumberSelecionado}
                        placeholder="Selecione..."
                        options={partnumbersMaterial.map((pn) => ({
                          value: String(pn.partnumber),
                          label: `${pn.partnumber}`,
                        }))}
                        styles={{
                          option: (styles, { data }) => ({
                            ...styles,
                            color: data.color,
                            fontStyle: data.fontStyle,
                          }),
                        }}
                        onChange={(select) =>
                          setPartnumberSelecionado(
                            select
                              ? {
                                  label: String(select.label),
                                  value: String(select.value),
                                }
                              : null
                          )
                        }
                      />
                    )}
                  </Column>
                )}

                {criaItemOSSisma() && (
                  <>
                    <WrapperItemOS>
                      {(usaMotivoFalha() ||
                        usaAgenteCausa() ||
                        usaSecaoTrab()) && (
                        <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
                          <SubtitleItemOS>Criação Item OS</SubtitleItemOS>
                        </Row>
                      )}

                      {(usaMotivoFalha() ||
                        usaAgenteCausa() ||
                        usaSecaoTrab()) && (
                        <Row>
                          {usaMotivoFalha() && (
                            <SelectInput
                              id="motivoFalha"
                              name="motivoFalha"
                              label="Motivo Falha"
                              width={200}
                              isSearchable
                              placeholder="Selecione..."
                              options={motivoFalha.map((m) => ({
                                value: m.codiMofa,
                                label: m.descricao,
                              }))}
                            />
                          )}

                          {usaAgenteCausa() && (
                            <SelectInput
                              id="agenteCausa"
                              name="agenteCausa"
                              label="Agente Causa"
                              width={200}
                              isSearchable
                              placeholder="Selecione..."
                              options={agenteCausa.map((a) => ({
                                value: a.codiAgente,
                                label: a.descricao,
                              }))}
                            />
                          )}

                          {usaSecaoTrab() && (
                            <SelectInput
                              id="secaoTrab"
                              name="secaoTrab"
                              label="Seção Trabalho"
                              width={200}
                              isSearchable
                              placeholder="Selecione..."
                              options={secaoTrab.map((s) => ({
                                value: s.codiSetr,
                                label: s.descrResum,
                              }))}
                            />
                          )}
                        </Row>
                      )}

                      <Row style={{ borderBottom: '1px solid #dbe1e9' }}>
                        <SubtitleItemOS>Composição</SubtitleItemOS>
                      </Row>

                      <Row>
                        <SelectInput
                          id="sistema"
                          name="sistema"
                          label="Sistema"
                          width={300}
                          isSearchable
                          isDisabled={sistemaSelecionado}
                          placeholder="Selecione..."
                          value={sistemaSelecionado}
                          options={sistema.map((s) => ({
                            value: s.codiSist,
                            label: `${s.codiSist} - ${s.descricao}`,
                            composicaoEnabled: s.composicaoEnabled,
                            color:
                              s.composicaoEnabled === true
                                ? '#334155'
                                : '#64748b',
                            fontWeight:
                              s.composicaoEnabled === true
                                ? 'bolder'
                                : 'lighter',
                          }))}
                          styles={{
                            option: (styles, { data }) => ({
                              ...styles,
                              backgroundColor: data.backgroundColor,
                              color: data.color,
                              fontWeight: data.fontWeight,
                            }),
                          }}
                          onChange={(select) => {
                            setSistemaSelecionado({
                              composicaoEnabled: select.composicaoEnabled,
                              label: select.label,
                              value: select.value,
                            });
                          }}
                        />

                        <SelectInput
                          id="local"
                          name="local"
                          label="Local"
                          width={300}
                          isSearchable
                          isDisabled={!sistemaSelecionado}
                          value={localSelecionado}
                          placeholder="Selecione..."
                          options={local.map((l) => ({
                            value: l.codiLoca,
                            label: `${l.codiLoca} - ${l.descricao}`,
                            composicaoEnabled: l.composicaoEnabled,
                            color:
                              l.composicaoEnabled === true
                                ? '#334155'
                                : '#64748b',
                            fontWeight:
                              l.composicaoEnabled === true
                                ? 'bolder'
                                : 'lighter',
                          }))}
                          styles={{
                            option: (styles, { data }) => ({
                              ...styles,
                              backgroundColor: data.backgroundColor,
                              color: data.color,
                              fontWeight: data.fontWeight,
                            }),
                          }}
                          onChange={(select) =>
                            setLocalSelecionado({
                              composicaoEnabled: select.composicaoEnabled,
                              label: select.label,
                              value: select.value,
                            })
                          }
                        />
                      </Row>
                    </WrapperItemOS>
                  </>
                )}

                {itensOS.length > 0 && !criaItemOSSisma() && (
                  <Row>
                    <SelectInput
                      id="itemOS"
                      name="itemOS"
                      label="Item O.S."
                      width={335}
                      isSearchable
                      options={itensOS.map((i) => ({
                        value: i.value,
                        label: i.label,
                      }))}
                      defaultValue={{
                        value: itensOS[0].value,
                        label: itensOS[0].label,
                      }}
                      onChange={(select) =>
                        handleSelecionado(
                          select,
                          item.idCatalogo,
                          item.idPagina,
                          item.idItem,
                          item.idMaterial,
                          item.materialEmpresa
                        )
                      }
                    />
                  </Row>
                )}

                <Row>
                  <Content.Form.Quantity>
                    <label htmlFor="quantidade">
                      {HEADER_TABLE_ITENS_QTD[idioma]}
                    </label>
                    <div>
                      <button type="button" onClick={handleRemover}>
                        <MdChevronLeft size={25} />
                      </button>

                      <Input
                        id="quantidade"
                        name="quantidade"
                        flexDirection="row"
                        type="number"
                        min="1"
                        max="9999999.9999"
                        width={80}
                      />

                      <button type="button" onClick={handleAdicionar}>
                        <MdChevronRight size={25} />
                      </button>
                    </div>
                  </Content.Form.Quantity>
                </Row>

                {/* {solicitaAtualizacaoPartnumber() && (
                  <Row>
                    <button
                      type="button"
                      onClick={handleSolicitaAtualizacaoPN}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        padding: '10px',
                        margin: '10px auto',
                        border: 'none',
                        background: '#64748b',
                        color: '#f8fafc',
                        borderRadius: '5px',
                      }}
                    >
                      <IoGitPullRequestSharp
                        size={20}
                        style={{ marginRight: '5px' }}
                      />
                      Solicitar Atualização de Partnumber
                    </button>
                  </Row>
                )} */}

                {utilizaConjunto() && !!itensConjuntoSelecionados.length && (
                  <Row style={{ marginTop: 16 }}>
                    <div style={{ width: '100%' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: 10,
                        }}
                      >
                        <label
                          style={{
                            display: 'block',
                            fontWeight: 600,
                            marginBottom: 0,
                          }}
                        >
                          Kit sugerido
                        </label>

                        <button
                          type="button"
                          onClick={handleToggleTodosItensConjunto}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#2563eb',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: 13,
                            padding: 0,
                          }}
                        >
                          {todosItensConjuntoMarcados
                            ? CLEAR_ALL[idioma]
                            : MARK_ALL[idioma]}
                        </button>
                      </div>

                      <div
                        style={{
                          maxHeight: 240,
                          overflowY: 'auto',
                          border: '1px solid #dbe1e9',
                          borderRadius: 8,
                          padding: 10,
                          background: '#fff',
                        }}
                      >
                        {itensConjuntoSelecionados.map((conjuntoItem) => (
                          <div
                            key={`${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 12,
                              padding: '10px 0',
                              borderBottom: '1px solid #eef2f7',
                              opacity: conjuntoItem.checked ? 1 : 0.45,
                              transition: 'opacity 0.2s ease',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={conjuntoItem.checked}
                              onChange={() =>
                                handleToggleItemConjunto(
                                  conjuntoItem.idItem,
                                  conjuntoItem.idMaterial
                                )
                              }
                            />

                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontWeight: 600 }}>
                                {conjuntoItem.itemResum || conjuntoItem.idItem}{' '}
                                - {conjuntoItem.partnumber}
                              </div>
                              <div
                                style={{
                                  fontSize: 13,
                                  color: '#64748b',
                                  marginTop: 2,
                                }}
                              >
                                {conjuntoItem.descricao}
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                              }}
                            >
                              <label
                                htmlFor={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
                                style={{ fontSize: 13 }}
                              >
                                Qtd.
                              </label>

                              <input
                                id={`quantidade-conjunto-${conjuntoItem.idItem}-${conjuntoItem.idMaterial}`}
                                type="number"
                                min="0"
                                value={conjuntoItem.quantidade}
                                disabled={!conjuntoItem.checked}
                                onChange={(e) =>
                                  handleQuantidadeItemConjunto(
                                    conjuntoItem.idItem,
                                    conjuntoItem.idMaterial,
                                    e.target.value
                                  )
                                }
                                style={{
                                  width: 50,
                                  height: 34,
                                  border: '1px solid #cbd5e1',
                                  borderRadius: 6,
                                  padding: '0 8px',
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Row>
                )}
              </Form>
            )}

            <Content.BtnAddCart type="submit" form="formCart">
              <MdShoppingCart size={20} /> {ADD_TO_CART[idioma]}
            </Content.BtnAddCart>

            {/* {podeCriarConjunto && (
              <button
                type="button"
                onClick={() => setCriarConjuntoAberto(true)}
                style={{
                  marginTop: 8,
                  width: '100%',
                  padding: '10px 16px',
                  borderRadius: 6,
                  border: 'none',
                  background: '#1789dd',
                  color: '#fff',
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {CREATE_SET_KIT[idioma]}
              </button>
            )} */}
          </Content.Form>
        </Content>

        {criarConjuntoAberto && (
          <ModalCriarConjunto
            item={item}
            itensPagina={itensPagina}
            onClose={() => setCriarConjuntoAberto(false)}
          />
        )}
      </CartModal>

      {/* {modalUpdatePN && (
        <CartModal>
          <Content>
            <Content.BtnClose
              type="button"
              onClick={() => setModalUpdatePN(false)}
            >
              <MdClose size={20} />
            </Content.BtnClose>
            <Content.Title>
              <strong>Atualização de Partnumber</strong>
            </Content.Title>
            <WrapperUpdatePN>
              <p>Partnumber Atual:</p>
              <h4>{item.partnumber}</h4>
              <p>Solicitar Atualização Para:</p>
              <input placeholder="Novo Partnumber" />
            </WrapperUpdatePN>
          </Content>
        </CartModal>
      )} */}

      {modalUpdatePN && (
        <CartModal centered={1}>
          <Content>
            <Content.BtnClose
              type="button"
              onClick={() => setModalUpdatePN(false)}
            >
              <MdClose size={20} />
            </Content.BtnClose>

            <Content.Title>
              <strong>Atualização de Partnumber</strong>
            </Content.Title>

            <WrapperUpdatePN>
              <div className="current-box">
                <span>Partnumber atual</span>
                <strong>{item.partnumber}</strong>
              </div>

              <div className="form-group">
                <label htmlFor="new-partnumber">
                  Solicitar atualização para
                </label>

                {/* <input
                  id="new-partnumber"
                  type="text"
                  placeholder="Digite o novo partnumber"
                /> */}
                <input
                  id="new-partnumber"
                  type="text"
                  placeholder="Digite o novo partnumber"
                  value={novoPartnumber}
                  onChange={(e) => setNovoPartnumber(e.target.value)}
                />
              </div>

              <div className="actions">
                <button
                  type="button"
                  className="cancel"
                  onClick={() => setModalUpdatePN(false)}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  onClick={() => handleConfirmUpdatePN(novoPartnumber)}
                >
                  Solicitar atualização
                </button>
              </div>
            </WrapperUpdatePN>
          </Content>
        </CartModal>
      )}
    </>,
    portalContainer
  );
}

export default ItemCart;
